import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CrudService } from '../components/services/crud.service';
import { environment } from 'src/environments/environment';
import { async } from 'rxjs/internal/scheduler/async';
import Swal from 'sweetalert2';

import {Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ignoreElements } from 'rxjs/operators';
import { agganciaSentinellaAula } from './sentinella-aula';


declare var JitsiMeetExternalAPI: any;

@Component({
    selector: 'app-jitsi',
    templateUrl: './jitsi.component.html',
    styleUrls: ['./jitsi.component.css']
})
export class JitsiComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('idCorsistaMeet') idCorsistaMeet: ElementRef;

    domain: string;
    room: any;
    options: any;
    api: any;
    user: any;

    // For Custom Controls
    isAudioMuted = true;
    isVideoMuted = false;
    isVideoShared = false;
    isChat = false;
    isHandMuted = false;

    public idCorsista: string="";
    public nomeCognomeCorsista: string="";
    public emailCorsista: string="";
    public idCorsoSvolgimento: string="";

    // Codice del cliente, server Jitsi e nome dell'aula arrivano dai dati della
    // live (`arrayLive`, api/corso.php::get_ElencoAulaCorsoTag), passati dal
    // dettaglio corso. Prima si leggevano dai campi nascosti #tokenMeet,
    // #serverMeet, #nomeAula: #tokenMeet si riempiva solo all'arrivo di
    // get_DetailCorso, e chi cliccava «Entra in aula» prima finiva su
    // «dominio//aula», una stanza omonima ma vuota, senza il docente.
    @Input() public tokenMeet: string="";
    @Input() public serverMeet: string="";
    @Input() public nomeAula: string="";
    // Emesso quando mancano i dati per aprire l'aula: Jitsi non parte.
    @Output() aulaNonPronta = new EventEmitter<void>();

    public isJoined:boolean=false;
    public isKickoutFromRoom: boolean=false;

    public elementMeet: Element;
    public isLoaded: boolean=false;

    public userIDMeet: string="";
    public isOnlyMember: boolean=false;

    public setTimeoutHandle: any;
    public setTimeoutHandleAutomatic: any;
    // Ping di presenza di riserva (vedi startPresenzaPing)
    public presenzaPingTimeout: any = null;
    public presenzaPingInterval: any = null;
    public arrayDetail: any;

    public disabledVideocamera: string;
    public canShowExtraControls: string="";

    // Presenter Mode
    public presenterActive: boolean = false;
    public presenterTitolo: string = '';
    public presenterSlideIndex: number = 0;
    public presenterTotalSlides: number = 0;
    private presenterIframe: HTMLIFrameElement = null;
    private presenterPollingInterval: any = null;
    private presenterLastSlideIndex: number = -1;
    private presenterPaused: boolean = false;
    private presenterMuted: boolean = false;

    // Scheda Didattica Mode
    private schedaActive: boolean = false;
    private schedaPollingInterval: any = null;
    private scalettaActive: boolean = false;
    private scalettaPollingInterval: any = null;
    private scalettaCurrentSlide: number = 0;
    private scalettaSlides: any[] = [];

    // Caso Studio Mode
    private casoStudioActive: boolean = false;
    private casoStudioPollingInterval: any = null;
    private casoStudioCurrentSlide: number = 0;
    private casoStudioSlides: any[] = [];
    private casoStudioAudio: HTMLAudioElement = null;
    private casoStudioPaused: boolean = false;

    // Flashcard Live Mode
    private flashcardLiveActive: boolean = false;
    private flashcardPollingInterval: any = null;
    private flashcardData: any[] = [];
    private flashcardCurrentIdx: number = 0;
    private flashcardTitolo: string = '';

    private videoLiveActive: boolean = false;
    private videoPollingInterval: any = null;
    private videoLiveUrl: string = '';
    private videoLiveTitolo: string = '';

    // Presentazione Integrata Mode
    private presIntegrataActive: boolean = false;
    private presIntegrataPollingInterval: any = null;

    // Simulcast Multi-Aula
    public _isSimulcast: boolean = false;
    public _simulcastSubject: string = '';
    private _simulcastRedirecting: boolean = false;
    private _originalRoom: string = '';

    // Accesso Bloccato Polling
    private accessoPollingInterval: any = null;
    private presIntegrataPresId: string = '';
    private presIntegrataPresPartner: number = 0;
    private presIntegrataTitolo: string = '';
    private presIntegrataCurrentSlide: number = 0;
    private presIntegrataTotalSlides: number = 0;
    private presIntegrataPaused: boolean = false;
    private presIntegrataIframe: HTMLIFrameElement = null;

    constructor(
        private router: Router,
        private crudService: CrudService,
        private el: ElementRef,

        @Inject(DOCUMENT) private _document: HTMLDocument
    ) { }

    // Aula leggera: solo sui PC deboli (4 core o meno, oppure 4 GB o meno)
    // meno lavoro per il browser — niente livelli audio, 2 video ricevuti,
    // video a 180p. La camera parte spenta solo se il corsista ha il pulsante
    // per accenderla; con la videocamera bloccata ('0') si apre come sempre.
    // Lo sfondo sfocato dietro il video grande si spegne in interfaceConfigOverwrite.
    private pcDebole(): boolean {
        const n: any = window.navigator || {};
        return (n.hardwareConcurrency || 8) <= 4 || (n.deviceMemory || 8) <= 4;
    }

    private aulaLeggera(): any {
        if (!this.pcDebole()) return {};
        const leggera: any = {
            enableNoisyMicDetection: false,
            disableAudioLevels: true,
            channelLastN: 2,
            resolution: 180,
            constraints: { video: { height: { ideal: 180, max: 180, min: 180 } } }
        };
        if (this.disabledVideocamera != '0') leggera.startWithVideoMuted = true;
        return leggera;
    }

    ngOnInit(): void {
        // Barriera: senza codice del cliente, server o nome aula la stanza
        // sarebbe sbagliata. Non si crea JitsiMeetExternalAPI.
        this.tokenMeet = String(this.tokenMeet || '').trim();
        this.serverMeet = String(this.serverMeet || '').trim();
        this.nomeAula = String(this.nomeAula || '').trim();
        if (!this.tokenMeet || !this.serverMeet || !this.nomeAula) {
            console.error('[Jitsi] aula non aperta, dati mancanti', {
                tokenMeet: this.tokenMeet, serverMeet: this.serverMeet, nomeAula: this.nomeAula });
            this.aulaNonPronta.emit();
            return;
        }
        this.domain=this.serverMeet;

        var inputIdCorsista = document.getElementById('idCorsistaMeet') as HTMLInputElement;
        this.idCorsista=inputIdCorsista.value;

        var input = document.getElementById('nomeCognomeMeet') as HTMLInputElement;
        this.nomeCognomeCorsista=input.value;

        input = document.getElementById('emailCorsistaMeet') as HTMLInputElement;
        this.emailCorsista=input.value;

        var inputIdCorsoSvolgimento = document.getElementById('idCorsoSvolgimento') as HTMLInputElement;
        this.idCorsoSvolgimento=inputIdCorsoSvolgimento.value;

        input = document.getElementById('abilitaVideocamera') as HTMLInputElement;
        this.disabledVideocamera=input.value;

        input = document.getElementById('canShowExtraControls') as HTMLInputElement;
        this.canShowExtraControls=input.value;


        var inputCorsoHeader = document.getElementById('idCorsoHeader') as HTMLInputElement;
        var inputDurata = document.getElementById('durata') as HTMLInputElement;
        var inputLinkAula = document.getElementById('linkAula') as HTMLInputElement;
        var inputDataOra = document.getElementById('dataOra') as HTMLInputElement;
        var inputDataOraFull = document.getElementById('dataOraFineFull') as HTMLInputElement;

        this.arrayDetail={'idCorsista': inputIdCorsista.value,
                          'idCorsoSvolgimento': inputIdCorsoSvolgimento.value,
                          'idCorsoHeader': inputCorsoHeader.value,
                          'durata': inputDurata.value,
                          'nome_aula': this.nomeAula,
                          'link_aula': inputLinkAula.value,
                          'dataInizio': inputDataOra.value,
                          'dataFine': inputDataOraFull.value};

        //this.api.executeCommand('toggleLobby', true);

        // Fetch simulcast_room direttamente dal server (fresh, bypassa cache Angular)
        var simulcastRoomValue = '';
        try {
            var apiBase = window.location.protocol + '//' + window.location.hostname + '/api/corso.php';
            var xhr = new XMLHttpRequest();
            xhr.open('POST', apiBase, false); // sincrono
            var formBody = 'type=get_SimulcastRoom&idCorsoSvolgimento=' + encodeURIComponent(inputIdCorsoSvolgimento.value);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(formBody);
            if (xhr.status === 200) {
                var resp = JSON.parse(xhr.responseText);
                if (resp && resp.simulcast_room) {
                    simulcastRoomValue = resp.simulcast_room;
                }
            }
        } catch (e) { console.warn('[Simulcast] Fetch failed:', e); }
        this._originalRoom = this.nomeAula;
        this._isSimulcast = (simulcastRoomValue !== '');
        this.room = this._isSimulcast ? simulcastRoomValue : this.nomeAula;
        // Il subject mostra il nome aula reale ai corsisti (non il codice stanza simulcast)
        this._simulcastSubject = this._isSimulcast
            ? this.nomeAula + ' \u2014 Multi aule'
            : '';
        this.user = {
            name: this.nomeCognomeCorsista
        }

        this.elementMeet=document.querySelector('#jitsi-iframe');

        this.options = {
            roomName: this.room,
            lang: 'it',
            height: '100%',
            configOverwrite: {
                prejoinPageEnabled: false,
                startWithAudioMuted: true,
                disableDeepLinking: true,
                enableNoisyMicDetection: true,
                disableVideoQualityLabel: true,
                hideDisplayName: true,
                hideDominantSpeakerBadge: true,
                // Sicurezza: il corsista NON deve poter espellere, mutare o
                // togliere la videocamera ad altri partecipanti (ne' al docente).
                // Il primo entrante in Jitsi diventa moderator per default, quindi
                // in produzione il corsista si ritrovava di fatto poteri completi.
                // - `remoteVideoMenu.disabled: true` nasconde il menu 3-puntini
                //   sui tile REMOTI (voci "Espelli", "Metti in primo piano", ecc.).
                // - Jitsi NON ha una chiave singola per disabilitare il menu 3-puntini
                //   sul PROPRIO tile: le voci si tolgono una per una. Servono
                //   `disableLocalVideoFlip` (togli "Specchia") + `disableSelfViewSettings`
                //   (togli "Nascondi la tua immagine"). Il "Metti in primo piano" (pin)
                //   non ha un flag proprio — lo nascondiamo via CSS iniettato nell'iframe
                //   in `videoConferenceJoined` (vedi `hideLocalVideoMenuTrigger`).
                // - `disableRemoteMute: true` blocca il mute remoto anche lato
                //   backend, come "cintura e bretelle" nel caso la UI venisse
                //   comunque raggiunta via scorciatoie/estensioni.
                remoteVideoMenu: { disabled: true },
                disableLocalVideoFlip: true,
                disableSelfViewSettings: true,
                disableRemoteMute: true,
                // Sui server Jitsi tutti entrano come moderatori: senza queste due
                // righe anche il corsista vedeva la richiesta della sala d'attesa
                // («Vuole unirsi alla riunione – Ammetti / Chat / Respingi»).
                // Il corsista non vede nessun avviso di Jitsi; il docente
                // (meet-docente.php) continua a vederli.
                notifications: [],
                disableJoinLeaveSounds: true,
                ...this.aulaLeggera(),
            },
            interfaceConfigOverwrite: {
                APP_NAME: 'Discentya',
                SHOW_JITSI_WATERMARK: false,
                SHOW_BRAND_WATERMARK: false,
                SHOW_WATERMARK_FOR_GUESTS: false,
                DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
                TOOLBAR_ALWAYS_VISIBLE: false,
                //TOOLBAR_BUTTONS: ['microphone', 'camera', 'profile', 'settings', 'raisehand', 'videoquality', 'hangup'],
                TOOLBAR_BUTTONS: [''],
                DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                SHOW_CHROME_EXTENSION_BANNER: false,
                DEFAULT_LOCAL_DISPLAY_NAME: '',
                DEFAULT_REMOTE_DISPLAY_NAME: '',
                HIDE_INVITE_MORE_HEADER: true,
            },
            parentNode: this.elementMeet,
            userInfo: {
                displayName: this.user.name,
                email: this.emailCorsista
            }
        }
        if (this.pcDebole()) this.options.interfaceConfigOverwrite.DISABLE_VIDEO_BACKGROUND = true;


        //console.log(this.domain+this.tokenMeet+"/");
        this.api = new JitsiMeetExternalAPI(this.domain+this.tokenMeet+"/", this.options);
        this.agganciaSentinella();

        //this.api.executeCommand('hideNotification');
        //var eee = document.getElementById('notifications-container') as HTMLInputElement;
        //eee.remove();
    }

    // Flag di readiness del BridgeChannel Jitsi. Il DataChannel WebRTC richiede
    // SDP handshake completato + ICE connesso + bridgechannel WebSocket aperto
    // per accettare sendEndpointTextMessage. Prima non fallisce ma il messaggio
    // viene silently droppato. Pattern gia' usato nel docente (meet-docente.php).
    private _jitsiBridgeReady: boolean = false;

    /**
     * Broadcast affidabile a tutti i partecipanti (pattern jitsiSafeBroadcast).
     * 1) invio broadcast (destinatario vuoto) - copre i partecipanti gia' connessi;
     * 2) invio unicast per ogni participantId - copre i late-joiners e chi era in
     *    reconnect al momento del broadcast (i loro DataChannel non ricevono
     *    messaggi antecedenti alla connessione).
     * Gating su _jitsiBridgeReady evita di sparare messaggi persi durante il
     * setup iniziale (Jitsi accetta ma non instrada).
     */
    private jitsiSafeBroadcast(messageStr: string) {
        if (!this.api) return;
        if (!this._jitsiBridgeReady) {
            console.warn('[jitsi] bridge non pronto, broadcast ignorato:', messageStr);
            return;
        }
        try { this.api.executeCommand('sendEndpointTextMessage', '', messageStr); }
        catch (e) { console.warn('[jitsi] broadcast fail', e); this._jitsiBridgeReady = false; }

        // Retry unicast per ogni participantId. Copre i late-joiners.
        try {
            this.api.getRoomsInfo().then((roomsInfo: any) => {
                try {
                    const participants = (roomsInfo && roomsInfo.rooms && roomsInfo.rooms[0]
                                          && roomsInfo.rooms[0].participants) || [];
                    participants.forEach((p: any) => {
                        if (p && p.id) {
                            try { this.api.executeCommand('sendEndpointTextMessage', p.id, messageStr); }
                            catch (e) { /* individuo down, skip */ }
                        }
                    });
                } catch (e) { console.warn('[jitsi] unicast loop fail', e); }
            }).catch((e: any) => console.warn('[jitsi] getRoomsInfo fail', e));
        } catch (e) { console.warn('[jitsi] getRoomsInfo throw', e); }
    }

    buttaTuttiFuori() {
        // Manda un messaggio a tutti per dire di uscire.
        // Prima: sendEndpointTextMessage grezzo -> messaggi persi silently su
        // corsisti con DataChannel non pronto (join iniziale, reconnect, switch
        // simulcast, micro-disconnessioni). Ora usa jitsiSafeBroadcast con
        // guardia _jitsiBridgeReady + unicast per-partecipante.
        this.jitsiSafeBroadcast(JSON.stringify({ action: 'close-room' }));
        console.log('[jitsi] buttaTuttiFuori: close-room broadcast+unicast');
    }

    ngAfterViewInit(): void {
        if (!this.api) return; // barriera di ngOnInit: aula non aperta
        this.initEvents();
    }

    /**
     * Fallback CSS: nasconde il trigger 3-puntini del proprio tile Jitsi.
     * I flag `disableLocalVideoFlip`+`disableSelfViewSettings` tolgono 2 voci su 3
     * ma "Metti in primo piano" resta e il pulsante rimane visibile. Iniettiamo
     * un <style> nell'iframe che copre i selettori usati da Jitsi web nelle
     * ultime versioni (nomi diversi tra release). E' un no-op se l'iframe e'
     * cross-origin (contentDocument protetto): in quel caso il pulsante resta,
     * ma NON e' un vettore di attacco — il pin locale non muta ne' espelle
     * altri partecipanti, e il mute/kick e' gia' bloccato da
     * `remoteVideoMenu.disabled` + `disableRemoteMute`.
     */
    private hideLocalVideoMenuTrigger(): void {
        try {
            const iframe: any = this.api && (this.api as any).getIFrame ? (this.api as any).getIFrame() : null;
            const doc = iframe && iframe.contentDocument;
            if (!doc) return;
            if (doc.getElementById('discentya-hide-local-tile-menu')) return;
            const st = doc.createElement('style');
            st.id = 'discentya-hide-local-tile-menu';
            st.textContent = [
                // Nomi noti del trigger locale nelle varie versioni Jitsi web:
                '.local-video-menu-trigger,',
                '#localVideoMenuTriggerButton,',
                '#localVideoTriggerButton,',
                '.videocontainer[id^="localVideoContainer"] .videocontainer__hoverOverlay,',
                '#filmstripLocalVideo .videocontainer__toolbar,',
                '#filmstripLocalVideo [class*="popover"]',
                '{ display: none !important; visibility: hidden !important; pointer-events: none !important; }'
            ].join('');
            doc.head.appendChild(st);
        } catch (_) { /* cross-origin: fallback non applicabile */ }
    }

    /**
     * Sentinella dei blocchi (sentinella-aula.ts): SOLO rileva e segnala.
     * Si riaggancia a ogni nuova `this.api` (ingresso, cambio stanza simulcast).
     */
    private agganciaSentinella(): void {
        try {
            agganciaSentinellaAula(this.api, {
                url: (environment.urlWeb || '/') + 'api/aula-blocchi.php',
                ruolo: 'corsista',
                dominio: this.domain + this.tokenMeet,
                stanza: this.room,
                idUtente: this.idCorsista,
                nome: this.user && this.user.name
            });
        } catch (e) {}
    }

    ngOnDestroy(): void {
        const sentinella = (window as any).__sentinellaAula;
        if (sentinella) sentinella.ferma();
        // Se il corsista era in aula e naviga via router SPA (menu -> Home)
        // senza chiudere il tab, beforeunload NON scatta. Registra comunque
        // l'uscita via beacon (fire-and-forget, no UI, no reload).
        this.sendBeaconExit();
        clearInterval(this.setTimeoutHandleAutomatic);
        this.setTimeoutHandleAutomatic = null;
        this.stopAccessoPolling();
        this.stopPresenzaPing();
    }

    @HostListener('window:beforeunload')
    onBeforeUnload(): void {
        this.sendBeaconExit();
    }

    // Wake-up check: se il tab e' stato throttled/sleep e torna visibile o
    // viene ripristinato dalla bfcache (es. mobile app-swap+return, laptop
    // svegliato), verifica SUBITO se l'orario di fine e' gia' passato.
    // Copre il caso "setTimeout non e' scattato in tempo perche' throttled".
    // Zero costo server: usa il fineUfficiale gia' cachato dal polling.
    @HostListener('document:visibilitychange')
    onVisibilityChange(): void {
        this.checkFineEventoOnWakeup('visibilitychange');
    }

    @HostListener('window:pageshow', ['$event'])
    onPageShow(_event: any): void {
        this.checkFineEventoOnWakeup('pageshow');
    }

    private checkFineEventoOnWakeup(source: string): void {
        try {
            if (this._fineEventoHandled) return;
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            if (!this._fineUfficialeCached) return;
            const nowMs = Date.now();
            const fineMs = new Date(String(this._fineUfficialeCached).replace(' ', 'T')).getTime();
            if (isNaN(fineMs)) return;
            if (nowMs >= fineMs) {
                console.log('[fine-evento] wakeup(' + source + '): fine gia\' passata -> salvaTimeOut');
                this._fineEventoHandled = true;
                this.stopAccessoPolling();
                if (this.isJoined) { this.salvaTimeOut(); }
            }
        } catch (e) { console.warn('checkFineEventoOnWakeup error', e); }
    }

    private sendBeaconExit(): void {
        if (this.idCorsista && this.idCorsoSvolgimento && this.isJoined) {
            const formData = new FormData();
            formData.append('type', 'setTImeoutCorsista');
            formData.append('idCorsista', this.idCorsista);
            formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
            formData.append('isAutomaticoTime', '0');
            navigator.sendBeacon(environment.web_api_url_base + 'corso.php', formData);
        }
    }

    initDevice() {
        this.api.isAudioDisabled().then(disabled => {
            if(disabled)
                this.isAudioMuted=true;
        });

        this.api.isAudioMuted().then(muted  => {
            if(!muted)
                this.isAudioMuted=true;
        });

        this.api.isVideoMuted().then(muted  => {
            this.isVideoMuted=muted;
        });

        this.api.isVideoAvailable().then(available  => {
            if(!available)
                this.isVideoMuted=true;
        });

        this.api.getRoomsInfo().then(rooms => {
        })

    }

    initEvents() {
        this.api.addEventListener('endpointTextMessageReceived', (event) => {
            console.log(event);
            try {
              const data = JSON.parse(event.data.eventData.text);
              if (data.action === 'close-room') {
                this.api.executeCommand('hangup');
              }
              // Presenter Mode: sync slide dal docente
              else if (data.action === 'presenter-sync') {
                this.handlePresenterSync(data);
              }
              // Scheda Didattica: sync dal docente
              else if (data.action === 'scheda-sync') {
                this.handleSchedaSync(data);
              }
              // Scaletta della lezione: sync dal docente
              else if (data.action === 'scaletta-sync') {
                // Salva il participantId del docente (chi invia il messaggio)
                const senderId = event.data?.senderInfo?.id || event.data?.eventData?.senderInfo?.id || '';
                if (senderId) {
                    (this as any)._docenteParticipantId = senderId;
                }
                this.handleScalettaSync(data);
              }
              // Caso Studio: sync dal docente (auto-play presentazione con TTS)
              else if (data.action === 'casostudio-sync') {
                this.handleCasoStudioSync(data);
              }
              // Flashcard Live: sync dal docente
              else if (data.action === 'flashcard-sync') {
                this.handleFlashcardLiveSync(data);
              }
              // Video Esterno Live: sync dal docente
              else if (data.action === 'video-sync') {
                this.handleVideoLiveSync(data);
              }
              // Presentazione Integrata: sync dal docente
              else if (data.action === 'presintegrata-sync') {
                this.handlePresIntegrataSync(data);
              }
              // Live Quiz: sync dal docente
              else if (data.action === 'quiz-sync') {
                this.handleQuizSync(data);
              }
              // Quiz Docente (dashboard): sync dal docente (6 tipi di domanda)
              else if (data.action === 'quiz-docente-sync') {
                this.handleQuizDocenteSync(data);
              }
              // Pausa countdown: sync dal docente
              else if (data.action === 'pausa-sync') {
                this.handlePausaSync(data);
              }
            } catch (e) {
              console.error('Errore parsing messaggio:', e);
            }
        });

        // Rete di sicurezza CSS: nasconde il trigger 3-puntini del proprio tile
        // (il flag Jitsi copre "Specchia"/"Nascondi" ma NON il "Metti in primo
        // piano"). Se l'iframe e' cross-origin, l'accesso a contentDocument
        // fallisce silenziosamente — non regressione, semplicemente restano i 3
        // puntini in quel caso.
        this.api.addListener('videoConferenceJoined', () => this.hideLocalVideoMenuTrigger());

        this.api.addEventListeners({
            readyToClose: this.handleClose,
            participantLeft: this.handleParticipantLeft,
            participantJoined: this.handleParticipantJoined,
            videoConferenceJoined: this.handleVideoConferenceJoined,
            // videoConferenceLeft registrato QUI (era in setTimeout 5s -> race window
            // di 5s all'inizio in cui hangup scattava senza salvaTimeOut() -> uscita
            // non salvata in tbl_corsi_attivi_body_uscita).
            // handleVideoConferenceLeft usa gia' la guardia if(this.isJoined) per
            // evitare falsi positivi durante il setup iniziale.
            videoConferenceLeft: this.handleVideoConferenceLeft,
            audioMuteStatusChanged: this.handleMuteStatus,
            videoMuteStatusChanged: this.handleVideoStatus,
            screenSharingStatusChanged: this.handleScreenStatus,
            participantKickedOut: this.handleParticipantKickedOut,
            moderationParticipantRejected: this.handleModerationParticipantRejected,
            moderationParticipantApproved: this.handleModerationParticipantApproved,
            errorOccurred: this.handleErrorOccurred
        });

    }


    salvaTimeOut() {
        if(this.idCorsista!="" && this.idCorsoSvolgimento!="") {
            clearInterval(this.setTimeoutHandleAutomatic);
            this.setTimeoutHandleAutomatic = null;
            this.crudService.api_setTImeoutCorsista(this.idCorsista, this.idCorsoSvolgimento, 0).subscribe(productData => {
                this.chiudiMeet();
            },(err)=>{
                console.error('salvaTimeOut HTTP error:', err);
                this.chiudiMeet();
            });
        }
    }

    salvaTimeOutAutomatico() {
        // GUARDIA anti-inflazione ore fascicolo:
        // - !isJoined: il partecipante ha gia' lasciato la meet Jitsi; senza
        //   questa guardia il tick 30' scriveva data_create=NOW() gonfiando
        //   la durata anche dopo l'uscita.
        // Nota: e' stata RIMOSSA la guardia visibilityState==='hidden' — bloccava
        // il refresh dell'uscita per corsisti col tab minimizzato ancora presenti
        // in aula, causando fascicolo con orario di uscita = ultimo momento in
        // foreground (bug segnalato da alcuni clienti). Il server clamp esatto
        // (function_primary.php::timeOutAula) gestisce comunque il tetto max
        // (fine_ufficiale), quindi nessuna inflazione oltre la fine reale.
        if (!this.isJoined) return;

        if(this.idCorsista!="" && this.idCorsoSvolgimento!="") {
            this.crudService.api_setTImeoutCorsista(this.idCorsista, this.idCorsoSvolgimento, 1).subscribe(
                productData => {
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        title: 'Presenza salvata automaticamente',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true
                    });
                },
                (err) => { console.error('salvaTimeOutAutomatico HTTP error:', err); }
            );
        }
    }

    entraInAula() {
        this.crudService.set_entraInAulaCorsista(this.arrayDetail).subscribe(responseData => {
            console.log(responseData);

            if(responseData && responseData['accessoBloccato'] == 1) {
                this.corsistaNonAccettato();
                return;
            }
            if(responseData==1) {}
        });

        clearInterval(this.setTimeoutHandleAutomatic);
        this.setTimeoutHandleAutomatic = setInterval(() => {
            this.salvaTimeOutAutomatico();
        }, 1800000);
        //30m=1800000 | TEST: 10s=10000

        this.startPresenzaPing();
    }

    /**
     * PING DI PRESENZA DI RISERVA (5 minuti).
     *
     * Nel caso normale la presenza e' gia' timbrata a COSTO ZERO dal polling
     * quiz (api/quiz-attivo.php, ogni 10s), che aggiorna `last_seen`.
     * Questo ping copre l'unico buco: quando un quiz e' attivo quel polling si
     * ferma (stopQuizAttivoPolling) e nessuno timbrerebbe piu' la presenza.
     *
     * JITTER: l'attesa iniziale e' casuale (0-60s) e l'intervallo varia tra 4'30"
     * e 5'30". Senza questo, i corsisti — che entrano tutti insieme all'inizio
     * della lezione — ticcherebbero tutti nello stesso istante, creando picchi
     * di centinaia di richieste simultanee invece di un flusso distribuito.
     */
    startPresenzaPing() {
        this.stopPresenzaPing();
        const jitterIniziale = Math.floor(Math.random() * 60000);          // 0-60s
        const intervallo     = 270000 + Math.floor(Math.random() * 60000); // 4'30"-5'30"
        this.presenzaPingTimeout = setTimeout(() => {
            this.inviaPresenzaPing();
            this.presenzaPingInterval = setInterval(() => this.inviaPresenzaPing(), intervallo);
        }, jitterIniziale);
    }

    stopPresenzaPing() {
        if (this.presenzaPingTimeout)  { clearTimeout(this.presenzaPingTimeout);   this.presenzaPingTimeout = null; }
        if (this.presenzaPingInterval) { clearInterval(this.presenzaPingInterval); this.presenzaPingInterval = null; }
    }

    inviaPresenzaPing() {
        // Come salvaTimeOutAutomatico: se ha gia' lasciato la meet non timbriamo,
        // altrimenti si gonfierebbe la presenza dopo l'uscita reale.
        if (!this.isJoined) return;
        if (!this.idCorsista || !this.idCorsoSvolgimento) return;

        const baseUrl  = environment.urlWeb || '/';
        const formData = new FormData();
        formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
        formData.append('idCorsista', this.idCorsista);
        formData.append('ruolo', 'corsista');

        fetch(baseUrl + 'api/presenza-ping.php', { method: 'POST', body: formData })
            .catch(() => { /* ping best-effort: un fallimento non deve disturbare la lezione */ });
    }

    handleErrorOccurred = (detail) => {
        switch (detail.error.name) {
            case 'conference.connectionError.accessDenied':
                this.corsistaNonAccettato();
                break;

            case "conference.connectionError.membersOnly":
                this.isLoaded=true;
                this.isOnlyMember=true;

            default:
                break;
        }
    }

    handleClose = () => {
        console.log("handleClose");
    }

    handleParticipantKickedOut = (participant) => {
        this.isKickoutFromRoom=true;
    }

    handleModerationParticipantApproved = (participant) => {
        console.log("approvato...");
    }

    handleModerationParticipantRejected() {
        console.log("non accettato");
    }

    handleParticipantLeft =  (participant) => {
        console.log("handleParticipantLeft", participant);
    }

    handleParticipantJoined = (participant) => {
        this.isOnlyMember=false;
        clearTimeout(this.setTimeoutHandle);

        this.userIDMeet = participant.id;

        this.getParticipants(participant, this.idCorsista);
    }

    handleVideoConferenceJoined = (participant) => {
        this.initDevice();

        this.isLoaded=true;

        // In simulcast, mostra il nome aula reale invece del codice stanza
        if (this._isSimulcast && this._simulcastSubject) {
            try { this.api.executeCommand('subject', this._simulcastSubject); } catch(e) {}
        }

        this.isJoined=true;
        // Bridge DataChannel: pronto dopo ~1500ms dal join (finestra empirica
        // di stabilizzazione WebRTC osservata nel docente). Prima di allora
        // sendEndpointTextMessage viene silently droppato.
        setTimeout(() => { this._jitsiBridgeReady = true; }, 1500);
        this.entraInAula();

        // Avvia polling presenter state, scheda, scaletta e caso studio (fallback per DataChannel)
        this.startPresenterPolling();
        this.startSchedaPolling();
        this.startScalettaPolling();
        this.startCasoStudioPolling();
        this.startFlashcardPolling();
        this.startVideoPolling();
        this.startPresIntegrataPolling();
        this.startAccessoPolling();

        // Controlla se c'e' un quiz attivo. Bug cliente AssOAFoP: il one-shot a 5s
        // (poi silenzio per sempre) faceva perdere il quiz al late-joiner nei casi:
        //  - fetch fallito silenziosamente (rete instabile, server 5xx)
        //  - corsista entrato PRIMA che il docente lanci il quiz (broadcast Jitsi
        //    perso per unreliable DataChannel)
        //  - heartbeat docente stale al primo probe ma rientra subito dopo
        // Nuova strategia: probe rapido a 500ms + polling ogni 10s finche' non trovato.
        // Si auto-ferma appena il quiz e' ricevuto (via DataChannel o fetch).
        this.startQuizAttivoPolling();
        this.startQuizDocenteAttivoPolling();
    }


    handleVideoConferenceLeft = (participant) => {
        console.log("handleVideoConferenceLeft");
        // Se e' un redirect simulcast, non uscire dall'aula
        if (this._simulcastRedirecting) return;
        if(this.isJoined) {
            this.salvaTimeOut();
        }
    }

    handleMuteStatus = (audio) => {
    }

    handleVideoStatus = (video) => {
    }

    handleScreenStatus = (status) => {
        this.isVideoShared=status.on;
    }

    getParticipants(participant, idCorsista) {
        console.clear();

        var arrayP=this.api.getParticipantsInfo();
        arrayP[arrayP.length - 1]['idCorsista']=idCorsista;
        console.log(arrayP[arrayP.length - 1])
            setTimeout(() => {
                console.log(this.api.getParticipantsInfo());
            }, 2500)
    }

    // custom events
    executeCommand(command: string) {
        if(command == 'hangup') {
            this.salvaTimeOut();
            return;
        }

        this.api.executeCommand(command);

        if(command == 'toggleTileView') {
        }

        if(command == 'toggleRaiseHand') {
            this.isHandMuted = !this.isHandMuted;
        }

        if(command == 'toggleAudio') {
            this.isAudioMuted = !this.isAudioMuted;
        }

        if(command == 'toggleVideo') {
            this.isVideoMuted = !this.isVideoMuted;
        }

        if(command == 'toggleChat') {
            this.isChat = !this.isChat;
        }
    }

    corsistaNonAccettato() {
        var tk=document.getElementById('jitsi-iframe') as HTMLInputElement;
        tk.style.display="none";

        if(this.idCorsista!="" && this.idCorsoSvolgimento!="") {
            this.crudService.api_setTImeoutCorsista(this.idCorsista, this.idCorsoSvolgimento, 0).subscribe(
                productData => {},
                (err) => { console.error('corsistaNonAccettato exit error:', err); }
            );
        }

        Swal.fire({
            title:'Respinto!',
            text: 'la tua richiesta di entrare in aula è stata respinta, riprova o contatta l\'amministrazione per ulteriori informazioni.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#6993FF',
            cancelButtonColor: '#dadada',
            confirmButtonText: 'Riprova',
            allowOutsideClick: false,
         }).then((result) => {
            if (result.isConfirmed) {
                location.reload();
            }
        });
    }


    // === PRESENTER MODE ===
    handlePresenterSync(data: any) {
        console.log('[Presenter] Sync ricevuto:', data.type, 'slide:', data.slideIndex);

        if (data.type === 'start') {
            // Se l'overlay è già attivo per la stessa presentazione, non ricreare
            if (this.presenterActive) {
                // Aggiorna solo se la slide è cambiata
                if (data.slideIndex !== this.presenterLastSlideIndex) {
                    this.presenterSlideIndex = data.slideIndex || 0;
                    this.presenterLastSlideIndex = data.slideIndex;
                    this.navigatePresenterSlide(data.slideIndex);
                }
                return;
            }
            this.presenterActive = true;
            this.presenterTitolo = data.titolo || 'Presentazione';
            this.presenterSlideIndex = data.slideIndex || 0;
            this.presenterTotalSlides = data.totalSlides || 0;
            this.presenterLastSlideIndex = data.slideIndex || 0;
            this.showPresenterOverlay(data.presId, data.presPartner, data.slideIndex);
        }
        else if (data.type === 'slide') {
            // Ignora se la slide non è cambiata
            if (data.slideIndex === this.presenterLastSlideIndex) return;
            this.presenterSlideIndex = data.slideIndex || 0;
            this.presenterLastSlideIndex = data.slideIndex || 0;
            this.presenterTotalSlides = data.totalSlides || 0;
            this.navigatePresenterSlide(data.slideIndex);
        }
        else if (data.type === 'pause') {
            this.presenterSendCommand('presenterPause');
        }
        else if (data.type === 'resume') {
            this.presenterSendCommand('presenterResume');
        }
        else if (data.type === 'mute') {
            this.presenterSendCommand('presenterMute');
        }
        else if (data.type === 'unmute') {
            this.presenterSendCommand('presenterUnmute');
        }
        else if (data.type === 'stop') {
            this.hidePresenterOverlay();
        }
    }

    presenterSendCommand(action: string) {
        if (!this.presenterIframe || !this.presenterIframe.contentWindow) return;
        const win = this.presenterIframe.contentWindow as any;
        try {
            // Accesso diretto same-origin via _presenterControl esposto dal viewer
            if (win._presenterControl) {
                if (action === 'presenterPause') { win._presenterControl.pause(); return; }
                if (action === 'presenterResume') { win._presenterControl.resume(); return; }
                if (action === 'presenterMute') { win._presenterControl.mute(); return; }
                if (action === 'presenterUnmute') { win._presenterControl.unmute(); return; }
            }
        } catch (e) {}
        // Fallback postMessage (cross-origin)
        win.postMessage(JSON.stringify({ action: action }), '*');
    }

    showPresenterOverlay(presId: string, presPartner: number, slideIndex: number, seekTime: number = 0) {
        // Rimuovi overlay DOM precedente se esiste (senza resettare lo stato)
        this.presenterIframe = null;
        const oldOverlay = document.getElementById('presenterOverlay');
        if (oldOverlay) oldOverlay.remove();
        const oldMini = document.getElementById('presenterMiniIndicator');
        if (oldMini) oldMini.remove();

        // Marca come attivo
        this.presenterActive = true;

        // Crea overlay container
        const overlay = document.createElement('div');
        overlay.id = 'presenterOverlay';
        overlay.style.cssText = 'position:fixed; top:40px; left:0; right:0; bottom:0; z-index:1001; background:#211D38; display:flex; flex-direction:column;';

        // Header bar
        const header = document.createElement('div');
        header.style.cssText = 'background:#1b1b28; padding:8px 16px; display:flex; align-items:center; gap:10px; border-bottom:1px solid #2d2d3f; flex-shrink:0;';
        header.innerHTML = '<span style="color:#3699FF; font-size:14px;">&#9654; Presentazione in corso</span>' +
            '<span style="color:#fff; font-size:13px; font-weight:600; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">' + this.escHtml(this.presenterTitolo) + '</span>' +
            '<span id="presOverlayCounter" style="color:#a2a3b7; font-size:12px;">' + (slideIndex + 1) + ' / ' + this.presenterTotalSlides + '</span>' +
            '<button id="btnPresMinimize" style="background:#2d2d3f; border:none; color:#fff; padding:4px 10px; border-radius:4px; cursor:pointer; font-size:12px;" title="Minimizza">&#9660;</button>';
        overlay.appendChild(header);

        // Iframe per il viewer — slideIndex e seekTime come parametri URL
        // così il viewer gestisce il late-join internamente dopo buildSlides()
        const baseUrl = environment.urlWeb || '/';
        let iframeSrc = baseUrl + 'pages/viewer_presentazione.php?id=' + encodeURIComponent(presId) +
            '&partner=' + presPartner + '&slave=1';
        if (slideIndex > 0) {
            iframeSrc += '&startSlide=' + slideIndex;
        }
        if (seekTime > 0) {
            iframeSrc += '&startSeek=' + seekTime.toFixed(1);
        }
        console.log('[Presenter] iframe URL:', iframeSrc);

        const iframe = document.createElement('iframe');
        iframe.id = 'presenterIframe';
        iframe.src = iframeSrc;
        iframe.allow = 'autoplay';
        iframe.style.cssText = 'flex:1; width:100%; border:none;';
        overlay.appendChild(iframe);

        this.presenterIframe = iframe;

        // Append al body
        document.body.appendChild(overlay);

        // Minimize handler
        const btnMin = document.getElementById('btnPresMinimize');
        if (btnMin) {
            btnMin.addEventListener('click', () => {
                this.togglePresenterMinimize();
            });
        }

        // Dopo caricamento iframe, applica stato pausa/mute se necessario
        iframe.onload = () => {
            const self = this;
            // Attendi _presenterReady per applicare pausa/mute
            let attempts = 0;
            const waitAndApplyState = () => {
                attempts++;
                if (!self.presenterIframe || !self.presenterIframe.contentWindow) return;
                const win = self.presenterIframe.contentWindow as any;
                if (!win._presenterReady && attempts < 50) {
                    setTimeout(waitAndApplyState, 200);
                    return;
                }
                if (self.presenterPaused) {
                    setTimeout(() => { self.presenterSendCommand('presenterPause'); }, 300);
                }
                if (self.presenterMuted) {
                    setTimeout(() => { self.presenterSendCommand('presenterMute'); }, 400);
                }
            };
            setTimeout(waitAndApplyState, 500);
        };
    }

    navigatePresenterSlide(slideIndex: number) {
        if (this.presenterIframe && this.presenterIframe.contentWindow) {
            const win = this.presenterIframe.contentWindow as any;
            try {
                if (win._presenterControl) {
                    win._presenterControl.goToSlide(slideIndex);
                } else {
                    win.postMessage(JSON.stringify({ action: 'presenterGoToSlide', slideIndex: slideIndex }), '*');
                }
            } catch (e) {
                win.postMessage(JSON.stringify({ action: 'presenterGoToSlide', slideIndex: slideIndex }), '*');
            }
        }
        // Aggiorna counter
        const counter = document.getElementById('presOverlayCounter');
        if (counter) {
            counter.textContent = (slideIndex + 1) + ' / ' + this.presenterTotalSlides;
        }
    }

    hidePresenterOverlay() {
        this.presenterActive = false;
        this.presenterIframe = null;
        this.presenterLastSlideIndex = -1;
        const overlay = document.getElementById('presenterOverlay');
        if (overlay) overlay.remove();
        // Rimuovi anche minimized indicator
        const mini = document.getElementById('presenterMiniIndicator');
        if (mini) mini.remove();
    }

    togglePresenterMinimize() {
        const overlay = document.getElementById('presenterOverlay');
        if (!overlay) return;

        if (overlay.style.display !== 'none') {
            // Minimizza
            overlay.style.display = 'none';
            // Mostra indicatore minimizzato
            const mini = document.createElement('div');
            mini.id = 'presenterMiniIndicator';
            mini.style.cssText = 'position:fixed; bottom:60px; right:12px; z-index:1001; background:#3699FF; color:#fff; padding:8px 14px; border-radius:8px; cursor:pointer; font-size:12px; font-weight:600; box-shadow:0 4px 12px rgba(0,0,0,0.3); font-family:Poppins,sans-serif;';
            mini.innerHTML = '&#9654; Presentazione <span style="opacity:0.7;">(' + (this.presenterSlideIndex + 1) + '/' + this.presenterTotalSlides + ')</span>';
            mini.addEventListener('click', () => {
                this.togglePresenterMinimize();
            });
            document.body.appendChild(mini);
        } else {
            // Ripristina
            overlay.style.display = 'flex';
            const mini = document.getElementById('presenterMiniIndicator');
            if (mini) mini.remove();
        }
    }

    private escHtml(str: string): string {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(str || ''));
        return div.innerHTML;
    }

    /** Converte inline Markdown (bold, italic, underline, highlight) in HTML sicuro */
    private inlineMd(md: string): string {
        if (!md) return '';
        let h = this.escHtml(md);
        h = h.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
        h = h.replace(/__([^_]+)__/g, '<u>$1</u>');
        h = h.replace(/\*([^*]+)\*/g, '<em>$1</em>');
        h = h.replace(/==([^=]+)==/g, '<mark>$1</mark>');
        return h;
    }

    /**
     * Auto-formattazione testo narrazione basata su keyword estratte dai punti.
     * Replica la logica dispFormatNarrazione del docente.
     */
    private autoFormatText(text: string, boldWords: string[], highlights: string[]): string {
        let h = this.escHtml(text);

        // 1) <mark> — sottotitoli dei punti chiave (highlights)
        const markMap: string[] = [];
        if (highlights && highlights.length) {
            highlights.slice(0, 20).forEach(hl => {
                const escaped = hl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const re = new RegExp('(?<![\\w])(' + escaped + ')(?![\\w])', 'gi');
                h = h.replace(re, (_m: string) => {
                    const idx = markMap.length;
                    markMap.push(_m);
                    return '\x01M' + idx + '\x01';
                });
            });
        }

        // 2) <strong> — parole significative (boldWords)
        const boldMap: string[] = [];
        if (boldWords && boldWords.length) {
            boldWords.slice(0, 30).forEach(kw => {
                const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const re = new RegExp('\\b(' + escaped + ')\\b', 'gi');
                h = h.replace(re, (_m: string) => {
                    const idx = boldMap.length;
                    boldMap.push(_m);
                    return '\x00B' + idx + '\x00';
                });
            });
        }

        // 3) Extra <mark> — sigle (2+ maiuscole), percentuali, date con anno
        h = h.replace(/\b([A-Z]{2,}[0-9]*(?:\/[A-Z0-9]+)?)\b/g, '<mark>$1</mark>');
        h = h.replace(/\b(\d+(?:[.,]\d+)?)\s*%/g, '<mark>$1%</mark>');
        h = h.replace(/\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/g, '<mark>$1</mark>');

        // 4) <em> — frasi introduttive
        h = h.replace(/^(In (?:questo|questa|quest[oi]) (?:contesto|sede|ambito|scenario|caso|sezione|slide|paragrafo)[,:]?\s)/i, '<em>$1</em>');
        h = h.replace(/^((?:È|E) (?:importante|fondamentale|essenziale|necessario|opportuno|utile)\s)/i, '<em>$1</em>');
        h = h.replace(/^((?:Come|Secondo|Sulla base di|In base a|A partire da)\s.{5,40}[,:]\s)/i, '<em>$1</em>');

        // 5) <u> — virgolette e caporali
        h = h.replace(/[«""]([^»""]{3,60})[»""]/g, '<u>$1</u>');

        // Ripristina placeholder
        for (let mi = markMap.length - 1; mi >= 0; mi--) {
            h = h.replace('\x01M' + mi + '\x01', '<mark>' + markMap[mi] + '</mark>');
        }
        for (let bi = boldMap.length - 1; bi >= 0; bi--) {
            h = h.replace('\x00B' + bi + '\x00', '<strong>' + boldMap[bi] + '</strong>');
        }

        return h;
    }

    // === LIVE QUIZ ===
    private quizIdQuiz: number = 0;
    private quizStartTime: number = 0;
    private quizTimerInterval: any = null;
    private quizCurrentDomandaId: number = 0;
    private quizResultsTimeout: any = null;
    private quizAllDomande: any[] = [];
    private quizCurrentIndex: number = 0;
    private quizTotalCorrette: number = 0;
    private quizTotalPunteggio: number = 0;
    private quizLastSyncAt: number = 0; // timestamp ricezione ultimo quiz-autonomous (per dedup)
    private quizAttivoPollInterval: any = null; // polling periodico late-joiner

    // ===== Quiz docente (dashboard) =====
    private quizDocIdQuiz: number = 0;
    private quizDocTitolo: string = '';
    private quizDocAllDomande: any[] = [];
    private quizDocCurrentIndex: number = 0;
    private quizDocTotalCorrette: number = 0;
    private quizDocTotalPunteggio: number = 0;
    private quizDocStartTime: number = 0;
    private quizDocTimerInterval: any = null;
    private quizDocTempRisposta: any = null; // risposta in costruzione (multi/ordinamento/abbinamento)
    private quizDocLastSyncAt: number = 0; // timestamp ricezione ultimo quiz-docente-autonomous (per dedup)
    private quizDocAttivoPollInterval: any = null; // polling periodico late-joiner
    private quizDocSummaryPollInterval: any = null; // polling stato docente durante overlay "in attesa classifica"
    private quizSummaryPollInterval: any = null; // idem per Live Quiz
    private quizDocTempoSecondi: number = 30; // tempo per domanda scelto dal docente (default 30)

    /**
     * Avvia il polling periodico per il Live Quiz (late-joiner).
     * Fa un probe subito a 500ms poi ripete ogni 10s finche' il quiz non e' ricevuto.
     * Si ferma automaticamente in stopQuizAttivoPolling(), chiamato da:
     *  - checkQuizAttivo() quando trova il quiz
     *  - handleQuizSync() quando riceve quiz-autonomous via DataChannel
     *  - chiudiMeet() quando la lezione finisce
     */
    startQuizAttivoPolling() {
        this.stopQuizAttivoPolling();
        setTimeout(() => { this.checkQuizAttivo(); }, 500);
        this.quizAttivoPollInterval = setInterval(() => {
            if (this.quizAllDomande && this.quizAllDomande.length > 0) {
                this.stopQuizAttivoPolling();
                return;
            }
            this.checkQuizAttivo();
        }, 10000);
    }

    stopQuizAttivoPolling() {
        if (this.quizAttivoPollInterval) {
            clearInterval(this.quizAttivoPollInterval);
            this.quizAttivoPollInterval = null;
        }
    }

    startQuizDocenteAttivoPolling() {
        this.stopQuizDocenteAttivoPolling();
        setTimeout(() => { this.checkQuizDocenteAttivo(); }, 700);
        this.quizDocAttivoPollInterval = setInterval(() => {
            if (this.quizDocAllDomande && this.quizDocAllDomande.length > 0) {
                this.stopQuizDocenteAttivoPolling();
                return;
            }
            this.checkQuizDocenteAttivo();
        }, 10000);
    }

    stopQuizDocenteAttivoPolling() {
        if (this.quizDocAttivoPollInterval) {
            clearInterval(this.quizDocAttivoPollInterval);
            this.quizDocAttivoPollInterval = null;
        }
    }

    /**
     * Controlla se c'è un quiz attivo per questo corso (per corsisti che entrano dopo il lancio).
     */
    checkQuizAttivo() {
        if (!this.idCorsoSvolgimento || !this.idCorsista) return;
        // Se il quiz è già attivo (ricevuto via DataChannel), non controllare
        if (this.quizAllDomande && this.quizAllDomande.length > 0) return;

        const baseUrl = environment.urlWeb || '/';
        const formData = new FormData();
        formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
        formData.append('idCorsista', this.idCorsista);

        console.log('[Quiz] checkQuizAttivo - idCorsoSvolgimento:', this.idCorsoSvolgimento, 'idCorsista:', this.idCorsista);

        fetch(baseUrl + 'api/quiz-attivo.php', {
            method: 'POST',
            body: formData
        })
        .then(resp => resp.text())
        .then(text => {
            console.log('[Quiz] checkQuizAttivo risposta raw:', text);
            const result = JSON.parse(text);
            if (result.success && result.quizAttivo && result.domande && result.domande.length > 0) {
                // Ricontrolla che nel frattempo non sia arrivato via DataChannel
                if (this.quizAllDomande && this.quizAllDomande.length > 0) return;
                console.log('[Quiz] Quiz attivo trovato al join:', result.idQuiz, result.titolo);
                this.quizIdQuiz = result.idQuiz;
                this.quizLastSyncAt = Date.now();
                this.quizAllDomande = result.domande;
                this.quizCurrentIndex = 0;
                this.quizTotalCorrette = 0;
                this.quizTotalPunteggio = 0;
                this.stopQuizAttivoPolling();
                this.showQuizNotification('Quiz: ' + (result.titolo || 'Live Quiz') + ' (' + result.totaleDomande + ' domande)');
                setTimeout(() => { this.quizAutonomousNext(); }, 2000);
            } else {
                console.log('[Quiz] Nessun quiz attivo:', result);
            }
        })
        .catch(err => {
            console.warn('[Quiz] Errore check quiz attivo:', err);
        });
    }

    /**
     * Controlla se c'e un quiz docente (dashboard) attivo al join.
     */
    checkQuizDocenteAttivo() {
        if (!this.idCorsoSvolgimento || !this.idCorsista) return;
        if (this.quizDocAllDomande && this.quizDocAllDomande.length > 0) return;

        const baseUrl = environment.urlWeb || '/';
        const formData = new FormData();
        formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
        formData.append('idCorsista', this.idCorsista);

        console.log('[QuizDocente] checkQuizDocenteAttivo - idCorsoSvolgimento:', this.idCorsoSvolgimento, 'idCorsista:', this.idCorsista);

        fetch(baseUrl + 'api/quiz-docente-attivo.php', {
            method: 'POST',
            body: formData
        })
        .then(resp => resp.text())
        .then(text => {
            console.log('[QuizDocente] checkQuizDocenteAttivo risposta raw:', text);
            const result = JSON.parse(text);
            if (result.success && result.quizAttivo && result.domande && result.domande.length > 0) {
                if (this.quizDocAllDomande && this.quizDocAllDomande.length > 0) return;
                console.log('[QuizDocente] Quiz attivo trovato al join:', result.idQuiz, result.titolo);
                this.quizDocIdQuiz = result.idQuiz;
                this.quizDocLastSyncAt = Date.now();
                this.quizDocTitolo = result.titolo;
                this.quizDocAllDomande = result.domande;
                this.quizDocCurrentIndex = 0;
                this.quizDocTotalCorrette = 0;
                this.quizDocTotalPunteggio = 0;
                this.quizDocTempoSecondi = parseInt(result.tempo_secondi_domanda, 10) || 30;
                this.stopQuizDocenteAttivoPolling();
                this.showQuizNotification('Quiz: ' + (result.titolo || 'Quiz docente') + ' (' + result.totaleDomande + ' domande)');
                setTimeout(() => { this.quizDocenteNext(); }, 2000);
            } else {
                console.log('[QuizDocente] Nessun quiz docente attivo:', result);
            }
        })
        .catch(err => {
            console.warn('[QuizDocente] Errore check:', err);
        });
    }

    /**
     * Handler dei messaggi 'quiz-docente-sync' dal docente.
     */
    handleQuizDocenteSync(msg: any) {
        const type = msg.type;
        const data = msg.data;
        console.log('[QuizDocente] Sync ricevuto:', type);

        if (type === 'quiz-docente-autonomous') {
            // Dedup con time-window 30s: se lo stesso quiz-docente-autonomous arriva
            // entro 30s dall'ultimo, e' quasi certamente un rebroadcast Jitsi (arriva in
            // millisecondi). Se arriva DOPO 30s con stesso idQuiz, e' un rilancio
            // intenzionale del docente (Termina + Avvia) → procedi.
            // Bug cliente AssOAFoP: senza guardia, il rilancio azzerava lo stato del
            // corsista e ricreava l'overlay → sfarfallio + progresso perso.
            const nowTs = Date.now();
            if (this.quizDocIdQuiz === data.idQuiz &&
                this.quizDocAllDomande && this.quizDocAllDomande.length > 0 &&
                (nowTs - this.quizDocLastSyncAt) < 30000) {
                console.log('[QuizDocente] Ignoro rebroadcast idQuiz=' + data.idQuiz + ' (entro 30s)');
                return;
            }
            this.quizDocLastSyncAt = nowTs;
            this.quizDocIdQuiz = data.idQuiz;
            this.quizDocTitolo = data.titolo || 'Quiz docente';
            this.quizDocAllDomande = data.domande || [];
            this.quizDocCurrentIndex = 0;
            this.quizDocTotalCorrette = 0;
            this.quizDocTotalPunteggio = 0;
            // Tempo per domanda scelto dal docente (fallback 30s per compat).
            this.quizDocTempoSecondi = parseInt(data.tempo_secondi_domanda, 10) || 30;
            this.stopQuizDocenteAttivoPolling();
            this.showQuizNotification('Quiz: ' + this.quizDocTitolo + ' (' + data.totaleDomande + ' domande)');
            setTimeout(() => { this.quizDocenteNext(); }, 2000);
        } else if (type === 'quiz-docente-leaderboard') {
            this.showQuizDocenteLeaderboard(data);
        } else if (type === 'quiz-docente-eval-update') {
            this.handleQuizDocenteEvalUpdate(data);
        }
    }

    /**
     * Riceve un aggiornamento di valutazione di una risposta aperta dal docente.
     * Se riguarda questo corsista, aggiorna il suo totale punteggio visualizzato e
     * mostra una piccola notifica.
     */
    handleQuizDocenteEvalUpdate(data: any) {
        const idCorsistaMsg = parseInt(data.idCorsista, 10);
        const mioId = parseInt(this.idCorsista, 10);
        if (idCorsistaMsg !== mioId) return;

        const isCor = data.isCorretta === 1 || data.isCorretta === true;
        const punti = parseInt(data.punteggio, 10) || 0;

        // Aggiorna lo stato locale del quiz docente
        if (isCor) {
            this.quizDocTotalCorrette++;
            this.quizDocTotalPunteggio += punti;
        }

        // Determina se il corsista ha gia completato tutte le domande.
        // In tal caso puo' essere in vista "summary" e va aggiornata.
        // Se invece sta ancora rispondendo, NON chiudere il quiz: solo notifica.
        const quizCompletato = this.quizDocAllDomande.length > 0 &&
                               this.quizDocCurrentIndex >= this.quizDocAllDomande.length;

        if (quizCompletato) {
            // Il corsista e' nella schermata di summary: aggiornala in place
            const el = document.getElementById('quizOverlay');
            if (el) this.showQuizDocenteSummary();
        }
        // Se il quiz e' ancora in corso: NIENTE rerender dell'overlay
        // (altrimenti interrompe la domanda corrente). Solo notifica toast.

        // Notifica toast discreta
        if (isCor) {
            this.showQuizNotification('Risposta aperta valutata: +' + punti + ' punti!');
        } else {
            this.showQuizNotification('Risposta aperta valutata: sbagliata');
        }
    }

    /**
     * Mostra la prossima domanda del quiz docente.
     */
    quizDocenteNext() {
        if (this.quizDocCurrentIndex >= this.quizDocAllDomande.length) {
            this.showQuizDocenteSummary();
            return;
        }
        const dom = this.quizDocAllDomande[this.quizDocCurrentIndex];
        const num = this.quizDocCurrentIndex + 1;
        const total = this.quizDocAllDomande.length;
        this.showQuizDocenteQuestion(dom, num, total);
    }

    /**
     * Mostra una domanda del quiz docente in overlay.
     * Rendering specifico per i 6 tipi: multipla, multi, vf, aperta, ordinamento, abbinamento.
     */
    showQuizDocenteQuestion(dom: any, num: number, total: number) {
        // Clear del timer precedente (difensivo): senza questo, se showQuizDocenteQuestion viene
        // chiamato piu' volte in rapida successione (es. rebroadcast quiz-docente-autonomous),
        // si accumulano setInterval paralleli che tickano tutti su #quizDocTimer e al remaining<=0
        // scattano piu' auto-submit consecutivi -> quizDocCurrentIndex sfora -> 0/10 nel summary.
        if (this.quizDocTimerInterval) {
            clearInterval(this.quizDocTimerInterval);
            this.quizDocTimerInterval = null;
        }
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        this.quizDocStartTime = Date.now();
        this.quizDocTempRisposta = null;
        // Tempo per domanda scelto dal docente (default 30s).
        const tempoSec = this.quizDocTempoSecondi > 0 ? this.quizDocTempoSecondi : 30;

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px; overflow-y:auto;';

        // Wrapper centrato
        let html = '<div style="width:100%; max-width:700px; margin:auto;">';

        // Header counter + timer
        html += '<div style="text-align:center; margin-bottom:20px; width:100%;">';
        html += '<div style="color:#8950FC; font-size:12px; font-weight:700; text-transform:uppercase; margin-bottom:6px;">Domanda ' + num + ' / ' + total + '</div>';
        html += '<div id="quizDocTimer" style="color:#FFA800; font-size:24px; font-weight:800; margin-bottom:12px;">' + tempoSec + '</div>';
        html += '<div id="quizDocTimerBar" style="width:100%; height:4px; background:#2d2d3f; border-radius:2px; overflow:hidden;"><div id="quizDocTimerFill" style="width:100%; height:100%; background:#FFA800; transition:width 1s linear;"></div></div>';
        html += '</div>';

        // Testo domanda
        html += '<div style="color:#fff; font-size:22px; font-weight:700; text-align:center; margin-bottom:30px; line-height:1.3;">' + this.escHtml(dom.testo) + '</div>';

        // Body specifico per tipo
        html += '<div id="quizDocBody" style="width:100%;">';
        html += this.renderQuizDocenteBody(dom);
        html += '</div>';

        // Feedback area
        html += '<div id="quizDocFeedback" style="display:none; margin-top:20px; text-align:center;"></div>';

        html += '</div>'; // close wrapper

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Bind handler per il tipo corrente
        this.bindQuizDocenteHandlers(dom);

        // Timer countdown
        let remaining = tempoSec;
        this.quizDocTimerInterval = setInterval(() => {
            remaining--;
            const timerEl = document.getElementById('quizDocTimer');
            const fillEl = document.getElementById('quizDocTimerFill');
            if (timerEl) timerEl.textContent = String(remaining);
            if (fillEl) fillEl.style.width = (remaining / tempoSec * 100) + '%';
            if (remaining <= 5 && timerEl) timerEl.style.color = '#F64E60';
            if (remaining <= 0) {
                clearInterval(this.quizDocTimerInterval);
                // Auto-invia quello che c'e (anche vuoto)
                this.submitQuizDocenteAnswer(dom);
            }
        }, 1000);
    }

    /**
     * Genera l'HTML del body domanda in base al tipo.
     */
    renderQuizDocenteBody(dom: any): string {
        const tipo = dom.tipo;
        let html = '';

        if (tipo === 'multipla') {
            html += '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">';
            const colors = ['#8950FC', '#3699FF', '#FFA800', '#1BC5BD', '#F64E60', '#0BB4AD'];
            const shapes = ['&#9650;', '&#9670;', '&#9679;', '&#9632;', '&#9733;', '&#10045;'];
            for (let i = 0; i < dom.opzioni.length; i++) {
                const col = colors[i % colors.length];
                html += '<button class="quiz-doc-opt" data-idx="' + i + '" style="background:' + col + '; border:none; color:#fff; padding:20px 16px; border-radius:8px; font-size:15px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:10px; min-height:60px; text-align:left;">';
                html += '<span style="font-size:18px;">' + shapes[i % shapes.length] + '</span>';
                html += '<span style="flex:1;">' + this.escHtml(dom.opzioni[i]) + '</span>';
                html += '</button>';
            }
            html += '</div>';
        }
        else if (tipo === 'multi') {
            html += '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px; margin-bottom:16px;">';
            const colors = ['#8950FC', '#3699FF', '#FFA800', '#1BC5BD', '#F64E60', '#0BB4AD'];
            for (let i = 0; i < dom.opzioni.length; i++) {
                const col = colors[i % colors.length];
                html += '<button class="quiz-doc-multi" data-idx="' + i + '" style="background:' + col + '; border:3px solid transparent; color:#fff; padding:18px 16px; border-radius:8px; font-size:14px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:10px; min-height:60px; text-align:left;">';
                html += '<span class="check-icon" style="width:22px; height:22px; border-radius:4px; border:2px solid #fff; display:inline-block; flex-shrink:0;"></span>';
                html += '<span style="flex:1;">' + this.escHtml(dom.opzioni[i]) + '</span>';
                html += '</button>';
            }
            html += '</div>';
            html += '<button id="quizDocConfirm" style="width:100%; padding:14px; background:#1BC5BD; border:none; color:#fff; border-radius:8px; font-size:15px; font-weight:700; cursor:pointer;">Conferma selezione</button>';
        }
        else if (tipo === 'vf') {
            html += '<div style="display:flex; gap:16px;">';
            html += '<button class="quiz-doc-vf" data-val="true" style="flex:1; padding:40px 20px; background:#1BC5BD; border:none; color:#fff; border-radius:12px; font-size:24px; font-weight:800; cursor:pointer;">';
            html += '<i class="fas fa-check" style="display:block; font-size:36px; margin-bottom:8px;"></i>VERO</button>';
            html += '<button class="quiz-doc-vf" data-val="false" style="flex:1; padding:40px 20px; background:#F64E60; border:none; color:#fff; border-radius:12px; font-size:24px; font-weight:800; cursor:pointer;">';
            html += '<i class="fas fa-times" style="display:block; font-size:36px; margin-bottom:8px;"></i>FALSO</button>';
            html += '</div>';
        }
        else if (tipo === 'aperta') {
            html += '<textarea id="quizDocAperta" placeholder="Scrivi la tua risposta..." style="width:100%; min-height:140px; padding:14px; background:#2d2d3f; border:2px solid #3d3d56; color:#fff; border-radius:8px; font-size:14px; font-family:Inter,Poppins,sans-serif; outline:none; resize:vertical;"></textarea>';
            html += '<div style="margin-top:10px; padding:10px 14px; background:rgba(255,168,0,0.15); border-left:3px solid #FFA800; border-radius:6px; color:#FFA800; font-size:11px;">';
            html += '<i class="fas fa-info-circle" style="margin-right:4px;"></i> Questa risposta sara valutata manualmente dal docente.</div>';
            html += '<button id="quizDocConfirm" style="width:100%; margin-top:14px; padding:14px; background:#1BC5BD; border:none; color:#fff; border-radius:8px; font-size:15px; font-weight:700; cursor:pointer;">Invia risposta</button>';
        }
        else if (tipo === 'ordinamento') {
            html += '<div style="color:#a2a3b7; font-size:11px; text-align:center; margin-bottom:10px;">Trascina per riordinare</div>';
            html += '<div id="quizDocOrderList" style="display:flex; flex-direction:column; gap:8px;">';
            for (let i = 0; i < dom.opzioni.length; i++) {
                html += '<div class="quiz-doc-order-item" draggable="true" data-idx="' + i + '" style="display:flex; align-items:center; gap:12px; padding:14px; background:#2d2d3f; border:2px solid #3d3d56; border-radius:8px; cursor:grab; color:#fff;">';
                html += '<span style="color:#8950FC; font-size:16px;"><i class="fas fa-grip-vertical"></i></span>';
                html += '<span class="order-num" style="width:28px; height:28px; border-radius:50%; background:#8950FC; color:#fff; font-size:12px; font-weight:700; display:flex; align-items:center; justify-content:center; flex-shrink:0;">' + (i + 1) + '</span>';
                html += '<span style="flex:1; font-size:14px;">' + this.escHtml(dom.opzioni[i]) + '</span>';
                html += '</div>';
            }
            html += '</div>';
            html += '<button id="quizDocConfirm" style="width:100%; margin-top:14px; padding:14px; background:#1BC5BD; border:none; color:#fff; border-radius:8px; font-size:15px; font-weight:700; cursor:pointer;">Conferma ordine</button>';
        }
        else if (tipo === 'abbinamento') {
            html += '<div style="display:flex; gap:10px; margin-bottom:8px;">';
            html += '<div style="flex:1; color:#8950FC; font-size:10px; font-weight:700; text-transform:uppercase;">Elemento A</div>';
            html += '<div style="width:30px;"></div>';
            html += '<div style="flex:1; color:#8950FC; font-size:10px; font-weight:700; text-transform:uppercase;">Abbinalo a</div>';
            html += '</div>';
            for (let i = 0; i < dom.opzioni.length; i++) {
                const coppia = dom.opzioni[i];
                html += '<div class="match-row" style="display:flex; gap:10px; margin-bottom:8px; align-items:center;">';
                html += '<div style="flex:1; padding:12px; background:#2d2d3f; border:1px solid #3d3d56; border-radius:6px; color:#fff; font-size:13px;">' + this.escHtml(coppia[0]) + '</div>';
                html += '<i class="fas fa-arrows-alt-h" style="color:#6c7293; font-size:14px; width:30px; text-align:center;"></i>';
                html += '<select class="quiz-doc-match" data-idx="' + i + '" style="flex:1; padding:12px; background:#2d2d3f; border:2px solid #3d3d56; color:#fff; border-radius:6px; font-size:13px; font-family:Inter,Poppins,sans-serif;">';
                html += '<option value="">-- Seleziona --</option>';
                // Lista shuffled di tutti gli elementi B
                const bList = dom.opzioni.map((p: any[], idx: number) => ({ txt: p[1], idx: idx }));
                // Shuffle semplice
                const shuffled = bList.slice().sort(() => Math.random() - 0.5);
                for (const item of shuffled) {
                    html += '<option value="' + item.idx + '">' + this.escHtml(item.txt) + '</option>';
                }
                html += '</select>';
                html += '</div>';
            }
            html += '<button id="quizDocConfirm" style="width:100%; margin-top:14px; padding:14px; background:#1BC5BD; border:none; color:#fff; border-radius:8px; font-size:15px; font-weight:700; cursor:pointer;">Conferma abbinamenti</button>';
        }

        return html;
    }

    /**
     * Bind event handlers per il tipo di domanda corrente.
     */
    bindQuizDocenteHandlers(dom: any) {
        const tipo = dom.tipo;
        const self = this;

        if (tipo === 'multipla') {
            const btns = document.querySelectorAll('.quiz-doc-opt');
            btns.forEach((btn: HTMLElement) => {
                btn.addEventListener('click', () => {
                    const idx = parseInt(btn.getAttribute('data-idx') || '0');
                    self.quizDocTempRisposta = idx;
                    // Highlight
                    btns.forEach((b: HTMLElement) => { b.style.opacity = '0.4'; });
                    btn.style.opacity = '1';
                    btn.style.border = '3px solid #fff';
                    setTimeout(() => { self.submitQuizDocenteAnswer(dom); }, 300);
                });
            });
        }
        else if (tipo === 'multi') {
            self.quizDocTempRisposta = [];
            const btns = document.querySelectorAll('.quiz-doc-multi');
            btns.forEach((btn: HTMLElement) => {
                btn.addEventListener('click', () => {
                    const idx = parseInt(btn.getAttribute('data-idx') || '0');
                    const arr = self.quizDocTempRisposta as number[];
                    const pos = arr.indexOf(idx);
                    const iconEl = btn.querySelector('.check-icon') as HTMLElement;
                    if (pos === -1) {
                        arr.push(idx);
                        btn.style.border = '3px solid #fff';
                        if (iconEl) iconEl.style.background = '#fff';
                    } else {
                        arr.splice(pos, 1);
                        btn.style.border = '3px solid transparent';
                        if (iconEl) iconEl.style.background = 'transparent';
                    }
                });
            });
            const confirm = document.getElementById('quizDocConfirm');
            if (confirm) confirm.addEventListener('click', () => self.submitQuizDocenteAnswer(dom));
        }
        else if (tipo === 'vf') {
            const btns = document.querySelectorAll('.quiz-doc-vf');
            btns.forEach((btn: HTMLElement) => {
                btn.addEventListener('click', () => {
                    const val = btn.getAttribute('data-val') === 'true';
                    self.quizDocTempRisposta = val;
                    btns.forEach((b: HTMLElement) => { b.style.opacity = '0.4'; });
                    btn.style.opacity = '1';
                    btn.style.border = '4px solid #fff';
                    setTimeout(() => { self.submitQuizDocenteAnswer(dom); }, 300);
                });
            });
        }
        else if (tipo === 'aperta') {
            const confirm = document.getElementById('quizDocConfirm');
            if (confirm) confirm.addEventListener('click', () => {
                const ta = document.getElementById('quizDocAperta') as HTMLTextAreaElement;
                self.quizDocTempRisposta = ta ? ta.value : '';
                self.submitQuizDocenteAnswer(dom);
            });
        }
        else if (tipo === 'ordinamento') {
            // Init con ordine visualizzato (0..n)
            self.quizDocTempRisposta = dom.opzioni.map((_: any, i: number) => i);
            // HTML5 drag&drop (desktop), touch fallback omesso per semplicità
            const items = document.querySelectorAll('.quiz-doc-order-item');
            let dragSrc: HTMLElement | null = null;
            items.forEach((item: HTMLElement) => {
                item.addEventListener('dragstart', (e: DragEvent) => { dragSrc = item; });
                item.addEventListener('dragover', (e: DragEvent) => { e.preventDefault(); });
                item.addEventListener('drop', (e: DragEvent) => {
                    e.preventDefault();
                    if (!dragSrc || dragSrc === item) return;
                    const list = document.getElementById('quizDocOrderList');
                    if (!list) return;
                    const children = Array.from(list.children);
                    const srcPos = children.indexOf(dragSrc);
                    const dstPos = children.indexOf(item);
                    if (srcPos < dstPos) {
                        list.insertBefore(dragSrc, item.nextSibling);
                    } else {
                        list.insertBefore(dragSrc, item);
                    }
                    // Aggiorna temp e numeri
                    const newChildren = Array.from(list.children) as HTMLElement[];
                    const newOrder = newChildren.map((el: HTMLElement) => parseInt(el.getAttribute('data-idx') || '0'));
                    self.quizDocTempRisposta = newOrder;
                    newChildren.forEach((el: HTMLElement, i: number) => {
                        const numEl = el.querySelector('.order-num') as HTMLElement;
                        if (numEl) numEl.textContent = String(i + 1);
                    });
                });
            });
            const confirm = document.getElementById('quizDocConfirm');
            if (confirm) confirm.addEventListener('click', () => self.submitQuizDocenteAnswer(dom));
        }
        else if (tipo === 'abbinamento') {
            self.quizDocTempRisposta = {};
            const selects = document.querySelectorAll('.quiz-doc-match');
            selects.forEach((sel: HTMLSelectElement) => {
                sel.addEventListener('change', () => {
                    const idx = parseInt(sel.getAttribute('data-idx') || '0');
                    (self.quizDocTempRisposta as any)[idx] = sel.value;
                });
            });
            const confirm = document.getElementById('quizDocConfirm');
            if (confirm) confirm.addEventListener('click', () => self.submitQuizDocenteAnswer(dom));
        }
    }

    /**
     * Invia la risposta del corsista al server e avanza.
     */
    submitQuizDocenteAnswer(dom: any) {
        clearInterval(this.quizDocTimerInterval);
        const tempoMs = Date.now() - this.quizDocStartTime;
        const risposta = this.quizDocTempRisposta;

        const fb = document.getElementById('quizDocFeedback');
        if (fb) {
            fb.style.display = 'block';
            fb.innerHTML = '<div style="color:#a2a3b7; font-size:14px;">Invio risposta...</div>';
        }

        const baseUrl = environment.urlWeb || '/';
        const formData = new FormData();
        formData.append('idQuiz', String(this.quizDocIdQuiz));
        formData.append('idDomanda', String(dom.id));
        formData.append('idCorsista', this.idCorsista);
        formData.append('nomeCorsista', this.nomeCognomeCorsista || '');
        formData.append('tempoMs', String(tempoMs));
        formData.append('risposta', JSON.stringify(risposta));

        const self = this;
        fetch(baseUrl + 'api/quiz-docente-rispondi.php', {
            method: 'POST',
            body: formData
        })
        .then(resp => resp.json())
        .then(result => {
            if (fb) {
                if (!result.success) {
                    fb.innerHTML = '<div style="color:#F64E60; font-size:14px;">' + (result.error || result.message || 'Errore') + '</div>';
                } else if (result.isCorretta === null || result.isCorretta === undefined) {
                    // Risposta aperta: in attesa di valutazione manuale dal docente
                    fb.innerHTML = '<div style="color:#FFA800; font-size:20px; font-weight:800;"><i class="fas fa-hourglass-half" style="margin-right:6px;"></i>Risposta inviata</div>' +
                        '<div style="color:#a2a3b7; font-size:13px; font-weight:500; margin-top:4px;">In attesa di valutazione dal docente</div>';
                } else if (result.isCorretta === 1 || result.isCorretta === true) {
                    self.quizDocTotalCorrette++;
                    self.quizDocTotalPunteggio += (result.punteggio || 0);
                    fb.innerHTML = '<div style="color:#1BC5BD; font-size:22px; font-weight:800;">&#10003; Corretto!</div>' +
                        '<div style="color:#FFA800; font-size:16px; font-weight:600; margin-top:4px;">+' + result.punteggio + ' punti</div>';
                } else {
                    fb.innerHTML = '<div style="color:#F64E60; font-size:22px; font-weight:800;">&#10007; Sbagliato</div>';
                }
            }
            self.quizDocCurrentIndex++;
            setTimeout(() => { self.quizDocenteNext(); }, 2000);
        })
        .catch(() => {
            if (fb) fb.innerHTML = '<div style="color:#F64E60; font-size:14px;">Errore di connessione</div>';
            self.quizDocCurrentIndex++;
            setTimeout(() => { self.quizDocenteNext(); }, 2000);
        });
    }

    /**
     * Mostra il summary personale al termine del quiz docente.
     */
    showQuizDocenteSummary() {
        clearInterval(this.quizDocTimerInterval);
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        const total = this.quizDocAllDomande.length;
        const pct = total > 0 ? Math.round((this.quizDocTotalCorrette / total) * 100) : 0;
        const emoji = pct >= 80 ? '&#127942;' : pct >= 50 ? '&#128077;' : '&#128170;';

        let html = '<div style="font-size:48px; margin-bottom:12px;">' + emoji + '</div>';
        html += '<div style="color:#FFA800; font-size:20px; font-weight:800; text-transform:uppercase; margin-bottom:8px;">Quiz Completato!</div>';
        html += '<div style="color:#fff; font-size:14px; margin-bottom:16px; opacity:0.7;">' + this.escHtml(this.quizDocTitolo) + '</div>';
        html += '<div style="color:#fff; font-size:32px; font-weight:800; margin-bottom:4px;">' + this.quizDocTotalPunteggio + ' <span style="font-size:16px;color:#a2a3b7;">punti</span></div>';
        html += '<div style="color:#a2a3b7; font-size:16px; margin-bottom:24px;">' + this.quizDocTotalCorrette + '/' + total + ' risposte corrette (' + pct + '%)</div>';

        const barColor = pct >= 80 ? '#1BC5BD' : pct >= 50 ? '#FFA800' : '#F64E60';
        html += '<div style="width:100%; max-width:300px; height:8px; background:#2d2d3f; border-radius:4px; overflow:hidden; margin-bottom:20px;">';
        html += '<div style="width:' + pct + '%; height:100%; background:' + barColor + '; border-radius:4px; transition:width 1s ease;"></div>';
        html += '</div>';
        html += '<div style="color:#6c7293; font-size:13px;">In attesa della classifica dal docente...</div>';

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Auto-remove dopo 90s se non arriva leaderboard
        setTimeout(() => {
            const el = document.getElementById('quizOverlay');
            if (el) el.remove();
            this.stopQuizDocSummaryPolling();
        }, 90000);

        // Watchdog docente: polling ogni 5s allo stato del quiz. Se il server
        // risponde `docente_offline` (heartbeat scaduto = docente caduto dalla
        // rete / uscito dall'aula) chiudiamo l'overlay per NON lasciare il
        // corsista bloccato sulla schermata "In attesa della classifica...".
        // Se il quiz e' effettivamente terminato (finished) o il docente e'
        // uscito, il corsista deve poter tornare alla lezione.
        this.startQuizDocSummaryPolling();

        // Reset dell'idQuiz cosi' un rilancio legittimo dello stesso quiz
        // (idQuiz uguale) a distanza di tempo NON viene bloccato dalla guardia
        // di dedup in handleQuizDocenteSync. Le domande restano per il render.
        this.quizDocIdQuiz = 0;
    }

    /**
     * Watchdog "in attesa classifica" per Quiz Docente: se il docente cade
     * (heartbeat scaduto lato server), l'overlay resterebbe bloccato per 90s.
     * Con questo polling lo chiudiamo entro ~5s dal disconnect docente.
     *
     * ATTENZIONE al race con il broadcast leaderboard: il .then() delle fetch
     * in volo controlla `_quizDocSummaryPollAlive`. Senza il flag, quando
     * arriva il leaderboard e chiamiamo stopQuizDocSummaryPolling(), la
     * fetch gia' partita continua fino alla response e cancellerebbe
     * l'overlay leaderboard appena creato (bug osservato: corsista Balzano
     * non vede la classifica mentre l'altro corsista si').
     */
    startQuizDocSummaryPolling() {
        this.stopQuizDocSummaryPolling();
        if (!this.idCorsoSvolgimento || !this.idCorsista) return;
        this._quizDocSummaryPollAlive = true;
        const startedAt = Date.now();
        let offlineStreak = 0;
        this.quizDocSummaryPollInterval = setInterval(() => {
            if (!this._quizDocSummaryPollAlive) return;
            // Regole conservative (vedi startQuizSummaryPolling):
            //  - Grace period 10s
            //  - NON chiude per `!reason` (attende broadcast leaderboard)
            //  - `docente_offline` richiede 2 tick consecutivi
            const inGrace = (Date.now() - startedAt) < 10000;
            const baseUrl = environment.urlWeb || '/';
            const formData = new FormData();
            formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
            formData.append('idCorsista', this.idCorsista);
            fetch(baseUrl + 'api/quiz-docente-attivo.php', { method: 'POST', body: formData })
                .then(r => r.json())
                .then(res => {
                    if (!this._quizDocSummaryPollAlive) return;
                    if (!res || !res.success) return;
                    if (res.reason === 'docente_offline') {
                        offlineStreak++;
                        if (!inGrace && offlineStreak >= 2) {
                            const el = document.getElementById('quizOverlay');
                            if (el) el.remove();
                            this.stopQuizDocSummaryPolling();
                            this.showQuizNotification('Docente disconnesso — quiz interrotto');
                        }
                    } else {
                        offlineStreak = 0;
                    }
                })
                .catch(() => { /* errore rete: continua a pollare */ });
        }, 5000);
    }

    stopQuizDocSummaryPolling() {
        this._quizDocSummaryPollAlive = false;
        if (this.quizDocSummaryPollInterval) {
            clearInterval(this.quizDocSummaryPollInterval);
            this.quizDocSummaryPollInterval = null;
        }
    }
    private _quizDocSummaryPollAlive: boolean = false;

    /**
     * Mostra la classifica finale ricevuta dal docente.
     */
    showQuizDocenteLeaderboard(data: any) {
        // Ferma il watchdog PRIMA di ricreare l'overlay: evita race con la
        // fetch in volo che chiuderebbe l'overlay leaderboard appena creato.
        this.stopQuizDocSummaryPolling();
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        const classifica = data.classifica || [];
        let html = '<div style="color:#FFA800; font-size:22px; font-weight:800; text-transform:uppercase; margin-bottom:20px;">&#127942; Classifica finale</div>';
        html += '<div style="width:100%; max-width:500px; background:#1b1b28; border-radius:12px; padding:16px;">';

        if (!classifica.length) {
            html += '<div style="color:#a2a3b7; text-align:center; padding:20px;">Nessun partecipante</div>';
        } else {
            for (let i = 0; i < Math.min(classifica.length, 10); i++) {
                const c = classifica[i];
                const rank = i + 1;
                const medal = rank === 1 ? '&#129351;' : rank === 2 ? '&#129352;' : rank === 3 ? '&#129353;' : rank + '.';
                const isMe = parseInt(c.id_corsista) === parseInt(this.idCorsista);
                const bg = isMe ? 'rgba(27,197,189,0.15)' : 'transparent';
                html += '<div style="display:flex; align-items:center; gap:10px; padding:10px; background:' + bg + '; border-bottom:1px solid rgba(255,255,255,0.06);">';
                html += '<span style="width:30px; text-align:center; font-size:16px;">' + medal + '</span>';
                html += '<span style="flex:1; color:#fff; font-size:14px;">' + this.escHtml(c.nome_corsista || ('#' + c.id_corsista)) + '</span>';
                html += '<span style="color:#1BC5BD; font-size:16px; font-weight:800;">' + c.punteggio_totale + '</span>';
                html += '</div>';
            }
        }

        html += '</div>';
        html += '<button onclick="document.getElementById(\'quizOverlay\').remove();" style="margin-top:20px; padding:12px 32px; background:#8950FC; border:none; color:#fff; border-radius:8px; font-size:14px; font-weight:600; cursor:pointer;">Chiudi</button>';

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Ferma il watchdog: la leaderboard e' arrivata, non serve piu' controllare.
        this.stopQuizDocSummaryPolling();

        // Reset stato quiz docente
        this.quizDocAllDomande = [];
        this.quizDocIdQuiz = 0;
    }

    // ---- Pausa countdown dal docente ----
    _pausaCountdownInterval: any = null;
    _pausaEndTime: number = 0;
    _pausaTotalSec: number = 0;

    handlePausaSync(msg: any) {
        const type = msg.type;
        const data = msg.data || {};
        console.log('[Pausa] Sync ricevuto:', type, data);

        if (type === 'start') {
            this._pausaTotalSec = data.totalSec || (data.durata || 0) * 60;
            this._pausaEndTime = Date.now() + this._pausaTotalSec * 1000;
            this.startPausaCountdownUI();
        } else if (type === 'update') {
            // Re-sync dal docente
            const remaining = data.remaining || 0;
            this._pausaTotalSec = data.totalSec || this._pausaTotalSec;
            this._pausaEndTime = Date.now() + remaining * 1000;
            if (!this._pausaCountdownInterval) {
                this.startPausaCountdownUI();
            }
        } else if (type === 'stop') {
            this.stopPausaCountdownUI();
        }
    }

    startPausaCountdownUI() {
        // Mostra/aggiorna timer nella slide pausa se visibile
        if (this._pausaCountdownInterval) clearInterval(this._pausaCountdownInterval);

        const updateTimer = () => {
            const el = document.getElementById('corsistaPausaTimer');
            const barEl = document.getElementById('corsistaPausaBarFill');
            const wrap = document.getElementById('corsistaPausaCountdownWrap');
            // Mostra wrap ad ogni tick (il polling ri-renderizza la slide e resetta display:none)
            if (wrap) wrap.style.display = 'block';
            if (!el) return;
            const remaining = Math.max(0, Math.round((this._pausaEndTime - Date.now()) / 1000));
            const m = Math.floor(remaining / 60);
            const s = remaining % 60;
            const txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
            const pct = this._pausaTotalSec > 0 ? (remaining / this._pausaTotalSec) * 100 : 0;
            el.textContent = txt;
            el.style.color = pct < 20 ? '#F64E60' : '#FFA800';
            if (barEl) {
                barEl.style.width = pct + '%';
                barEl.style.background = pct < 20 ? '#F64E60' : '#FFA800';
            }
            if (remaining <= 0) {
                this.stopPausaCountdownUI();
            }
        };

        updateTimer();
        this._pausaCountdownInterval = setInterval(updateTimer, 1000);
    }

    stopPausaCountdownUI() {
        if (this._pausaCountdownInterval) {
            clearInterval(this._pausaCountdownInterval);
            this._pausaCountdownInterval = null;
        }
        const el = document.getElementById('corsistaPausaTimer');
        if (el) el.textContent = '00:00';
        const wrap = document.getElementById('corsistaPausaCountdownWrap');
        if (wrap) wrap.style.display = 'none';
    }

    handleQuizSync(msg: any) {
        const type = msg.type;
        const data = msg.data;
        console.log('[Quiz] Sync ricevuto:', type);

        if (type === 'quiz-autonomous') {
            // Dedup con time-window 30s: rebroadcast Jitsi arriva in ms, un rilancio
            // intenzionale del docente (Termina + Avvia) impiega almeno alcuni secondi.
            // Bug cliente AssOAFoP: senza guardia, un rilancio ravvicinato resettava
            // lo stato del corsista → sfarfallio + progresso perso.
            const nowTs = Date.now();
            if (this.quizIdQuiz === data.idQuiz &&
                this.quizAllDomande && this.quizAllDomande.length > 0 &&
                (nowTs - this.quizLastSyncAt) < 30000) {
                console.log('[Quiz] Ignoro rebroadcast idQuiz=' + data.idQuiz + ' (entro 30s)');
                return;
            }
            this.quizLastSyncAt = nowTs;
            // Modalità autonoma: riceve tutte le domande e procede da solo
            this.quizIdQuiz = data.idQuiz;
            this.quizAllDomande = data.domande || [];
            this.quizCurrentIndex = 0;
            this.quizTotalCorrette = 0;
            this.quizTotalPunteggio = 0;
            this.stopQuizAttivoPolling();
            this.showQuizNotification('Quiz: ' + (data.titolo || 'Live Quiz') + ' (' + data.totaleDomande + ' domande)');
            // Avvia la prima domanda dopo 2 secondi (tempo di leggere la notifica)
            setTimeout(() => { this.quizAutonomousNext(); }, 2000);
        }
        else if (type === 'quiz-start') {
            this.quizIdQuiz = data.idQuiz;
            this.showQuizNotification('Quiz: ' + (data.titolo || 'Live Quiz') + ' (' + data.totaleDomande + ' domande)');
        }
        else if (type === 'question') {
            if (data.idQuiz && (!this.quizIdQuiz || this.quizIdQuiz === 0)) {
                this.quizIdQuiz = data.idQuiz;
            }
            const domId = data.domanda ? data.domanda.id : 0;
            if (domId && domId === this.quizCurrentDomandaId) return;
            this.quizCurrentDomandaId = domId;
            if (this.quizResultsTimeout) {
                clearTimeout(this.quizResultsTimeout);
                this.quizResultsTimeout = null;
            }
            this.showQuizQuestion(data);
        }
        else if (type === 'results') {
            this.quizCurrentDomandaId = 0;
            this.showQuizResults(data);
        }
        else if (type === 'leaderboard') {
            if (this.quizResultsTimeout) {
                clearTimeout(this.quizResultsTimeout);
                this.quizResultsTimeout = null;
            }
            this.showQuizLeaderboard(data);
        }
    }

    /**
     * Flusso autonomo: mostra la prossima domanda dalla lista locale.
     */
    quizAutonomousNext() {
        if (this.quizCurrentIndex >= this.quizAllDomande.length) {
            // Quiz completato - mostra summary personale
            this.showQuizSummary();
            return;
        }

        const dom = this.quizAllDomande[this.quizCurrentIndex];
        const num = this.quizCurrentIndex + 1;
        const total = this.quizAllDomande.length;

        this.showQuizQuestion({
            domanda: dom,
            domandaNum: num,
            totaleDomande: total
        });
    }

    /**
     * Mostra il riepilogo personale a fine quiz autonomo.
     */
    showQuizSummary() {
        clearInterval(this.quizTimerInterval);
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        const total = this.quizAllDomande.length;
        const pct = total > 0 ? Math.round((this.quizTotalCorrette / total) * 100) : 0;
        const emoji = pct >= 80 ? '&#127942;' : pct >= 50 ? '&#128077;' : '&#128170;';

        let html = '<div style="font-size:48px; margin-bottom:12px;">' + emoji + '</div>';
        html += '<div style="color:#FFA800; font-size:20px; font-weight:800; text-transform:uppercase; margin-bottom:8px;">Quiz Completato!</div>';
        html += '<div style="color:#fff; font-size:32px; font-weight:800; margin-bottom:4px;">' + this.quizTotalPunteggio + ' <span style="font-size:16px;color:#a2a3b7;">punti</span></div>';
        html += '<div style="color:#a2a3b7; font-size:16px; margin-bottom:24px;">' + this.quizTotalCorrette + '/' + total + ' risposte corrette (' + pct + '%)</div>';

        // Barra progresso
        const barColor = pct >= 80 ? '#1BC5BD' : pct >= 50 ? '#FFA800' : '#F64E60';
        html += '<div style="width:100%; max-width:300px; height:8px; background:#2d2d3f; border-radius:4px; overflow:hidden; margin-bottom:20px;">';
        html += '<div style="width:' + pct + '%; height:100%; background:' + barColor + '; border-radius:4px; transition:width 1s ease;"></div>';
        html += '</div>';

        html += '<div style="color:#6c7293; font-size:13px;">In attesa della classifica dal docente...</div>';

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Auto-rimuovi dopo 60 secondi come fallback
        this.quizResultsTimeout = setTimeout(() => {
            const el = document.getElementById('quizOverlay');
            if (el) el.remove();
            this.stopQuizSummaryPolling();
        }, 60000);

        // Watchdog docente (stesso pattern del Quiz Docente): se il docente
        // cade / il quiz e' terminato lato server, chiudiamo l'overlay senza
        // aspettare i 60s del fallback.
        this.startQuizSummaryPolling();

        // Reset dell'idQuiz cosi' un rilancio legittimo dello stesso quiz
        // (idQuiz uguale) a distanza di tempo NON viene bloccato dalla guardia
        // di dedup in handleQuizSync. Le domande restano per il render del summary.
        this.quizIdQuiz = 0;
    }

    /**
     * Watchdog "in attesa classifica" per Live Quiz (analogo Quiz Docente).
     * Regole conservative per NON chiudere l'overlay in maniera aggressiva:
     *  1. Grace period di 10s dallo start (evita transitori all'apertura).
     *  2. NON chiude per `!res.reason` (quiz terminato lato server): il canale
     *     canonico e' il broadcast `leaderboard`; se questo non arriva, il
     *     fallback di 60s in showQuizSummary pulisce l'overlay.
     *  3. Richiede 2 tick consecutivi di `docente_offline` (~10s) prima di
     *     chiudere: gestisce Chrome throttle del tab docente.
     *
     * Vedi commento su startQuizDocSummaryPolling per il race con leaderboard.
     */
    startQuizSummaryPolling() {
        this.stopQuizSummaryPolling();
        if (!this.idCorsoSvolgimento || !this.idCorsista) return;
        this._quizSummaryPollAlive = true;
        const startedAt = Date.now();
        let offlineStreak = 0;
        this.quizSummaryPollInterval = setInterval(() => {
            if (!this._quizSummaryPollAlive) return;
            // Grace period: nei primi 10s dopo l'apertura del summary, non
            // chiudere nulla (evita di reagire a transitori di join/heartbeat).
            const inGrace = (Date.now() - startedAt) < 10000;
            const baseUrl = environment.urlWeb || '/';
            const formData = new FormData();
            formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
            formData.append('idCorsista', this.idCorsista);
            fetch(baseUrl + 'api/quiz-attivo.php', { method: 'POST', body: formData })
                .then(r => r.json())
                .then(res => {
                    if (!this._quizSummaryPollAlive) return;
                    if (!res || !res.success) return;
                    if (res.reason === 'docente_offline') {
                        offlineStreak++;
                        if (!inGrace && offlineStreak >= 2) {
                            const el = document.getElementById('quizOverlay');
                            if (el) el.remove();
                            this.stopQuizSummaryPolling();
                            this.showQuizNotification('Docente disconnesso — quiz interrotto');
                        }
                    } else {
                        // Docente vivo (quizAttivo:true, o quizAttivo:false con
                        // `already_completed`, o quiz finished senza reason).
                        // In tutti questi casi mantieni l'overlay: il broadcast
                        // leaderboard e' il canale canonico per chiuderlo.
                        offlineStreak = 0;
                    }
                })
                .catch(() => { /* errore rete: continua a pollare */ });
        }, 5000);
    }

    stopQuizSummaryPolling() {
        this._quizSummaryPollAlive = false;
        if (this.quizSummaryPollInterval) {
            clearInterval(this.quizSummaryPollInterval);
            this.quizSummaryPollInterval = null;
        }
    }
    private _quizSummaryPollAlive: boolean = false;

    showQuizNotification(text: string) {
        const existing = document.getElementById('quizNotification');
        if (existing) existing.remove();

        const notif = document.createElement('div');
        notif.id = 'quizNotification';
        notif.style.cssText = 'position:fixed; top:50px; left:50%; transform:translateX(-50%); z-index:10010; background:#8950FC; color:#fff; padding:12px 24px; border-radius:12px; font-size:14px; font-weight:600; font-family:Inter,Poppins,sans-serif; box-shadow:0 8px 24px rgba(0,0,0,0.3); animation:quizFadeIn 0.3s ease;';
        notif.textContent = text;
        document.body.appendChild(notif);

        // Aggiungi animazione CSS
        if (!document.getElementById('quizAnimStyles')) {
            const style = document.createElement('style');
            style.id = 'quizAnimStyles';
            style.textContent = `
                @keyframes quizFadeIn { from { opacity:0; transform:translateX(-50%) translateY(-20px); } to { opacity:1; transform:translateX(-50%) translateY(0); } }
                @keyframes quizPulse { 0%,100% { transform:scale(1); } 50% { transform:scale(1.05); } }
            `;
            document.head.appendChild(style);
        }

        setTimeout(() => { if (notif.parentNode) notif.remove(); }, 4000);
    }

    showQuizQuestion(data: any) {
        // Clear del timer precedente (difensivo): senza questo, se showQuizQuestion viene
        // chiamata piu' volte in rapida successione (es. rebroadcast quiz-autonomous),
        // si accumulano setInterval paralleli che tickano tutti su #quizTimer e al remaining<=0
        // scattano piu' auto-submit consecutivi -> quizCurrentIndex sfora -> 0/10 nel summary.
        if (this.quizTimerInterval) {
            clearInterval(this.quizTimerInterval);
            this.quizTimerInterval = null;
        }
        const dom = data.domanda;
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        this.quizStartTime = Date.now();
        const tempoSec = dom.tempo_secondi || 20;

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        // Header con counter e timer
        let html = '<div style="text-align:center; margin-bottom:20px; width:100%; max-width:700px;">';
        html += '<div style="color:#8950FC; font-size:12px; font-weight:700; text-transform:uppercase; margin-bottom:6px;">Domanda ' + data.domandaNum + ' / ' + data.totaleDomande + '</div>';
        html += '<div id="quizTimer" style="color:#FFA800; font-size:24px; font-weight:800; margin-bottom:12px;">' + tempoSec + '</div>';
        html += '<div id="quizTimerBar" style="width:100%; height:4px; background:#2d2d3f; border-radius:2px; overflow:hidden;"><div id="quizTimerFill" style="width:100%; height:100%; background:#FFA800; transition:width 1s linear;"></div></div>';
        html += '</div>';

        // Domanda
        html += '<div style="color:#fff; font-size:22px; font-weight:700; text-align:center; margin-bottom:30px; max-width:700px; line-height:1.3;">' + this.escHtml(dom.testo) + '</div>';

        // Risposte (grid 2x2)
        html += '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px; width:100%; max-width:700px;">';
        const shapes = ['&#9650;', '&#9670;', '&#9679;', '&#9632;']; // triangolo, diamante, cerchio, quadrato
        for (let i = 0; i < dom.risposte.length; i++) {
            const r = dom.risposte[i];
            html += '<button class="quiz-answer-btn" data-risposta-id="' + r.id_live_quiz_risposta + '" style="background:' + r.colore + '; border:none; color:#fff; padding:20px 16px; border-radius:8px; font-size:16px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:10px; transition:all 0.2s; min-height:60px;">';
            html += '<span style="font-size:20px;">' + shapes[i % 4] + '</span>';
            html += '<span style="flex:1; text-align:left;">' + this.escHtml(r.testo) + '</span>';
            html += '</button>';
        }
        html += '</div>';

        // Feedback area (nascosta, mostrata dopo risposta)
        html += '<div id="quizFeedback" style="display:none; margin-top:20px; text-align:center;"></div>';

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Click handler per risposte
        const self = this;
        const buttons = overlay.querySelectorAll('.quiz-answer-btn');
        buttons.forEach((btn: HTMLElement) => {
            btn.addEventListener('click', () => {
                const idRisposta = parseInt(btn.getAttribute('data-risposta-id') || '0');
                self.submitQuizAnswer(dom.id, idRisposta, buttons);
            });
        });

        // Timer countdown
        let remaining = tempoSec;
        this.quizTimerInterval = setInterval(() => {
            remaining--;
            const timerEl = document.getElementById('quizTimer');
            const fillEl = document.getElementById('quizTimerFill');
            if (timerEl) timerEl.textContent = String(remaining);
            if (fillEl) fillEl.style.width = (remaining / tempoSec * 100) + '%';

            if (remaining <= 5 && timerEl) timerEl.style.color = '#F64E60';

            if (remaining <= 0) {
                clearInterval(self.quizTimerInterval);
                // Disabilita tutte le risposte
                buttons.forEach((b: HTMLElement) => {
                    b.style.opacity = '0.5';
                    b.style.pointerEvents = 'none';
                });
                const fb = document.getElementById('quizFeedback');
                if (fb) {
                    fb.style.display = 'block';
                    fb.innerHTML = '<div style="color:#F64E60; font-size:18px; font-weight:700;">Tempo scaduto!</div>';
                }
                // In modalità autonoma, avanza dopo 2 secondi
                if (self.quizAllDomande.length > 0) {
                    self.quizCurrentIndex++;
                    setTimeout(() => { self.quizAutonomousNext(); }, 2000);
                }
            }
        }, 1000);
    }

    submitQuizAnswer(idDomanda: number, idRisposta: number, buttons: NodeListOf<Element>) {
        const tempoMs = Date.now() - this.quizStartTime;
        clearInterval(this.quizTimerInterval);
        const isAutonomous = this.quizAllDomande.length > 0;

        // Disabilita tutte le risposte
        buttons.forEach((b: HTMLElement) => {
            b.style.opacity = '0.5';
            b.style.pointerEvents = 'none';
        });

        // Highlight la risposta scelta
        buttons.forEach((b: HTMLElement) => {
            if (parseInt(b.getAttribute('data-risposta-id') || '0') === idRisposta) {
                b.style.opacity = '1';
                b.style.border = '3px solid #fff';
                b.style.boxShadow = '0 0 20px rgba(255,255,255,0.3)';
            }
        });

        const fb = document.getElementById('quizFeedback');
        if (fb) {
            fb.style.display = 'block';
            fb.innerHTML = '<div style="color:#a2a3b7; font-size:14px;">Invio risposta...</div>';
        }

        // Invia risposta al server via HTTP
        const baseUrl = environment.urlWeb || '/';
        const formData = new FormData();
        formData.append('action', 'rispondi');
        formData.append('idQuiz', String(this.quizIdQuiz));
        formData.append('idDomanda', String(idDomanda));
        formData.append('idCorsista', this.idCorsista);
        formData.append('nomeCorsista', this.nomeCognomeCorsista);
        formData.append('idRisposta', String(idRisposta));
        formData.append('tempoMs', String(tempoMs));

        const self = this;

        fetch(baseUrl + 'api/quiz-rispondi.php', {
            method: 'POST',
            body: formData
        })
        .then(resp => resp.json())
        .then(result => {
            if (fb) {
                if (!result.success) {
                    fb.innerHTML = '<div style="color:#a2a3b7; font-size:14px;">' + (result.message || 'Risposta registrata') + '</div>';
                } else if (result.isCorretta === 1 || result.isCorretta === true) {
                    self.quizTotalCorrette++;
                    self.quizTotalPunteggio += (result.punteggio || 0);
                    fb.innerHTML = '<div style="color:#1BC5BD; font-size:22px; font-weight:800;">&#10003; Corretto!</div>' +
                        '<div style="color:#FFA800; font-size:16px; font-weight:600; margin-top:4px;">+' + result.punteggio + ' punti</div>';
                } else {
                    fb.innerHTML = '<div style="color:#F64E60; font-size:22px; font-weight:800;">&#10007; Sbagliato</div>';
                }
            }
            // In modalità autonoma, avanza alla prossima domanda
            if (isAutonomous) {
                self.quizCurrentIndex++;
                setTimeout(() => { self.quizAutonomousNext(); }, 2000);
            }
        })
        .catch(() => {
            if (fb) fb.innerHTML = '<div style="color:#F64E60; font-size:14px;">Errore di connessione</div>';
            // Avanza comunque in modalità autonoma
            if (isAutonomous) {
                self.quizCurrentIndex++;
                setTimeout(() => { self.quizAutonomousNext(); }, 2000);
            }
        });
    }

    showQuizResults(data: any) {
        clearInterval(this.quizTimerInterval);
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        let html = '<div style="color:#FFA800; font-size:14px; font-weight:700; text-transform:uppercase; margin-bottom:16px;">Risultati</div>';
        html += '<div style="color:#a2a3b7; font-size:14px; margin-bottom:20px;">' + data.corrette + '/' + data.totaleRisposte + ' risposte corrette</div>';
        html += '<div style="width:100%; max-width:500px;">';

        const maxCount = Math.max(1, ...data.risposte.map((r: any) => parseInt(r.conteggio)));
        for (const r of data.risposte) {
            const pct = parseInt(r.conteggio) / maxCount * 100;
            const isCorr = parseInt(r.is_corretta) === 1;
            html += '<div style="display:flex; align-items:center; gap:10px; margin-bottom:8px;">';
            html += '<span style="width:16px; height:16px; border-radius:4px; background:' + r.colore + '; flex-shrink:0;"></span>';
            html += '<span style="color:#fff; font-size:13px; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">' + this.escHtml(r.testo) + (isCorr ? ' &#10003;' : '') + '</span>';
            html += '<div style="width:80px; height:8px; background:#2d2d3f; border-radius:4px; overflow:hidden;"><div style="width:' + pct + '%; height:100%; background:' + r.colore + '; border-radius:4px;"></div></div>';
            html += '<span style="color:#fff; font-size:13px; font-weight:700; width:20px; text-align:right;">' + r.conteggio + '</span>';
            html += '</div>';
        }

        html += '</div>';
        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Auto-rimuovi dopo 30 secondi come fallback (il docente controlla il flusso)
        this.quizResultsTimeout = setTimeout(() => { const el = document.getElementById('quizOverlay'); if (el) el.remove(); }, 30000);
    }

    showQuizLeaderboard(data: any) {
        // Ferma il watchdog PRIMA di ricreare l'overlay: cosi' se una fetch
        // del watchdog e' in volo, la sua response non cancellera' l'overlay
        // leaderboard (race osservato: alcuni corsisti perdevano la classifica).
        this.stopQuizSummaryPolling();
        clearInterval(this.quizTimerInterval);
        const existing = document.getElementById('quizOverlay');
        if (existing) existing.remove();

        const overlay = document.createElement('div');
        overlay.id = 'quizOverlay';
        overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; z-index:10010; background:rgba(33,29,56,0.95); display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:Inter,Poppins,sans-serif; padding:20px;';

        let html = '<div style="font-size:40px; margin-bottom:8px;">&#127942;</div>';
        html += '<div style="color:#FFA800; font-size:18px; font-weight:800; text-transform:uppercase; margin-bottom:20px;">Classifica Finale</div>';
        html += '<div style="width:100%; max-width:400px;">';

        const medals = ['&#129351;', '&#129352;', '&#129353;']; // oro, argento, bronzo
        const classifica = data.classifica || [];
        const limit = Math.min(classifica.length, 10);

        // Evidenzia il corsista corrente
        for (let i = 0; i < limit; i++) {
            const c = classifica[i];
            const rank = i + 1;
            const isMe = String(c.id_corsista) === this.idCorsista;
            const bg = isMe ? 'rgba(54,153,255,0.2)' : '#2d2d3f';
            const border = isMe ? 'border:1px solid #3699FF;' : '';
            const medal = rank <= 3 ? medals[i] : String(rank);
            const medalBg = rank <= 3 ? ['#FFA800', '#B5B5C3', '#CD7F32'][i] : '#3d3d56';

            html += '<div style="display:flex; align-items:center; gap:10px; padding:10px 12px; background:' + bg + '; border-radius:8px; margin-bottom:4px; ' + border + '">';
            html += '<span style="width:28px; height:28px; border-radius:50%; background:' + medalBg + '; color:#fff; font-size:13px; font-weight:700; display:flex; align-items:center; justify-content:center; flex-shrink:0;">' + medal + '</span>';
            html += '<span style="color:#fff; font-size:14px; font-weight:' + (isMe ? '700' : '500') + '; flex:1;">' + this.escHtml(c.nome_corsista) + (isMe ? ' (Tu)' : '') + '</span>';
            html += '<span style="color:#FFA800; font-size:14px; font-weight:700;">' + c.punteggio_totale + ' pt</span>';
            html += '</div>';
        }

        html += '</div>';

        // Chiudi button
        html += '<button onclick="document.getElementById(\'quizOverlay\').remove()" style="margin-top:20px; background:#2d2d3f; border:none; color:#a2a3b7; padding:10px 24px; border-radius:8px; font-size:13px; cursor:pointer;">Chiudi</button>';

        overlay.innerHTML = html;
        document.body.appendChild(overlay);

        // Ferma il watchdog: la leaderboard e' arrivata, non serve piu' controllare.
        this.stopQuizSummaryPolling();

        // Reset stato Live Quiz: cosi' un rilancio dello stesso quiz a distanza
        // di tempo NON viene bloccato dalla guardia di dedup in handleQuizSync.
        this.quizAllDomande = [];
        this.quizIdQuiz = 0;
    }

    chiudiMeet() {
        // Pulisci presenter overlay, scheda overlay, scaletta overlay, caso studio e quiz overlay se attivi
        this.hidePresenterOverlay();
        this.hideSchedaOverlay();
        this.hideScalettaOverlay();
        this.hideCasoStudioOverlay();
        this.stopPresenterPolling();
        this.stopSchedaPolling();
        this.stopScalettaPolling();
        this.stopCasoStudioPolling();
        this.stopFlashcardPolling();
        this.stopPresenzaPing();
        this.stopVideoPolling();
        this.stopQuizAttivoPolling();
        this.stopQuizDocenteAttivoPolling();
        this.stopQuizSummaryPolling();
        this.stopQuizDocSummaryPolling();
        clearInterval(this.quizTimerInterval);
        if (this.quizDocTimerInterval) {
            clearInterval(this.quizDocTimerInterval);
            this.quizDocTimerInterval = null;
        }
        const quizOv = document.getElementById('quizOverlay');
        if (quizOv) quizOv.remove();

        var tk=document.getElementById('jitsi-iframe') as HTMLInputElement;
        tk.style.display="none";

        location.reload();
    }

    /**
     * Polling AJAX per lo stato presenter (fallback quando DataChannel non funziona).
     */
    startPresenterPolling() {
        this.stopPresenterPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        console.log('[PresenterPoll] Avvio polling, idCorsoSvolgimento:', this.idCorsoSvolgimento);
        this.presenterPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/presenter-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                console.log('[PresenterPoll] risposta:', resp);
                if (!resp.success) return;

                if (resp.active && resp.state) {
                    const st = resp.state;
                    if (!self.presenterActive) {
                        // Presentazione appena iniziata (o corsista entrato in ritardo)
                        self.presenterActive = true;
                        self.presenterTitolo = st.titolo || 'Presentazione';
                        self.presenterSlideIndex = st.slideIndex || 0;
                        self.presenterTotalSlides = st.totalSlides || 0;
                        self.presenterLastSlideIndex = st.slideIndex;
                        self.presenterPaused = !!(st.paused);
                        self.presenterMuted = !!(st.muted);
                        // Calcola seek: audioTime + secondi trascorsi dal heartbeat
                        const serverAudioTime = parseFloat(st.audioTime) || 0;
                        const serverTs = parseInt(st.ts) || 0;
                        const nowTs = Math.floor(Date.now() / 1000);
                        const seekTime = st.paused ? serverAudioTime : serverAudioTime + (nowTs - serverTs);
                        self.showPresenterOverlay(st.presId, st.presPartner, st.slideIndex, seekTime);
                    } else if (st.slideIndex !== self.presenterLastSlideIndex) {
                        // Slide cambiata
                        self.presenterSlideIndex = st.slideIndex;
                        self.presenterLastSlideIndex = st.slideIndex;
                        self.navigatePresenterSlide(st.slideIndex);
                    }
                    // Gestisci pausa/riprendi
                    const isPaused = !!(st.paused);
                    if (isPaused !== self.presenterPaused) {
                        self.presenterPaused = isPaused;
                        self.presenterSendCommand(isPaused ? 'presenterPause' : 'presenterResume');
                    }
                    // Gestisci mute/unmute
                    const isMuted = !!(st.muted);
                    if (isMuted !== self.presenterMuted) {
                        self.presenterMuted = isMuted;
                        self.presenterSendCommand(isMuted ? 'presenterMute' : 'presenterUnmute');
                    }
                } else if (!resp.active && self.presenterActive) {
                    // Presentazione fermata
                    self.hidePresenterOverlay();
                }
            })
            .catch((err) => { console.warn('[PresenterPoll] errore:', err); });
        }, 3000);
    }

    stopPresenterPolling() {
        if (this.presenterPollingInterval) {
            clearInterval(this.presenterPollingInterval);
            this.presenterPollingInterval = null;
        }
    }

    // =========================================================================
    // SCHEDE DIDATTICHE — Overlay corsista
    // =========================================================================

    private schedaSlides: any[] = [];
    private schedaCurrentIdx: number = 0;

    handleSchedaSync(data: any) {
        if (data.type === 'start' && data.content) {
            this.showSchedaOverlay(data.titolo, data.content);
        } else if (data.type === 'stop') {
            this.hideSchedaOverlay();
        } else if (data.type === 'slide' && typeof data.slideIndex === 'number') {
            this.schedaGoToSlide(data.slideIndex);
        }
    }

    showSchedaOverlay(titolo: string, contentJson: string) {
        const old = document.getElementById('schedaOverlay');
        if (old) old.remove();

        let parsed: any;
        try {
            parsed = JSON.parse(contentJson);
        } catch (e) { return; }

        this.schedaActive = true;
        this.schedaSlides = (parsed.slides && parsed.slides.length) ? parsed.slides : [];
        this.schedaCurrentIdx = 0;

        if (!this.schedaSlides.length) return;

        // --- Inject CSS (una sola volta) ---
        if (!document.getElementById('schedaOverlayStyle')) {
            const style = document.createElement('style');
            style.id = 'schedaOverlayStyle';
            style.textContent = this.getSchedaCSS();
            document.head.appendChild(style);
        }

        // --- Overlay container ---
        const overlay = document.createElement('div');
        overlay.id = 'schedaOverlay';
        overlay.className = 'so-root';

        // Header
        overlay.innerHTML =
            '<div class="so-header">' +
                '<span class="so-header-icon"><i class="fas fa-book-open"></i></span>' +
                '<span class="so-header-title">' + this.escHtml(titolo || parsed.titolo || 'Dispensa') + '</span>' +
                '<span class="so-header-counter" id="soCounter">1 / ' + this.schedaSlides.length + '</span>' +
            '</div>' +
            '<div class="so-body" id="soBody"></div>' +
            '<div class="so-footer">' +
                '<div class="so-dots" id="soDots"></div>' +
            '</div>';

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';

        // Render dots
        this.schedaRenderDots();
        // Render first slide
        this.schedaRenderCurrentSlide();

        // Mostra Jitsi come PiP sopra l'overlay
        this.moveJitsiToPip();
    }

    private schedaGoToSlide(idx: number) {
        if (idx < 0 || idx >= this.schedaSlides.length) return;
        if (idx === this.schedaCurrentIdx) return;
        this.schedaCurrentIdx = idx;
        this.schedaRenderCurrentSlide();
        this.schedaRenderDots();
    }

    private schedaRenderDots() {
        const dotsEl = document.getElementById('soDots');
        if (!dotsEl) return;
        let html = '';
        for (let i = 0; i < this.schedaSlides.length; i++) {
            const cls = i === this.schedaCurrentIdx ? 'so-dot active' : 'so-dot';
            html += '<span class="' + cls + '"></span>';
        }
        dotsEl.innerHTML = html;

        const counter = document.getElementById('soCounter');
        if (counter) counter.textContent = (this.schedaCurrentIdx + 1) + ' / ' + this.schedaSlides.length;
    }

    private schedaRenderCurrentSlide() {
        const body = document.getElementById('soBody');
        if (!body) return;
        const slide = this.schedaSlides[this.schedaCurrentIdx];
        if (!slide) { body.innerHTML = ''; return; }

        let html = '<div class="so-slide">';
        // Titolo slide
        html += '<div class="so-slide-title">' + this.escHtml(slide.titolo || '') + '</div>';

        // Punti
        if (slide.punti && slide.punti.length) {
            const groups = this.schedaGroupPunti(slide.punti);
            groups.forEach((g: any) => {
                html += this.schedaRenderGroup(g);
            });
        }

        // Narrazione (se presente) — con auto-formattazione basata sui punti chiave
        if (slide.narrazione && slide.narrazione.trim()) {
            // Estrai keyword da punti per auto-formattazione
            const highlights: string[] = [];
            const boldWords: string[] = [];
            const stopWords = ['della','delle','dello','degli','nella','nelle','nello','negli','sulla','sulle','sullo','sugli','alla','alle','allo','agli','dalla','dalle','dallo','dagli','come','sono','essere','anche','ogni','questo','questa','questi','queste','quello','quella','quelli','quelle','loro','nostro','nostra','dopo','prima','durante','attraverso','secondo','contro','verso','senza','fino','oltre','circa','alcuni','alcune','molto','molti','tutto','tutti','tutte','dove','quando','perché','cosa','fatto','modo','parte','caso','forma','tipo','base','punto','senso','tale','tali','solo','quindi','però','oppure','infatti','inoltre','tuttavia','comunque','ovvero','cioè'];
            if (slide.punti && slide.punti.length) {
                slide.punti.forEach((p: any) => {
                    const st = (typeof p.sottotitolo === 'string' ? p.sottotitolo : '').trim();
                    if (st.length >= 3 && st.length <= 50 && !highlights.some(h => h.toLowerCase() === st.toLowerCase())) {
                        highlights.push(st);
                    }
                    const txt = (typeof p.testo === 'string' ? p.testo : '');
                    txt.split(/\s+/).forEach((w: string) => {
                        const clean = w.replace(/[^a-zA-ZÀ-ÿ]/g, '');
                        if (clean.length >= 5 && stopWords.indexOf(clean.toLowerCase()) === -1 && !boldWords.some(b => b.toLowerCase() === clean.toLowerCase())) {
                            boldWords.push(clean);
                        }
                    });
                });
            }
            highlights.sort((a, b) => b.length - a.length);
            boldWords.sort((a, b) => b.length - a.length);

            html += '<div class="so-narration">';
            html += '<div class="so-narration-label"><i class="fas fa-book-reader"></i> Approfondimento</div>';
            const sentences = slide.narrazione.split(/(?<=[.!?])\s+/).filter((s: string) => s.trim());
            sentences.forEach((s: string) => {
                html += '<p class="so-narration-text">' + this.autoFormatText(s, boldWords, highlights) + '</p>';
            });
            html += '</div>';
        }

        html += '</div>';
        body.innerHTML = html;
        body.scrollTop = 0;
    }

    // ---- Raggruppamento punti (mirror della logica docente) ----

    private schedaGroupPunti(punti: any[]): any[] {
        const groups: any[] = [];
        const items = punti.map((p: any) => ({
            sub: (typeof p.sottotitolo === 'string' ? p.sottotitolo : (p.sottotitolo ? String(p.sottotitolo) : '')).trim(),
            txt: (typeof p.testo === 'string' ? p.testo : (p.testo ? String(p.testo) : '')).trim()
        }));
        let i = 0;
        while (i < items.length) {
            // Versus: 2+ con stessa label A, poi 2+ con label B
            const vs = this.detectVersus(items, i);
            if (vs) { groups.push(vs.group); i = vs.end; continue; }
            // Compare: coppia Prima/Dopo etc.
            const cmp = this.detectCompare(items, i);
            if (cmp) { groups.push(cmp.group); i = cmp.end; continue; }
            // Legend: 2+ label corte senza/con poco testo
            const leg = this.detectLegend(items, i);
            if (leg) { groups.push(leg.group); i = leg.end; continue; }
            // Barchart: 3+ valori numerici
            const bar = this.detectBarChart(items, i);
            if (bar) { groups.push(bar.group); i = bar.end; continue; }
            // Single
            groups.push({ type: 'single', item: items[i] });
            i++;
        }
        return groups;
    }

    private detectVersus(items: any[], i: number): any {
        if (i >= items.length) return null;
        const labelA = items[i].sub;
        if (!labelA) return null;
        const specialLabels = ['formula', 'nota', 'definizione', 'citazione', 'conclusione', 'approfondimento'];
        if (specialLabels.indexOf(labelA.toLowerCase()) !== -1) return null;
        let j = i;
        const gA: any[] = [];
        while (j < items.length && items[j].sub === labelA) { gA.push(items[j]); j++; }
        if (gA.length < 2 || j >= items.length) return null;
        const labelB = items[j].sub;
        if (!labelB || labelB === labelA) return null;
        const gB: any[] = [];
        while (j < items.length && items[j].sub === labelB) { gB.push(items[j]); j++; }
        if (gB.length < 2) return null;
        return { group: { type: 'versus', labelA, labelB, itemsA: gA, itemsB: gB }, end: j };
    }

    private detectCompare(items: any[], i: number): any {
        if (i + 1 >= items.length) return null;
        const a = items[i], b = items[i + 1];
        if (!a.sub || !b.sub || a.sub === b.sub) return null;
        const pairs = [['prima','dopo'],['before','after'],['causa','effetto'],['problema','soluzione'],['input','output'],['vecchio','nuovo'],['as-is','to-be'],['ieri','oggi'],['domanda','risposta']];
        const aL = a.sub.toLowerCase(), bL = b.sub.toLowerCase();
        const ok = pairs.some(p => (aL.indexOf(p[0]) !== -1 && bL.indexOf(p[1]) !== -1) || (aL.indexOf(p[1]) !== -1 && bL.indexOf(p[0]) !== -1));
        if (!ok) return null;
        return { group: { type: 'compare', a, b }, end: i + 2 };
    }

    private detectLegend(items: any[], i: number): any {
        const legends: any[] = [];
        let j = i;
        while (j < items.length && items[j].sub && items[j].sub.length <= 8 && items[j].txt.length <= 40) {
            legends.push(items[j]); j++;
        }
        if (legends.length < 2) return null;
        return { group: { type: 'legend', items: legends }, end: j };
    }

    private detectBarChart(items: any[], i: number): any {
        const bars: any[] = [];
        let j = i;
        while (j < items.length) {
            const num = this.extractNum(items[j].txt);
            if (num && items[j].sub) {
                bars.push({ sub: items[j].sub, num });
            } else if (num && !items[j].sub) {
                bars.push({ sub: items[j].txt, num });
            } else break;
            j++;
        }
        if (bars.length < 3) return null;
        const allPct = bars.every((b: any) => b.num.suf === '%');
        const max = allPct ? 100 : Math.max(...bars.map((b: any) => b.num.v));
        return { group: { type: 'barchart', items: bars, max: max || 100, allPct }, end: j };
    }

    private extractNum(txt: string): any {
        if (!txt) return null;
        const t = txt.trim();
        let m = t.match(/^(?:Livello:\s*)?(\d+(?:[.,]\d+)?)\s*%$/i);
        if (m) return { v: parseFloat(m[1].replace(',', '.')), suf: '%' };
        if (t.length <= 6) {
            m = t.match(/^(\d+(?:[.,]\d+)?)$/);
            if (m) return { v: parseFloat(m[1].replace(',', '.')), suf: '' };
        }
        return null;
    }

    // ---- Rendering gruppi ----

    private schedaRenderGroup(g: any): string {
        if (g.type === 'versus') return this.renderVersus(g);
        if (g.type === 'compare') return this.renderCompare(g);
        if (g.type === 'legend') return this.renderLegend(g);
        if (g.type === 'barchart') return this.renderBarChart(g);
        return this.renderSingle(g.item);
    }

    private renderSingle(p: any): string {
        const sub = p.sub, txt = p.txt;
        if (!sub && !txt) return '';
        const subLow = (sub || '').toLowerCase().trim();

        // Citazione
        const isCitation = subLow.indexOf('citazione') !== -1;
        if (isCitation || (!sub && txt)) {
            if (isCitation) {
                return '<div class="so-blockquote"><p>' + this.inlineMd(txt) + '</p></div>';
            }
        }

        // Highlight box for special types (allineato al docente)
        const specials = ['formula', 'nota', 'conclusione', 'intersezione', 'centro', 'approfondimento'];
        if (sub && specials.indexOf(subLow) !== -1) {
            return '<div class="so-highlight"><div class="so-highlight-label">' + this.escHtml(sub) +
                '</div><div class="so-highlight-text">' + this.inlineMd(txt) + '</div></div>';
        }

        // Inline short value (stessa soglia del docente)
        if (sub && txt && txt.length <= 30 && txt.split(/\s+/).length <= 4) {
            return '<div class="so-inline"><span class="so-inline-label">' + this.inlineMd(sub) +
                '</span><span class="so-inline-value">' + this.inlineMd(txt) + '</span></div>';
        }

        // Standard
        let h = '';
        if (sub) h += '<div class="so-key">' + this.inlineMd(sub) + '</div>';
        if (txt) h += '<div class="so-text">' + this.inlineMd(txt) + '</div>';
        return h;
    }

    private renderVersus(g: any): string {
        const posKw = ['pro','vantaggi','benefici','punti di forza','opportunità','forze'];
        const negKw = ['contro','svantaggi','costi','punti di debolezza','minacce','rischi'];
        const aL = g.labelA.toLowerCase(), bL = g.labelB.toLowerCase();
        const aPos = posKw.some((k: string) => aL.indexOf(k) !== -1);
        const bNeg = negKw.some((k: string) => bL.indexOf(k) !== -1);
        let proL: string, proI: any[], conL: string, conI: any[];
        if (aPos || bNeg) { proL = g.labelA; proI = g.itemsA; conL = g.labelB; conI = g.itemsB; }
        else { proL = g.labelA; proI = g.itemsA; conL = g.labelB; conI = g.itemsB; }

        let h = '<div class="so-versus">';
        h += '<div class="so-vs-col so-vs-pro"><div class="so-vs-head"><i class="fas fa-check-circle"></i> ' + this.escHtml(proL) + '</div>';
        proI.forEach((it: any) => { h += '<div class="so-vs-item"><i class="fas fa-circle so-vs-dot"></i>' + this.inlineMd(it.txt) + '</div>'; });
        h += '</div>';
        h += '<div class="so-vs-col so-vs-con"><div class="so-vs-head"><i class="fas fa-times-circle"></i> ' + this.escHtml(conL) + '</div>';
        conI.forEach((it: any) => { h += '<div class="so-vs-item"><i class="fas fa-circle so-vs-dot"></i>' + this.inlineMd(it.txt) + '</div>'; });
        h += '</div></div>';
        return h;
    }

    private renderCompare(g: any): string {
        return '<div class="so-compare">' +
            '<div class="so-cmp-card so-cmp-before"><div class="so-cmp-label">' + this.escHtml(g.a.sub) + '</div>' +
            (g.a.txt ? '<div class="so-cmp-text">' + this.inlineMd(g.a.txt) + '</div>' : '') + '</div>' +
            '<div class="so-cmp-arrow"><i class="fas fa-long-arrow-alt-right"></i></div>' +
            '<div class="so-cmp-card so-cmp-after"><div class="so-cmp-label">' + this.escHtml(g.b.sub) + '</div>' +
            (g.b.txt ? '<div class="so-cmp-text">' + this.inlineMd(g.b.txt) + '</div>' : '') + '</div></div>';
    }

    private renderLegend(g: any): string {
        let h = '<div class="so-legend">';
        g.items.forEach((it: any) => {
            h += '<div class="so-legend-item"><span class="so-legend-sym">' + this.escHtml(it.sub) + '</span>';
            if (it.txt) h += '<span class="so-legend-desc">' + this.inlineMd(it.txt) + '</span>';
            h += '</div>';
        });
        return h + '</div>';
    }

    private renderBarChart(g: any): string {
        let h = '<div class="so-barchart">';
        g.items.forEach((bar: any) => {
            const pct = g.max > 0 ? Math.min(100, (bar.num.v / g.max) * 100) : 0;
            const cls = pct >= 75 ? 'so-bar-high' : (pct >= 40 ? 'so-bar-mid' : 'so-bar-low');
            const val = bar.num.suf ? bar.num.v + bar.num.suf : bar.num.v;
            h += '<div class="so-bar-row">' +
                '<div class="so-bar-label">' + this.escHtml(bar.sub) + '</div>' +
                '<div class="so-bar-track"><div class="so-bar-fill ' + cls + '" style="width:' + pct + '%"></div></div>' +
                '<div class="so-bar-value">' + val + '</div></div>';
        });
        return h + '</div>';
    }

    // ---- CSS per overlay corsista ----

    private getSchedaCSS(): string {
        return `
.so-root {
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    z-index: 1001; background: #191825;
    display: flex; flex-direction: column;
    font-family: 'Poppins', 'Segoe UI', sans-serif;
}
.so-header {
    background: #1b1b2e; padding: clamp(8px, 1.5vh, 16px) clamp(12px, 3vw, 32px);
    display: flex; align-items: center; gap: clamp(8px, 1.5vw, 16px);
    border-bottom: 1px solid #2d2d3f; flex-shrink: 0;
}
.so-header-icon { color: #1BC5BD; font-size: clamp(16px, 2.5vw, 28px); }
.so-header-title {
    color: #fff; font-size: clamp(14px, 2vw, 22px); font-weight: 700;
    flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.so-header-counter {
    color: #6c7293; font-size: clamp(11px, 1.2vw, 15px); font-weight: 600;
    background: rgba(255,255,255,0.05); padding: 4px 12px; border-radius: 20px;
}
.so-body {
    flex: 1; overflow-y: auto; padding: clamp(16px, 3vh, 40px) clamp(16px, 5vw, 80px);
    display: flex; align-items: flex-start; justify-content: center;
}
.so-body::-webkit-scrollbar { width: 5px; }
.so-body::-webkit-scrollbar-thumb { background: rgba(137,80,252,0.3); border-radius: 4px; }
.so-slide {
    max-width: 900px; width: 100%;
}
.so-slide-title {
    color: #fff; font-size: clamp(20px, 3vw, 36px); font-weight: 800;
    margin-bottom: clamp(16px, 2.5vh, 32px); line-height: 1.3;
    border-bottom: 3px solid #3699FF; padding-bottom: clamp(8px, 1.5vh, 16px);
}
/* Punti */
.so-key {
    color: #FFA800; font-size: clamp(14px, 1.8vw, 20px); font-weight: 700;
    margin-top: clamp(12px, 2vh, 24px); margin-bottom: 4px;
}
.so-text {
    color: #d0d0e0; font-size: clamp(14px, 1.6vw, 19px); line-height: 1.7;
    padding-left: clamp(10px, 1.5vw, 20px); border-left: 3px solid rgba(54,153,255,0.3);
    margin-bottom: 4px;
}
.so-inline {
    display: flex; align-items: baseline; gap: clamp(8px, 1vw, 16px);
    margin-top: clamp(6px, 1vh, 12px); padding: clamp(6px, 1vh, 12px) clamp(10px, 1.5vw, 20px);
    background: rgba(255,255,255,0.03); border-radius: 10px; border-left: 3px solid #FFA800;
}
.so-inline-label { color: #FFA800; font-size: clamp(13px, 1.5vw, 18px); font-weight: 700; white-space: nowrap; }
.so-inline-value { color: #e0e0f0; font-size: clamp(14px, 1.6vw, 20px); font-weight: 600; }
/* Highlight box */
.so-highlight {
    background: rgba(137,80,252,0.08); border: 1px solid rgba(137,80,252,0.25);
    border-radius: 12px; padding: clamp(12px, 2vh, 24px); margin-top: clamp(8px, 1.5vh, 16px);
}
.so-highlight-label {
    color: #b9a0f8; font-size: clamp(10px, 1.2vw, 14px); font-weight: 700;
    text-transform: uppercase; letter-spacing: 1px; margin-bottom: 6px;
}
.so-highlight-text { color: #e0e0f0; font-size: clamp(16px, 2vw, 24px); font-weight: 600; line-height: 1.5; }
/* Versus */
.so-versus {
    display: flex; gap: clamp(8px, 1.5vw, 16px);
    margin-top: clamp(8px, 1.5vh, 16px);
}
.so-vs-col { flex: 1; border-radius: 12px; padding: clamp(10px, 1.5vh, 20px) clamp(10px, 1.5vw, 20px); min-width: 0; }
.so-vs-pro { background: rgba(27,197,189,0.08); border: 1px solid rgba(27,197,189,0.3); }
.so-vs-con { background: rgba(246,78,96,0.08); border: 1px solid rgba(246,78,96,0.3); }
.so-vs-head { font-size: clamp(12px, 1.5vw, 18px); font-weight: 700; text-transform: uppercase; margin-bottom: clamp(6px, 1vh, 12px); display: flex; align-items: center; gap: 6px; }
.so-vs-pro .so-vs-head { color: #1BC5BD; }
.so-vs-con .so-vs-head { color: #F64E60; }
.so-vs-item { color: #c0c0d4; font-size: clamp(13px, 1.4vw, 17px); line-height: 1.6; padding: clamp(4px, 0.5vh, 8px) 0; border-bottom: 1px solid rgba(255,255,255,0.04); display: flex; align-items: flex-start; gap: 8px; }
.so-vs-item:last-child { border-bottom: none; }
.so-vs-dot { font-size: 6px; margin-top: clamp(5px, 0.8vh, 9px); flex-shrink: 0; }
.so-vs-pro .so-vs-dot { color: #1BC5BD; }
.so-vs-con .so-vs-dot { color: #F64E60; }
/* Compare */
.so-compare { display: flex; align-items: stretch; margin-top: clamp(8px, 1.5vh, 16px); }
.so-cmp-card { flex: 1; padding: clamp(10px, 1.5vh, 20px) clamp(10px, 1.5vw, 20px); min-width: 0; }
.so-cmp-before { background: rgba(246,78,96,0.06); border: 1px solid rgba(246,78,96,0.2); border-right: none; border-radius: 12px 0 0 12px; }
.so-cmp-after { background: rgba(27,197,189,0.06); border: 1px solid rgba(27,197,189,0.2); border-left: none; border-radius: 0 12px 12px 0; }
.so-cmp-label { font-size: clamp(11px, 1.3vw, 16px); font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.so-cmp-before .so-cmp-label { color: #F64E60; }
.so-cmp-after .so-cmp-label { color: #1BC5BD; }
.so-cmp-text { color: #c0c0d4; font-size: clamp(13px, 1.4vw, 17px); line-height: 1.5; }
.so-cmp-arrow { display: flex; align-items: center; padding: 0 clamp(6px, 1vw, 14px); color: #FFA800; font-size: clamp(16px, 2vw, 28px); background: rgba(255,168,0,0.06); }
/* Legend */
.so-legend {
    display: flex; flex-wrap: wrap; gap: clamp(6px, 1vw, 12px);
    margin-top: clamp(8px, 1.5vh, 16px); padding: clamp(8px, 1.5vh, 16px) clamp(10px, 1.5vw, 20px);
    background: rgba(255,255,255,0.02); border-radius: 12px; border-left: 3px solid #3699FF;
}
.so-legend-item { display: inline-flex; align-items: baseline; gap: 8px; background: rgba(54,153,255,0.08); border-radius: 8px; padding: clamp(4px, 0.5vh, 8px) clamp(10px, 1vw, 16px); }
.so-legend-sym { color: #3699FF; font-size: clamp(15px, 1.8vw, 22px); font-weight: 800; font-family: 'Courier New', monospace; }
.so-legend-desc { color: #a2a3b7; font-size: clamp(12px, 1.3vw, 16px); }
/* Barchart */
.so-barchart { margin-top: clamp(8px, 1.5vh, 16px); padding: clamp(8px, 1.5vh, 16px) clamp(10px, 1.5vw, 20px); background: rgba(255,255,255,0.02); border-radius: 12px; border-left: 3px solid #8950FC; }
.so-bar-row { display: flex; align-items: center; gap: clamp(8px, 1vw, 14px); margin-bottom: clamp(6px, 1vh, 12px); }
.so-bar-label { color: #a2a3b7; font-size: clamp(12px, 1.3vw, 16px); font-weight: 500; min-width: clamp(80px, 12vw, 160px); max-width: clamp(100px, 15vw, 200px); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; }
.so-bar-track { flex: 1; height: clamp(16px, 2vh, 24px); background: rgba(255,255,255,0.06); border-radius: 12px; overflow: hidden; }
.so-bar-fill { height: 100%; border-radius: 12px; transition: width 0.5s ease; min-width: 2px; }
.so-bar-high { background: linear-gradient(90deg, #1BC5BD, #0BB783); }
.so-bar-mid { background: linear-gradient(90deg, #3699FF, #8950FC); }
.so-bar-low { background: linear-gradient(90deg, #FFA800, #F64E60); }
.so-bar-value { color: #fff; font-size: clamp(13px, 1.4vw, 18px); font-weight: 700; min-width: clamp(36px, 4vw, 50px); text-align: right; flex-shrink: 0; }
/* Narrazione */
.so-narration { margin-top: clamp(16px, 3vh, 32px); padding-top: clamp(12px, 2vh, 24px); border-top: 1px dashed #2d2d3f; }
.so-narration-label { color: #6c7293; font-size: clamp(10px, 1.1vw, 13px); font-weight: 700; text-transform: uppercase; letter-spacing: 1px; margin-bottom: clamp(8px, 1.5vh, 16px); }
.so-narration-label i { margin-right: 4px; }
.so-narration-text { color: #b0b0c4; font-size: clamp(13px, 1.4vw, 17px); line-height: 1.8; margin-bottom: clamp(6px, 1vh, 10px); }
/* Footer dots */
.so-footer {
    background: #1b1b2e; padding: clamp(6px, 1vh, 12px) clamp(12px, 2vw, 24px);
    border-top: 1px solid #2d2d3f; flex-shrink: 0;
    display: flex; justify-content: center;
}
.so-dots { display: flex; gap: 6px; flex-wrap: wrap; justify-content: center; }
.so-dot {
    width: clamp(6px, 0.8vw, 10px); height: clamp(6px, 0.8vw, 10px);
    border-radius: 50%; background: rgba(255,255,255,0.15); transition: all 0.3s;
}
.so-dot.active { background: #3699FF; transform: scale(1.3); box-shadow: 0 0 8px rgba(54,153,255,0.5); }
/* Blockquote (citazioni) */
.so-blockquote {
    border-left: 4px solid #8950FC; padding: clamp(10px, 1.5vh, 20px) clamp(12px, 2vw, 24px);
    background: rgba(137,80,252,0.06); border-radius: 0 12px 12px 0;
    margin-top: clamp(8px, 1.5vh, 16px); font-style: italic;
}
.so-blockquote p { color: #d0d0e0; font-size: clamp(14px, 1.6vw, 20px); line-height: 1.7; margin: 0; }
/* Inline Markdown */
.so-root strong { color: #fff; font-weight: 700; }
.so-root em { font-style: italic; color: #c8c8e0; }
.so-root u { text-decoration: underline; text-decoration-color: #FFA800; text-underline-offset: 2px; }
.so-root mark { background: rgba(255,168,0,0.2) !important; color: #FFD740 !important; padding: 1px 4px; border-radius: 3px; }
`;
    }

    hideSchedaOverlay() {
        this.schedaActive = false;
        this.schedaSlides = [];
        this.schedaCurrentIdx = 0;
        const overlay = document.getElementById('schedaOverlay');
        if (overlay) overlay.remove();
        // Ripristina Jitsi dalla PiP
        this.restoreJitsiFromPip();
        document.body.style.overflow = '';
    }

    startSchedaPolling() {
        this.stopSchedaPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.schedaPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/scheda-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;

                if (resp.active && resp.state) {
                    if (!self.schedaActive) {
                        // Corsista appena entrato o scheda appena condivisa
                        self.showSchedaOverlay(resp.state.titolo, resp.state.content);
                        // Allinea alla slide corrente del docente
                        if (typeof resp.state.slideIndex === 'number' && resp.state.slideIndex > 0) {
                            self.schedaGoToSlide(resp.state.slideIndex);
                        }
                    } else if (typeof resp.state.slideIndex === 'number') {
                        // Già attiva: sincronizza slide se cambiata
                        self.schedaGoToSlide(resp.state.slideIndex);
                    }
                } else if (!resp.active && self.schedaActive) {
                    self.hideSchedaOverlay();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopSchedaPolling() {
        if (this.schedaPollingInterval) {
            clearInterval(this.schedaPollingInterval);
            this.schedaPollingInterval = null;
        }
    }

    // =========================================================================
    // SCALETTA DELLA LEZIONE — Vista corsisti (presentazione)
    // =========================================================================

    handleScalettaSync(data: any) {
        if (data.type === 'start' && data.content) {
            this.showScalettaOverlay(data.titolo, data.content);
        } else if (data.type === 'update' && data.content) {
            this.updateScalettaSlide(data.content);
        } else if (data.type === 'stop') {
            this.hideScalettaOverlay();
        }
    }

    showScalettaOverlay(titolo: string, contentJson: string) {
        // Se overlay già attivo, non ricrearlo (evita flash/reload)
        const old = document.getElementById('scalettaOverlay');
        if (old && this.scalettaActive) {
            // Aggiorna solo il contenuto
            this.updateScalettaSlide(contentJson);
            return;
        }
        if (old) old.remove();

        let parsed: any;
        try { parsed = JSON.parse(contentJson); } catch (e) { return; }

        this.scalettaActive = true;
        this.scalettaSlides = parsed.slides || [];
        this.scalettaCurrentSlide = parsed.currentSlide || 0;

        // Salva il participantId del docente dal payload (fallback per polling)
        if (parsed.docenteParticipantId) {
            (this as any)._docenteParticipantId = parsed.docenteParticipantId;
        }

        if (!this.scalettaSlides.length) return;

        // Inietta CSS presentazione se non presente
        this.injectScalettaPresCSS();

        // Overlay identico alla simulazione di gestione-scheda-didattica
        const overlay = document.createElement('div');
        overlay.id = 'scalettaOverlay';
        overlay.className = 'pres-overlay active';

        overlay.innerHTML =
            '<div class="pres-topbar">' +
                '<div class="pres-topbar-left">' +
                    '<div class="pres-topbar-title">' + this.escHtml(titolo || parsed.titolo || 'Scaletta della lezione') + '</div>' +
                '</div>' +
                '<div style="display:flex;align-items:center;gap:12px">' +
                    '<div class="pres-counter" id="scalettaCounter"></div>' +
                '</div>' +
            '</div>' +
            '<div class="pres-stage"><div class="pres-slide" id="scalettaSlideContent"></div></div>' +
            '<div class="pres-nav">' +
                '<div class="pres-progress"><div class="pres-progress-fill" id="scalettaProgress"></div></div>' +
                '<div class="pres-nav-info" id="scalettaNavInfo"></div>' +
            '</div>' +
            '<div class="pres-pip" id="scalettaPip"></div>';

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';

        // Sposta iframe Jitsi nel riquadro PiP
        this.moveJitsiToPip();

        this.renderScalettaSlide();
    }

    updateScalettaSlide(contentJson: string) {
        if (!this.scalettaActive) return;
        let parsed: any;
        try { parsed = JSON.parse(contentJson); } catch (e) { return; }

        this.scalettaSlides = parsed.slides || this.scalettaSlides;
        const newSlide = parsed.currentSlide;
        if (typeof newSlide === 'number' && newSlide !== this.scalettaCurrentSlide) {
            this.scalettaCurrentSlide = newSlide;
            this.renderScalettaSlide();
        }
    }

    /**
     * Rendering identico a sdRenderPresSlide() di gestione-scheda-didattica.js.
     */
    renderScalettaSlide() {
        const slideContent = document.getElementById('scalettaSlideContent');
        if (!slideContent) return;

        if (this.scalettaCurrentSlide >= this.scalettaSlides.length) this.scalettaCurrentSlide = 0;
        const s = this.scalettaSlides[this.scalettaCurrentSlide];
        const total = this.scalettaSlides.length;
        const idx = this.scalettaCurrentSlide;

        const counter = document.getElementById('scalettaCounter');
        if (counter) counter.textContent = (idx + 1) + ' / ' + total;
        const navInfo = document.getElementById('scalettaNavInfo');
        if (navInfo) navInfo.textContent = (idx + 1) + ' di ' + total;
        const progress = document.getElementById('scalettaProgress');
        if (progress) progress.style.width = ((idx + 1) / total * 100) + '%';

        let html = '';
        const esc = (str: string) => this.escHtml(str || '');
        const md = (str: string) => this.inlineMd(str || '');

        if (s.type === 'titolo') {
            html += '<div class="pres-slide-orario" style="color:' + (s.color || '#3699FF') + '"><i class="fas fa-clock"></i> ' + esc(s.orario) + ' <span class="badge" style="background:' + (s.color || '#3699FF') + '">' + esc(s.durata) + '</span></div>';
            html += '<h1>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#3699FF') + '"></div>';
            if (s.sottotitolo) html += '<div style="font-size:15px;color:#B5B5C3;margin-bottom:24px">' + md(s.sottotitolo) + '</div>';
            if (s.punti && s.punti.length) {
                html += '<div style="font-size:12px;color:#565674;text-transform:uppercase;letter-spacing:1px;margin-bottom:12px;font-weight:700">Obiettivi della lezione</div>';
                html += '<div class="pres-punti-grid">';
                s.punti.forEach((p: string, i: number) => {
                    html += '<div class="pres-punto"><div class="pres-punto-icon" style="background:' + (s.color || '#3699FF') + ';color:#fff">' + (i + 1) + '</div><div class="pres-punto-text">' + md(p) + '</div></div>';
                });
                html += '</div>';
            }
        } else if (s.type === 'pausa') {
            html += '<div style="text-align:center;padding:60px 0">' +
                '<div style="font-size:72px;margin-bottom:16px;">&#9749;</div>' +
                '<h1 style="color:#B5B5C3;font-size:28px;font-weight:700">' + esc(s.titolo || 'Pausa') + '</h1>' +
                '<div style="font-size:16px;color:#565674;margin-top:8px">' + esc(s.orario) + '</div>' +
                (s.durata ? '<div style="font-size:16px;color:#7E8299;margin-top:10px"><i class="fas fa-stopwatch mr-1"></i>' + s.durata + ' minuti</div>' : '') +
                '<div id="corsistaPausaCountdownWrap" style="display:none;margin-top:24px">' +
                '<div id="corsistaPausaTimer" style="font-size:48px;font-weight:700;color:#FFA800;font-variant-numeric:tabular-nums;letter-spacing:2px">00:00</div>' +
                '<div style="margin:12px auto 0;width:220px;height:5px;background:rgba(255,168,0,0.15);border-radius:3px;overflow:hidden"><div id="corsistaPausaBarFill" style="height:100%;width:100%;background:#FFA800;border-radius:3px;transition:width 1s linear"></div></div>' +
                '</div>' +
                '</div>';
        } else if (s.type === 'contenuto') {
            const color = s.color || '#3699FF';
            html += '<div style="font-size:11px;color:#565674;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px;font-weight:600">' + esc(s.bloccoTitolo) + '</div>';
            html += '<div class="pres-slide-orario" style="color:' + color + '"><i class="fas fa-clock"></i> ' + esc(s.orario) + ' <span class="badge" style="background:' + color + '">' + esc(s.durata) + '</span></div>';
            html += '<h1 style="font-size:24px">' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + color + '"></div>';
            if (s.contenuto) html += '<div class="pres-slide-content">' + md(s.contenuto) + '</div>';
            if (s.punti && s.punti.length) {
                html += '<div class="pres-punti-grid">';
                s.punti.forEach((p: string) => {
                    html += '<div class="pres-punto"><div class="pres-punto-icon" style="background:' + color + ';color:#fff"><i class="fas fa-check" style="font-size:11px"></i></div><div class="pres-punto-text">' + md(p) + '</div></div>';
                });
                html += '</div>';
            }
            if (s.domanda) {
                html += '<div class="pres-domanda-box"><div class="pres-label"><i class="fas fa-comment-dots mr-1"></i> Domanda per la classe</div><div class="pres-text">' + md(s.domanda) + '</div></div>';
            }
            if (s.esempio) {
                html += '<div class="pres-esempio-box"><div class="pres-label"><i class="fas fa-lightbulb mr-1"></i> Esempio</div><div class="pres-text">' + md(s.esempio) + '</div></div>';
            }
            // AI Expansion — identico a sdRenderPresSlide
            if (s.aiExpansion) {
                const cor = s.aiExpansion.corsisti || null;
                if (cor && (cor.concetto_principale || cor.punti_visivi)) {
                    html += '<div style="margin-top:20px;padding:20px 24px;background:linear-gradient(135deg,#1a1a3e 0%,#252550 100%);border:1px solid #8950FC30;border-radius:12px">';
                    if (cor.concetto_principale) {
                        html += '<div style="text-align:center;margin-bottom:16px"><div style="display:inline-block;font-size:18px;font-weight:700;color:#fff;padding:8px 24px;background:linear-gradient(135deg,#8950FC 0%,#3699FF 100%);border-radius:24px;letter-spacing:0.3px"><i class="fas fa-bullseye mr-2" style="font-size:14px"></i>' + md(cor.concetto_principale) + '</div></div>';
                    }
                    if (cor.punti_visivi && cor.punti_visivi.length) {
                        html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">';
                        cor.punti_visivi.forEach((pv: any) => {
                            const icona = pv.icona || 'fas fa-check-circle';
                            html += '<div style="display:flex;align-items:flex-start;gap:12px;padding:12px 14px;background:#ffffff08;border:1px solid #ffffff12;border-radius:10px;transition:all .2s">' +
                                '<div style="width:36px;height:36px;border-radius:10px;background:linear-gradient(135deg,#8950FC20,#3699FF20);display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="' + esc(icona) + '" style="color:#8950FC;font-size:15px"></i></div>' +
                                '<div style="font-size:13.5px;color:#d0d0e8;line-height:1.5;padding-top:2px">' + md(pv.testo) + '</div></div>';
                        });
                        html += '</div>';
                    }
                    if (cor.da_ricordare) {
                        html += '<div style="display:flex;align-items:center;gap:10px;padding:10px 16px;background:linear-gradient(90deg,#FFA80015,#FFA80008);border:1px solid #FFA80030;border-radius:8px"><i class="fas fa-star" style="color:#FFA800;font-size:16px;flex-shrink:0"></i><div style="font-size:13.5px;color:#FFA800;font-weight:600;line-height:1.4">' + md(cor.da_ricordare) + '</div></div>';
                    }
                    html += '</div>';
                } else if (cor && (cor.riepilogo || cor.punti_chiave)) {
                    html += '<div style="margin-top:16px;padding:16px 20px;background:linear-gradient(135deg,#1e1e3a 0%,#2a2a50 100%);border:1px solid #1BC5BD40;border-radius:8px">';
                    html += '<div style="font-size:11px;color:#1BC5BD;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-bookmark mr-1"></i> Riepilogo</div>';
                    if (cor.riepilogo) html += '<div style="font-size:14px;color:#d0d0e0;line-height:1.6;margin-bottom:10px">' + md(cor.riepilogo) + '</div>';
                    if (cor.punti_chiave && cor.punti_chiave.length) {
                        html += '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px">';
                        cor.punti_chiave.forEach((p: string) => {
                            html += '<div style="font-size:13px;color:#e0e0e0;padding:6px 12px;background:#ffffff10;border-radius:6px;border-left:3px solid #1BC5BD"><i class="fas fa-check mr-1" style="color:#1BC5BD;font-size:10px"></i>' + md(p) + '</div>';
                        });
                        html += '</div>';
                    }
                    if (cor.da_ricordare) html += '<div style="font-size:13px;color:#FFA800;margin-top:6px;font-weight:600"><i class="fas fa-star mr-1"></i>' + md(cor.da_ricordare) + '</div>';
                    html += '</div>';
                } else if (s.aiExpansion.contenuto_espanso) {
                    html += '<div style="margin-top:16px;padding:16px 20px;background:linear-gradient(135deg,#1e1e3a 0%,#2a2a50 100%);border:1px solid #8950FC40;border-radius:8px">';
                    html += '<div style="font-size:11px;color:#8950FC;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-robot mr-1"></i> Approfondimento</div>';
                    html += '<div style="font-size:14px;color:#d0d0e0;line-height:1.6">' + md(s.aiExpansion.contenuto_espanso) + '</div>';
                    html += '</div>';
                }
            }
            // Extra inline del nodo (mappa, esercizio, quiz, riepilogo, etc.)
            html += this.renderScalettaExtrasInline(s, esc);
        } else if (s.type === 'mappa') {
            html += '<h1 style="font-size:24px;text-align:center"><i class="fas fa-project-diagram mr-2" style="color:' + (s.color || '#8950FC') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#8950FC') + ';margin:16px auto 24px"></div>';
            if (s.centrale) html += '<div class="pres-mappa-centrale"><span>' + md(s.centrale) + '</span></div>';
            (s.rami || []).forEach((r: any) => {
                html += '<div class="pres-mappa-ramo"><h4>' + esc(r.titolo) + '</h4>';
                if (r.desc) html += '<div class="desc">' + md(r.desc) + '</div>';
                (r.sotto || []).forEach((sub: string) => { html += '<div class="pres-mappa-sotto">' + md(sub) + '</div>'; });
                html += '</div>';
            });
        } else if (s.type === 'esercizio') {
            html += '<h1 style="font-size:24px"><i class="fas fa-pencil-alt mr-2" style="color:' + (s.color || '#FFA800') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#FFA800') + '"></div>';
            if (s.scenario) html += '<div class="pres-esercizio-section"><div class="pres-label" style="color:#FFA800"><i class="fas fa-theater-masks mr-1"></i> Scenario</div><div class="pres-text">' + md(s.scenario) + '</div></div>';
            if (s.consegna) html += '<div class="pres-esercizio-section"><div class="pres-label" style="color:#3699FF"><i class="fas fa-tasks mr-1"></i> Consegna</div><div class="pres-text">' + md(s.consegna) + '</div></div>';
        } else if (s.type === 'domande') {
            html += '<h1 style="font-size:24px"><i class="fas fa-question-circle mr-2" style="color:' + (s.color || '#F64E60') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#F64E60') + '"></div>';
            (s.domande || []).forEach((d: string, i: number) => {
                html += '<div class="pres-domanda-box" style="margin-bottom:12px"><div class="pres-label"><i class="fas fa-comment-dots mr-1"></i> Domanda ' + (i + 1) + '</div><div class="pres-text">' + md(d) + '</div></div>';
            });
        } else if (s.type === 'riepilogo') {
            html += '<h1 style="font-size:24px"><i class="fas fa-file-alt mr-2" style="color:' + (s.color || '#1BC5BD') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#1BC5BD') + '"></div>';
            (s.punti || []).forEach((p: string) => {
                html += '<div class="pres-riepilogo-item"><span>' + md(p) + '</span></div>';
            });
        } else if (s.type === 'glossario') {
            html += '<h1 style="font-size:24px"><i class="fas fa-book mr-2" style="color:' + (s.color || '#3699FF') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#3699FF') + '"></div>';
            (s.termini || []).forEach((g: any) => {
                html += '<div style="margin-bottom:14px;padding:12px 16px;background:#ffffff08;border-left:3px solid #3699FF;border-radius:8px">';
                html += '<div style="font-size:16px;font-weight:700;color:#fff">' + esc(g.termine || '');
                if (g.categoria) html += ' <span style="font-size:10px;color:#7E8299;background:#3699FF20;padding:2px 8px;border-radius:4px;margin-left:8px">' + esc(g.categoria) + '</span>';
                html += '</div>';
                html += '<div style="font-size:14px;color:#d0d0e0;margin-top:4px">' + md(g.definizione || '') + '</div>';
                if (g.esempio_uso) html += '<div style="font-size:13px;color:#a2a3b7;font-style:italic;margin-top:4px"><i class="fas fa-quote-left mr-1" style="font-size:10px"></i>' + md(g.esempio_uso) + '</div>';
                html += '</div>';
            });
        } else if (s.type === 'quiz_interattivo') {
            html += '<h1 style="font-size:24px"><i class="fas fa-question-circle mr-2" style="color:' + (s.color || '#F64E60') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#F64E60') + '"></div>';
            (s.domande || []).forEach((q: any, qi: number) => {
                html += '<div style="margin-bottom:16px;padding:14px 18px;background:#ffffff08;border-radius:8px;border-left:3px solid #F64E60">';
                html += '<div style="font-size:15px;font-weight:700;color:#fff;margin-bottom:8px">' + (qi + 1) + '. ' + md(q.domanda || '') + '</div>';
                (q.opzioni || []).forEach((o: string) => {
                    const isCorrect = o.charAt(0) === (q.risposta_corretta || '');
                    html += '<div style="font-size:14px;padding:4px 0;color:' + (isCorrect ? '#1BC5BD' : '#d0d0e0') + '">' +
                        (isCorrect ? '<i class="fas fa-check-circle mr-2" style="color:#1BC5BD"></i>' : '<i class="far fa-circle mr-2" style="color:#565674"></i>') + md(o) + '</div>';
                });
                if (q.spiegazione) html += '<div style="font-size:12px;color:#1BC5BD;margin-top:6px;font-style:italic"><i class="fas fa-info-circle mr-1"></i>' + md(q.spiegazione) + '</div>';
                html += '</div>';
            });
        } else if (s.type === 'attivita_gruppo') {
            const ag = s.data || {};
            html += '<h1 style="font-size:24px"><i class="fas fa-users mr-2" style="color:' + (s.color || '#FFA800') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#FFA800') + '"></div>';
            if (ag.tipo_attivita) html += '<div style="text-align:center;margin-bottom:16px"><span style="font-size:13px;color:#FFA800;background:#FFA80015;padding:4px 14px;border-radius:20px;font-weight:600">' + esc(ag.tipo_attivita.replace(/_/g, ' ')) + '</span></div>';
            if (ag.formazione_gruppi) html += '<div style="margin-bottom:12px;padding:10px 14px;background:#ffffff08;border-radius:8px"><div style="font-size:11px;color:#FFA800;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:4px">Formazione gruppi</div><div style="font-size:14px;color:#d0d0e0">' + md(ag.formazione_gruppi) + '</div></div>';
            if (ag.consegna) html += '<div style="margin-bottom:12px;padding:10px 14px;background:#ffffff08;border-radius:8px"><div style="font-size:11px;color:#3699FF;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:4px">Consegna</div><div style="font-size:14px;color:#d0d0e0">' + md(ag.consegna) + '</div></div>';
            if (ag.tempi) {
                html += '<div style="display:flex;justify-content:center;gap:12px;margin:16px 0">';
                if (ag.tempi.preparazione) html += '<div style="text-align:center;padding:8px 14px;background:#FFA80015;border-radius:8px"><div style="font-size:18px;font-weight:700;color:#FFA800">' + ag.tempi.preparazione + '\'</div><div style="font-size:10px;color:#a2a3b7">Preparazione</div></div>';
                if (ag.tempi.svolgimento) html += '<div style="text-align:center;padding:8px 14px;background:#3699FF15;border-radius:8px"><div style="font-size:18px;font-weight:700;color:#3699FF">' + ag.tempi.svolgimento + '\'</div><div style="font-size:10px;color:#a2a3b7">Svolgimento</div></div>';
                if (ag.tempi.debriefing) html += '<div style="text-align:center;padding:8px 14px;background:#1BC5BD15;border-radius:8px"><div style="font-size:18px;font-weight:700;color:#1BC5BD">' + ag.tempi.debriefing + '\'</div><div style="font-size:10px;color:#a2a3b7">Debriefing</div></div>';
                html += '</div>';
            }
        } else if (s.type === 'valutazione') {
            const vl = s.data || {};
            html += '<h1 style="font-size:24px"><i class="fas fa-clipboard-check mr-2" style="color:' + (s.color || '#4CAF50') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#4CAF50') + '"></div>';
            if (vl.tipo) html += '<div style="text-align:center;margin-bottom:16px"><span style="font-size:13px;color:#4CAF50;background:#4CAF5015;padding:4px 14px;border-radius:20px;font-weight:600">' + esc(vl.tipo) + '</span></div>';
            if (vl.titolo) html += '<div style="font-size:16px;color:#fff;font-weight:700;margin-bottom:14px;text-align:center">' + esc(vl.titolo) + '</div>';
            (vl.criteri || []).forEach((cr: any) => {
                html += '<div style="margin-bottom:10px;padding:10px 14px;background:#ffffff08;border-left:3px solid #4CAF50;border-radius:8px">';
                html += '<div style="font-size:14px;font-weight:700;color:#66BB6A">' + esc(cr.criterio || '') + '</div>';
                if (cr.indicatore) html += '<div style="font-size:13px;color:#d0d0e0;margin-top:2px">' + md(cr.indicatore) + '</div>';
                if (cr.livelli) {
                    html += '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:8px">';
                    const lvlColors: any = {insufficiente: '#F64E60', sufficiente: '#FFA800', buono: '#3699FF', ottimo: '#1BC5BD'};
                    for (const lvl of Object.keys(cr.livelli)) {
                        const lc = lvlColors[lvl] || '#7E8299';
                        html += '<span style="font-size:11px;padding:3px 10px;border-radius:4px;background:' + lc + '20;color:' + lc + ';font-weight:600">' + esc(lvl) + '</span>';
                    }
                    html += '</div>';
                }
                html += '</div>';
            });
            if (vl.punteggio_minimo) html += '<div style="text-align:center;margin-top:16px;font-size:13px;color:#a2a3b7"><i class="fas fa-star mr-1" style="color:#FFA800"></i>Soglia superamento: <strong style="color:#fff">' + esc(vl.punteggio_minimo) + '</strong></div>';
        } else if (s.type === 'caso_studio_intro') {
            html += '<h1 style="font-size:26px"><i class="fas fa-briefcase mr-2" style="color:' + (s.color || '#9C27B0') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#9C27B0') + '"></div>';
            html += '<div style="font-size:11px;color:#9C27B0;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:12px"><i class="fas fa-file-alt mr-1"></i>Scenario</div>';
            if (s.scenario) html += '<div style="font-size:15px;color:#d1d1e0;line-height:1.8;text-align:left">' + md(s.scenario) + '</div>';
        } else if (s.type === 'caso_studio_domande') {
            html += '<h1 style="font-size:24px"><i class="fas fa-question-circle mr-2" style="color:' + (s.color || '#9C27B0') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#9C27B0') + '"></div>';
            (s.domande || []).forEach((d: string, i: number) => {
                html += '<div style="display:flex;align-items:flex-start;gap:12px;padding:14px 18px;margin-bottom:10px;background:rgba(156,39,176,0.08);border-left:3px solid #9C27B0;border-radius:0 10px 10px 0">';
                html += '<div style="width:30px;height:30px;border-radius:50%;background:#9C27B0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff;flex-shrink:0">' + (i + 1) + '</div>';
                html += '<div style="font-size:15px;color:#d1d1e0;line-height:1.6;padding-top:4px">' + md(d) + '</div>';
                html += '</div>';
            });
        } else if (s.type === 'caso_studio_punti') {
            html += '<h1 style="font-size:24px"><i class="fas fa-lightbulb mr-2" style="color:' + (s.color || '#9C27B0') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#9C27B0') + '"></div>';
            (s.punti || []).forEach((p: string) => {
                html += '<div style="display:flex;align-items:flex-start;gap:10px;padding:10px 16px;margin-bottom:8px;background:rgba(255,255,255,0.04);border-radius:8px;border:1px solid rgba(156,39,176,0.15)">';
                html += '<i class="fas fa-check-circle" style="color:#9C27B0;font-size:16px;margin-top:2px;flex-shrink:0"></i>';
                html += '<span style="font-size:14px;color:#d1d1e0;line-height:1.5">' + md(p) + '</span>';
                html += '</div>';
            });
            if (s.collegamento) html += '<div style="margin-top:16px;padding:12px 16px;background:rgba(156,39,176,0.06);border:1px solid rgba(156,39,176,0.2);border-radius:10px;font-size:14px;color:#CE93D8"><i class="fas fa-link mr-2"></i>' + md(s.collegamento) + '</div>';
        } else if (s.type === 'video_checkpoint') {
            // Fallback per vecchie schede che usano ancora il formato singolo
            const vc = s.data || {};
            html += '<h1 style="font-size:24px"><i class="fas fa-briefcase mr-2" style="color:' + (s.color || '#9C27B0') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#9C27B0') + '"></div>';
            if (vc.titolo_risorsa) html += '<div style="font-size:16px;color:#fff;font-weight:700;margin-bottom:10px">' + esc(vc.titolo_risorsa) + '</div>';
            if (vc.scenario) html += '<div style="font-size:14px;color:#d0d0e0;margin-bottom:14px;line-height:1.7">' + md(vc.scenario) + '</div>';
        } else if (s.type === 'link_risorse') {
            html += '<h1 style="font-size:24px"><i class="fas fa-external-link-alt mr-2" style="color:' + (s.color || '#1976D2') + '"></i>' + esc(s.titolo) + '</h1>';
            html += '<div class="pres-slide-divider" style="background:' + (s.color || '#1976D2') + '"></div>';
            (s.risorse || []).forEach((r: any) => {
                const tipoIcons: any = {articolo: 'fas fa-newspaper', video: 'fas fa-play-circle', libro: 'fas fa-book', tool: 'fas fa-wrench', corso: 'fas fa-graduation-cap', documento: 'fas fa-file-alt'};
                const icon = tipoIcons[r.tipo] || 'fas fa-link';
                const lvlColors: any = {base: '#1BC5BD', intermedio: '#3699FF', avanzato: '#8950FC'};
                const lc = lvlColors[r.livello] || '#7E8299';
                html += '<div style="margin-bottom:10px;padding:12px 16px;background:#ffffff08;border-left:3px solid #1976D2;border-radius:0 8px 8px 0">';
                html += '<div style="display:flex;align-items:center;gap:10px"><i class="' + icon + '" style="color:#1976D2;font-size:16px"></i><div style="font-size:15px;font-weight:700;color:#fff">' + esc(r.titolo || '') + '</div>';
                if (r.livello) html += '<span style="font-size:10px;padding:2px 8px;border-radius:4px;background:' + lc + '20;color:' + lc + ';font-weight:600;margin-left:auto">' + esc(r.livello) + '</span>';
                html += '</div>';
                if (r.descrizione) html += '<div style="font-size:13px;color:#a2a3b7;margin-top:4px">' + md(r.descrizione) + '</div>';
                html += '</div>';
            });
        }

        slideContent.innerHTML = html;
    }

    /**
     * Renderizza le sezioni extra inline nella slide contenuto (mappa, esercizio, quiz, etc.).
     * Queste fanno parte dello stesso nodo timeline, non sono slide separate.
     */
    renderScalettaExtrasInline(s: any, esc: (str: string) => string): string {
        let html = '';
        const md = (str: string) => this.inlineMd(str || '');

        // Mappa concettuale
        if (s.mappa_concettuale) {
            const mc = s.mappa_concettuale;
            html += '<div style="margin-top:20px;padding:20px;background:rgba(137,80,252,.06);border:1px solid rgba(137,80,252,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#8950FC;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:12px"><i class="fas fa-project-diagram mr-1"></i> Mappa concettuale</div>';
            if (mc.nodo_centrale) html += '<div class="pres-mappa-centrale"><span>' + md(mc.nodo_centrale) + '</span></div>';
            (mc.rami || []).forEach((r: any) => {
                html += '<div class="pres-mappa-ramo"><h4>' + esc(r.concetto || '') + '</h4>';
                if (r.descrizione) html += '<div class="desc">' + md(r.descrizione) + '</div>';
                (r.sotto_nodi || []).forEach((sn: any) => {
                    html += '<div class="pres-mappa-sotto">' + md((sn.concetto || '') + (sn.descrizione ? ': ' + sn.descrizione : '')) + '</div>';
                });
                html += '</div>';
            });
            html += '</div>';
        }

        // Esercizio
        if (s.esercizio) {
            const es = s.esercizio;
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(255,168,0,.06);border:1px solid rgba(255,168,0,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#FFA800;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-pencil-alt mr-1"></i> ' + esc(es.titolo || 'Esercizio') + '</div>';
            if (es.scenario) html += '<div style="font-size:14px;color:#d0d0e0;margin-bottom:8px;line-height:1.6">' + md(es.scenario) + '</div>';
            if (es.consegna) html += '<div style="font-size:14px;color:#3699FF;font-weight:600"><i class="fas fa-tasks mr-1"></i>' + md(es.consegna) + '</div>';
            html += '</div>';
        }

        // Riepilogo
        if (s.riepilogo) {
            const ri = s.riepilogo;
            const items: string[] = [];
            if (ri.concetti_chiave) ri.concetti_chiave.forEach((c: any) => { items.push((c.termine || '') + ': ' + (c.definizione || '')); });
            if (ri.punti_fondamentali) ri.punti_fondamentali.forEach((p: any) => { items.push((p.titolo || '') + ': ' + (p.descrizione || '')); });
            if (items.length) {
                html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(27,197,189,.06);border:1px solid rgba(27,197,189,.2);border-radius:12px">';
                html += '<div style="font-size:11px;color:#1BC5BD;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-file-alt mr-1"></i> Riepilogo</div>';
                items.forEach((p: string) => {
                    html += '<div class="pres-riepilogo-item"><span>' + md(p) + '</span></div>';
                });
                html += '</div>';
            }
        }

        // domande_guida escluse: strumento del docente, non mostrate ai corsisti

        // Glossario
        if (s.glossario && s.glossario.length) {
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(54,153,255,.06);border:1px solid rgba(54,153,255,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#3699FF;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-book mr-1"></i> Glossario</div>';
            s.glossario.forEach((g: any) => {
                html += '<div style="margin-bottom:8px;padding:8px 12px;background:#ffffff06;border-radius:6px;border-left:3px solid #3699FF">';
                html += '<div style="font-size:14px;font-weight:700;color:#fff">' + esc(g.termine || '') + '</div>';
                html += '<div style="font-size:13px;color:#a2a3b7;margin-top:2px">' + md(g.definizione || '') + '</div>';
                html += '</div>';
            });
            html += '</div>';
        }

        // Quiz interattivo: escluso dalla slide corsisti — viene avviato dal docente

        // Attivita di gruppo
        if (s.attivita_gruppo) {
            const ag = s.attivita_gruppo;
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(255,168,0,.06);border:1px solid rgba(255,168,0,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#FFA800;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-users mr-1"></i> Attivit\u00e0 di Gruppo</div>';
            if (ag.consegna) html += '<div style="font-size:14px;color:#d0d0e0;margin-bottom:8px">' + md(ag.consegna) + '</div>';
            if (ag.formazione_gruppi) html += '<div style="font-size:13px;color:#FFA800;font-weight:600"><i class="fas fa-users mr-1"></i>' + md(ag.formazione_gruppi) + '</div>';
            html += '</div>';
        }

        // Video checkpoint / Caso studio
        if (s.video_checkpoint) {
            const vc = s.video_checkpoint;
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(156,39,176,.06);border:1px solid rgba(156,39,176,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#9C27B0;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-briefcase mr-1"></i> ' + esc(vc.titolo_risorsa || 'Caso Studio') + '</div>';
            if (vc.scenario) html += '<div style="font-size:14px;color:#d0d0e0;line-height:1.6">' + md(vc.scenario) + '</div>';
            html += '</div>';
        }

        // Video esterno
        if (s.video_esterno && s.video_esterno.url) {
            const ve = s.video_esterno;
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(255,0,0,.06);border:1px solid rgba(255,0,0,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#FF0000;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-video mr-1"></i> Video Esterno</div>';
            if (ve.titolo) html += '<div style="font-size:16px;font-weight:700;color:#fff;margin-bottom:6px">' + esc(ve.titolo) + '</div>';
            if (ve.descrizione) html += '<div style="font-size:14px;color:#d0d0e0;line-height:1.6">' + esc(ve.descrizione) + '</div>';
            html += '</div>';
        }

        // Presentazione integrata
        if (s.presentazione_integrata && s.presentazione_integrata.presId) {
            const pi = s.presentazione_integrata;
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(54,153,255,.06);border:1px solid rgba(54,153,255,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#3699FF;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-tv mr-1"></i> Presentazione</div>';
            if (pi.titolo) html += '<div style="font-size:16px;font-weight:700;color:#fff;margin-bottom:6px">' + esc(pi.titolo) + '</div>';
            if (pi.numSlides) html += '<div style="font-size:12px;color:#a2a3b7;margin-bottom:6px"><i class="fas fa-images mr-1" style="color:#3699FF"></i>' + pi.numSlides + ' slide</div>';
            if (pi.descrizione) html += '<div style="font-size:14px;color:#d0d0e0;line-height:1.6">' + this.inlineMd(pi.descrizione) + '</div>';
            html += '</div>';
        }

        // Link risorse
        if (s.link_risorse && s.link_risorse.length) {
            html += '<div style="margin-top:16px;padding:16px 20px;background:rgba(25,118,210,.06);border:1px solid rgba(25,118,210,.2);border-radius:12px">';
            html += '<div style="font-size:11px;color:#1976D2;text-transform:uppercase;letter-spacing:1px;font-weight:700;margin-bottom:8px"><i class="fas fa-link mr-1"></i> Risorse</div>';
            s.link_risorse.forEach((r: any) => {
                html += '<div style="margin-bottom:6px;padding:6px 10px;background:#ffffff06;border-radius:6px;border-left:3px solid #1976D2">';
                html += '<div style="font-size:13px;font-weight:600;color:#fff">' + esc(r.titolo || '') + '</div>';
                if (r.descrizione) html += '<div style="font-size:12px;color:#a2a3b7">' + esc(r.descrizione) + '</div>';
                html += '</div>';
            });
            html += '</div>';
        }

        return html;
    }

    /**
     * Inietta il CSS della presentazione nel DOM (identico a gestione_scheda_didattica.php).
     */
    injectScalettaPresCSS() {
        const existing = document.getElementById('scalettaPresCSS');
        if (existing) existing.remove();
        const style = document.createElement('style');
        style.id = 'scalettaPresCSS';
        style.textContent = `
.pres-overlay{display:none;position:fixed;inset:0;z-index:9999;background:#0d0d1a;color:#fff;font-family:'Poppins','Segoe UI',-apple-system,sans-serif;overflow:hidden}
.pres-overlay.active{display:flex!important;flex-direction:column}
.pres-topbar{display:flex;align-items:center;justify-content:space-between;padding:10px 24px;background:rgba(0,0,0,.4);border-bottom:1px solid rgba(255,255,255,.08);flex-shrink:0}
.pres-topbar-left{display:flex;align-items:center;gap:12px}
.pres-topbar-title{font-size:13px;font-weight:600;color:#B5B5C3}
.pres-counter{font-size:12px;color:#565674;font-weight:600}
.pres-stage{flex:1;display:flex;align-items:center;justify-content:center;padding:30px 60px;overflow:hidden;position:relative}
.pres-slide{width:100%;max-width:960px;background:linear-gradient(145deg,#1e1e2d 0%,#1a1a2e 100%);border-radius:16px;padding:48px 56px;box-shadow:0 20px 60px rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.06);animation:sdSlideIn .35s ease;max-height:calc(100vh - 140px);overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}
.pres-slide::-webkit-scrollbar{display:none}
.pres-overlay *{scrollbar-width:none;-ms-overflow-style:none}
.pres-overlay *::-webkit-scrollbar{display:none}
@keyframes sdSlideIn{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}
.pres-slide-orario{display:inline-flex;align-items:center;gap:8px;font-size:14px;font-weight:700;margin-bottom:16px}
.pres-slide-orario .badge{padding:3px 10px;border-radius:4px;font-size:11px;font-weight:600;color:#fff}
.pres-slide h1{font-size:28px;font-weight:800;line-height:1.3;margin-bottom:20px;color:#fff}
.pres-slide-divider{height:3px;width:60px;border-radius:2px;margin-bottom:24px}
.pres-slide-content{font-size:16px;line-height:1.7;color:#d1d1e0;margin-bottom:20px}
.pres-punti-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:24px}
.pres-punto{display:flex;align-items:flex-start;gap:10px;background:rgba(255,255,255,.04);border-radius:8px;padding:12px 16px;border:1px solid rgba(255,255,255,.06)}
.pres-punto-icon{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0}
.pres-punto-text{font-size:14px;color:#d1d1e0;line-height:1.4}
.pres-domanda-box{background:rgba(246,78,96,.08);border:1px solid rgba(246,78,96,.2);border-radius:10px;padding:16px 20px;margin-bottom:16px}
.pres-domanda-box .pres-label{font-size:11px;font-weight:700;color:#F64E60;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px}
.pres-domanda-box .pres-text{font-size:16px;color:#fff;font-weight:500;line-height:1.5}
.pres-esempio-box{background:rgba(255,168,0,.08);border:1px solid rgba(255,168,0,.2);border-radius:10px;padding:16px 20px;margin-bottom:16px}
.pres-esempio-box .pres-label{font-size:11px;font-weight:700;color:#FFA800;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px}
.pres-esempio-box .pres-text{font-size:15px;color:#d1d1e0;line-height:1.5;font-style:italic}
.pres-mappa-centrale{text-align:center;margin:20px 0}
.pres-mappa-centrale span{display:inline-block;background:linear-gradient(135deg,#8950FC,#6c3bd4);color:#fff;padding:10px 30px;border-radius:24px;font-size:18px;font-weight:700;box-shadow:0 4px 16px rgba(137,80,252,.3)}
.pres-mappa-ramo{background:rgba(137,80,252,.08);border:1px solid rgba(137,80,252,.2);border-left:4px solid #8950FC;border-radius:0 10px 10px 0;padding:14px 18px;margin-bottom:10px}
.pres-mappa-ramo h4{font-size:15px;font-weight:700;color:#fff;margin-bottom:2px}
.pres-mappa-ramo .desc{font-size:13px;color:#B5B5C3;margin-top:4px}
.pres-mappa-sotto{margin-left:20px;margin-top:6px;font-size:12.5px;color:#7E8299}
.pres-esercizio-section{margin-bottom:16px}
.pres-esercizio-section .pres-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px}
.pres-esercizio-section .pres-text{font-size:15px;color:#d1d1e0;line-height:1.6}
.pres-riepilogo-item{display:flex;align-items:flex-start;gap:10px;padding:10px 14px;margin-bottom:6px;background:rgba(255,255,255,.03);border-radius:6px;border-left:3px solid #1BC5BD}
.pres-riepilogo-item span{font-size:14px;color:#B5B5C3;line-height:1.4}
.pres-nav{display:flex;align-items:center;justify-content:center;gap:16px;padding:14px 24px;background:rgba(0,0,0,.4);border-top:1px solid rgba(255,255,255,.08);flex-shrink:0}
.pres-progress{flex:1;max-width:500px;height:4px;background:rgba(255,255,255,.1);border-radius:2px;overflow:hidden}
.pres-progress-fill{height:100%;background:#3699FF;border-radius:2px;transition:width .3s}
.pres-nav-info{font-size:13px;color:#565674;font-weight:600;min-width:80px;text-align:center}
.pres-pip{position:fixed;bottom:80px;right:24px;width:240px;height:160px;border-radius:12px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,.6);border:2px solid rgba(255,255,255,.15);z-index:10001;background:#000;transition:opacity .3s}
.pres-pip:hover{border-color:rgba(54,153,255,.5)}
/* Inline Markdown */
.pres-overlay strong{color:#fff;font-weight:700}
.pres-overlay em{font-style:italic;color:#c8c8e0}
.pres-overlay u{text-decoration:underline;text-decoration-color:#FFA800;text-underline-offset:2px}
.pres-overlay mark{background:rgba(255,168,0,0.2)!important;color:#FFD740!important;padding:1px 4px;border-radius:3px;font-weight:600}

/* === CASO STUDIO SLIDE LAYOUTS (12 varianti) === */

/* --- SHARED --- */
.cs-slide-wrap{min-height:280px}

/* 1. Copertina: animated gradient + glassmorphism card */
.cs-copertina{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:40px 48px;min-height:340px;background:linear-gradient(135deg,#1a0a2e 0%,#2d1b4e 30%,#1e1e2d 60%,#0d0d1a 100%);background-size:200% 200%;animation:csGradShift 8s ease infinite;overflow:hidden}
@keyframes csGradShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
.cs-copertina::before{content:'';position:absolute;top:-30%;right:-15%;width:400px;height:400px;background:radial-gradient(circle,rgba(156,39,176,.2) 0%,transparent 70%);border-radius:50%;pointer-events:none}
.cs-copertina::after{content:'';position:absolute;bottom:-25%;left:-10%;width:350px;height:350px;background:radial-gradient(circle,rgba(206,147,216,.1) 0%,transparent 70%);border-radius:50%;pointer-events:none}
.cs-copertina>*{position:relative;z-index:1}
.cs-copertina .cs-icon-wrap{width:90px;height:90px;border-radius:50%;background:linear-gradient(135deg,#9C27B0,#CE93D8);display:flex;align-items:center;justify-content:center;margin-bottom:28px;box-shadow:0 8px 32px rgba(156,39,176,.4);animation:csIconFloat 3s ease-in-out infinite}
@keyframes csIconFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
.cs-copertina .cs-icon-wrap i{font-size:36px;color:#fff}
.cs-copertina .cs-glass-card{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);border-radius:20px;padding:32px 40px;max-width:640px;width:100%;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}
.cs-copertina .cs-glass-card h1{font-size:32px;font-weight:800;color:#fff;margin-bottom:12px;line-height:1.2}
.cs-copertina .cs-glass-card .cs-desc{font-size:16px;color:rgba(255,255,255,.7);line-height:1.7}
.cs-copertina .cs-badge{display:inline-flex;align-items:center;gap:6px;background:rgba(156,39,176,.2);border:1px solid rgba(156,39,176,.3);color:#CE93D8;padding:6px 18px;border-radius:20px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;margin-bottom:20px}

/* 2. Scenario: side accent stripe + narrative flow */
.cs-scenario{position:relative;padding:0;display:flex;min-height:300px;overflow:hidden}
.cs-scenario .cs-accent-bar{width:6px;flex-shrink:0;background:linear-gradient(180deg,#9C27B0,#CE93D8,#9C27B0);border-radius:3px 0 0 3px}
.cs-scenario .cs-scenario-body{flex:1;padding:40px 48px 36px 42px;display:flex;flex-direction:column}
.cs-scenario .cs-scenario-header{display:flex;align-items:center;gap:14px;margin-bottom:24px}
.cs-scenario .cs-scenario-icon{width:44px;height:44px;border-radius:12px;background:linear-gradient(135deg,rgba(156,39,176,.2),rgba(206,147,216,.15));border:1px solid rgba(156,39,176,.25);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.cs-scenario .cs-scenario-icon i{font-size:18px;color:#CE93D8}
.cs-scenario .cs-scenario-header h1{font-size:26px;font-weight:800;color:#fff;margin:0;line-height:1.2}
.cs-scenario .cs-narrative-points{display:flex;flex-direction:column;gap:14px;flex:1}
.cs-scenario .cs-narrative-item{display:flex;gap:14px;align-items:flex-start;padding:16px 20px;background:rgba(255,255,255,.03);border-radius:12px;border:1px solid rgba(255,255,255,.05)}
.cs-scenario .cs-narrative-num{width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#9C27B0,#7B1FA2);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#fff;flex-shrink:0;box-shadow:0 3px 12px rgba(156,39,176,.3)}
.cs-scenario .cs-narrative-text{font-size:15px;color:#d1d1e0;line-height:1.6;flex:1}
.cs-scenario .cs-narrazione-footer{margin-top:auto;padding-top:16px;font-size:13px;color:#7E8299;line-height:1.6;font-style:italic;border-top:1px solid rgba(255,255,255,.06)}

/* 3. Domande: question cards */
.cs-domande{padding:40px 48px}
.cs-domande .cs-domande-header{display:flex;align-items:center;gap:14px;margin-bottom:28px}
.cs-domande .cs-domande-icon{width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,#F64E60,#E85D7C);display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 4px 16px rgba(246,78,96,.3)}
.cs-domande .cs-domande-icon i{font-size:20px;color:#fff}
.cs-domande .cs-domande-header h1{font-size:26px;font-weight:800;color:#fff;margin:0}
.cs-domande .cs-domande-grid{display:flex;flex-direction:column;gap:14px}
.cs-domande .cs-domanda-card{display:flex;align-items:flex-start;gap:16px;padding:20px 24px;background:linear-gradient(135deg,rgba(246,78,96,.06),rgba(246,78,96,.02));border:1px solid rgba(246,78,96,.15);border-radius:14px;position:relative;overflow:hidden}
.cs-domande .cs-domanda-card::before{content:'?';position:absolute;right:16px;bottom:-8px;font-size:80px;font-weight:900;color:rgba(246,78,96,.04);line-height:1;pointer-events:none}
.cs-domande .cs-domanda-num{width:36px;height:36px;border-radius:10px;background:rgba(246,78,96,.15);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.cs-domande .cs-domanda-num i{font-size:16px;color:#F64E60}
.cs-domande .cs-domanda-text{font-size:16px;color:#fff;font-weight:500;line-height:1.5;position:relative;z-index:1}

/* 4. Punti Chiave: checklist cards */
.cs-puntichiave{padding:40px 48px}
.cs-puntichiave .cs-pk-header{display:flex;align-items:center;gap:14px;margin-bottom:28px}
.cs-puntichiave .cs-pk-icon{width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,#1BC5BD,#0bb4ad);display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 4px 16px rgba(27,197,189,.3)}
.cs-puntichiave .cs-pk-icon i{font-size:20px;color:#fff}
.cs-puntichiave .cs-pk-header h1{font-size:26px;font-weight:800;color:#fff;margin:0}
.cs-puntichiave .cs-pk-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.cs-puntichiave .cs-pk-card{display:flex;align-items:flex-start;gap:14px;padding:18px 20px;background:rgba(27,197,189,.06);border:1px solid rgba(27,197,189,.15);border-radius:14px}
.cs-puntichiave .cs-pk-check{width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#1BC5BD,#0bb4ad);display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 2px 8px rgba(27,197,189,.25)}
.cs-puntichiave .cs-pk-check i{font-size:12px;color:#fff}
.cs-puntichiave .cs-pk-text{font-size:14px;color:#d1d1e0;line-height:1.5;font-weight:500}
.cs-puntichiave .cs-pk-footer{margin-top:20px;font-size:13px;color:#7E8299;line-height:1.6;font-style:italic;border-top:1px solid rgba(255,255,255,.06);padding-top:16px}

/* 5. Timeline: vertical timeline with dots + connectors */
.cs-timeline{padding:40px 48px}
.cs-timeline .cs-tl-header{display:flex;align-items:center;gap:14px;margin-bottom:28px}
.cs-timeline .cs-tl-icon{width:44px;height:44px;border-radius:12px;background:linear-gradient(135deg,rgba(54,153,255,.2),rgba(54,153,255,.1));border:1px solid rgba(54,153,255,.25);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.cs-timeline .cs-tl-icon i{font-size:18px;color:#3699FF}
.cs-timeline .cs-tl-header h1{font-size:26px;font-weight:800;color:#fff;margin:0}
.cs-timeline .cs-tl-list{position:relative;padding-left:36px}
.cs-timeline .cs-tl-list::before{content:'';position:absolute;left:14px;top:8px;bottom:8px;width:2px;background:linear-gradient(180deg,#3699FF,rgba(54,153,255,.15));border-radius:1px}
.cs-timeline .cs-tl-item{position:relative;margin-bottom:18px;padding:16px 20px;background:rgba(54,153,255,.04);border:1px solid rgba(54,153,255,.1);border-radius:12px}
.cs-timeline .cs-tl-item::before{content:'';position:absolute;left:-28px;top:22px;width:12px;height:12px;border-radius:50%;background:#3699FF;box-shadow:0 0 0 4px rgba(54,153,255,.2),0 2px 8px rgba(54,153,255,.3)}
.cs-timeline .cs-tl-text{font-size:15px;color:#d1d1e0;line-height:1.6}

/* 6. Split: left accent panel + right content */
.cs-split{display:flex;min-height:300px;overflow:hidden;padding:0}
.cs-split .cs-split-left{width:38%;background:linear-gradient(160deg,#2d1b4e 0%,#1a0a2e 100%);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 32px;text-align:center;position:relative;overflow:hidden}
.cs-split .cs-split-left::after{content:'';position:absolute;bottom:-20%;right:-30%;width:200px;height:200px;background:radial-gradient(circle,rgba(156,39,176,.25) 0%,transparent 70%);border-radius:50%;pointer-events:none}
.cs-split .cs-split-left>*{position:relative;z-index:1}
.cs-split .cs-split-left .cs-split-icon{width:60px;height:60px;border-radius:50%;background:linear-gradient(135deg,#9C27B0,#CE93D8);display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 24px rgba(156,39,176,.35)}
.cs-split .cs-split-left .cs-split-icon i{font-size:24px;color:#fff}
.cs-split .cs-split-left h1{font-size:22px;font-weight:800;color:#fff;line-height:1.3;margin:0}
.cs-split .cs-split-left .cs-split-sub{font-size:12px;color:#CE93D8;margin-top:10px;font-weight:600;text-transform:uppercase;letter-spacing:.5px}
.cs-split .cs-split-right{flex:1;padding:36px 40px;display:flex;flex-direction:column;justify-content:center;gap:12px}
.cs-split .cs-split-card{display:flex;align-items:flex-start;gap:12px;padding:14px 18px;background:rgba(156,39,176,.04);border:1px solid rgba(156,39,176,.1);border-radius:10px;border-left:3px solid #9C27B0}
.cs-split .cs-split-num{width:26px;height:26px;border-radius:50%;background:#9C27B0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#fff;flex-shrink:0}
.cs-split .cs-split-text{font-size:14px;color:#d1d1e0;line-height:1.5}

/* 7. Big Numbers: oversized numbered blocks */
.cs-bignums{padding:40px 48px}
.cs-bignums .cs-bn-header{display:flex;align-items:center;gap:14px;margin-bottom:28px}
.cs-bignums .cs-bn-badge{display:inline-flex;align-items:center;gap:6px;background:rgba(255,168,0,.12);border:1px solid rgba(255,168,0,.25);color:#FFA800;padding:5px 14px;border-radius:16px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.6px}
.cs-bignums .cs-bn-header h1{font-size:26px;font-weight:800;color:#fff;margin:0}
.cs-bignums .cs-bn-list{display:flex;flex-direction:column;gap:16px}
.cs-bignums .cs-bn-item{display:flex;align-items:flex-start;gap:20px;padding:20px 24px;background:rgba(255,255,255,.02);border-radius:14px;border:1px solid rgba(255,255,255,.05)}
.cs-bignums .cs-bn-num{font-size:48px;font-weight:900;line-height:1;color:#FFA800;opacity:.7;flex-shrink:0;min-width:50px;text-align:center;text-shadow:0 4px 16px rgba(255,168,0,.2)}
.cs-bignums .cs-bn-text{font-size:15px;color:#d1d1e0;line-height:1.6;padding-top:8px}

/* 8. Cards Float: floating glass cards */
.cs-cardsfloat{padding:40px 48px}
.cs-cardsfloat .cs-cf-header{margin-bottom:24px}
.cs-cardsfloat .cs-cf-header h1{font-size:26px;font-weight:800;color:#fff;margin:0 0 6px}
.cs-cardsfloat .cs-cf-header .cs-cf-line{height:3px;width:80px;border-radius:2px;background:linear-gradient(90deg,#8950FC,transparent)}
.cs-cardsfloat .cs-cf-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.cs-cardsfloat .cs-cf-card{padding:22px 20px;background:linear-gradient(145deg,rgba(137,80,252,.08),rgba(137,80,252,.02));border:1px solid rgba(137,80,252,.15);border-radius:16px;position:relative;overflow:hidden}
.cs-cardsfloat .cs-cf-card::after{content:'';position:absolute;top:-20px;right:-20px;width:80px;height:80px;background:radial-gradient(circle,rgba(137,80,252,.1) 0%,transparent 70%);border-radius:50%;pointer-events:none}
.cs-cardsfloat .cs-cf-card-icon{display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;background:rgba(137,80,252,.15);margin-bottom:12px}
.cs-cardsfloat .cs-cf-card-icon i{font-size:14px;color:#8950FC}
.cs-cardsfloat .cs-cf-card-text{font-size:14px;color:#d1d1e0;line-height:1.5;position:relative;z-index:1}
.cs-cardsfloat .cs-cf-narr{margin-top:16px;font-size:13px;color:#7E8299;font-style:italic;line-height:1.6}

/* 9. Banner Top: colored banner + clean content */
.cs-banner{padding:0;overflow:hidden}
.cs-banner .cs-ban-top{background:linear-gradient(135deg,#2d1b4e,#3B3476);padding:28px 48px;position:relative;overflow:hidden}
.cs-banner .cs-ban-top::before{content:'';position:absolute;top:-40%;right:-10%;width:300px;height:300px;background:radial-gradient(circle,rgba(206,147,216,.15) 0%,transparent 70%);border-radius:50%;pointer-events:none}
.cs-banner .cs-ban-top>*{position:relative;z-index:1}
.cs-banner .cs-ban-top h1{font-size:28px;font-weight:800;color:#fff;margin:0 0 6px}
.cs-banner .cs-ban-top .cs-ban-sub{font-size:13px;color:#CE93D8;font-weight:600}
.cs-banner .cs-ban-body{padding:28px 48px}
.cs-banner .cs-ban-list{display:flex;flex-direction:column;gap:12px}
.cs-banner .cs-ban-item{display:flex;align-items:center;gap:14px;padding:14px 18px;background:rgba(255,255,255,.03);border-radius:10px;border:1px solid rgba(255,255,255,.06)}
.cs-banner .cs-ban-dot{width:10px;height:10px;border-radius:50%;flex-shrink:0}
.cs-banner .cs-ban-text{font-size:14px;color:#d1d1e0;line-height:1.5}

/* 10. Spotlight: large centered quote/text for narration-heavy */
.cs-spotlight{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:48px 60px;min-height:320px;position:relative;overflow:hidden}
.cs-spotlight::before{content:'\\201C';position:absolute;top:20px;left:40px;font-size:120px;font-weight:900;color:rgba(156,39,176,.06);line-height:1;pointer-events:none;font-family:Georgia,serif}
.cs-spotlight .cs-spot-icon{width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,#9C27B0,#7B1FA2);display:flex;align-items:center;justify-content:center;margin-bottom:24px;box-shadow:0 6px 20px rgba(156,39,176,.3)}
.cs-spotlight .cs-spot-icon i{font-size:22px;color:#fff}
.cs-spotlight h1{font-size:24px;font-weight:800;color:#fff;margin-bottom:20px}
.cs-spotlight .cs-spot-text{font-size:18px;color:#d1d1e0;line-height:1.8;max-width:700px;font-weight:400}
.cs-spotlight .cs-spot-points{display:flex;flex-direction:column;gap:10px;margin-top:20px;text-align:left;max-width:600px;width:100%}
.cs-spotlight .cs-spot-point{display:flex;align-items:center;gap:10px;font-size:15px;color:#d1d1e0}
.cs-spotlight .cs-spot-point .cs-spot-bullet{width:8px;height:8px;border-radius:50%;background:#9C27B0;flex-shrink:0}

/* 11. Magazine: two-column editorial */
.cs-magazine{padding:40px 48px}
.cs-magazine .cs-mag-header{margin-bottom:24px;padding-bottom:16px;border-bottom:2px solid rgba(255,168,0,.2)}
.cs-magazine .cs-mag-header h1{font-size:28px;font-weight:800;color:#fff;margin:0 0 4px}
.cs-magazine .cs-mag-header .cs-mag-sub{font-size:12px;color:#FFA800;font-weight:700;text-transform:uppercase;letter-spacing:1px}
.cs-magazine .cs-mag-cols{display:grid;grid-template-columns:1fr 1fr;gap:24px}
.cs-magazine .cs-mag-col{display:flex;flex-direction:column;gap:14px}
.cs-magazine .cs-mag-item{font-size:14px;color:#d1d1e0;line-height:1.7;padding-left:14px;border-left:2px solid rgba(255,168,0,.25)}
.cs-magazine .cs-mag-narr{margin-top:20px;padding:16px 20px;background:rgba(255,168,0,.05);border:1px solid rgba(255,168,0,.12);border-radius:10px;font-size:13px;color:#B5B5C3;line-height:1.6;font-style:italic}

/* 12. Icon Grid: icon + text cards with varied colors */
.cs-icongrid{padding:40px 48px}
.cs-icongrid .cs-ig-header{display:flex;align-items:center;gap:14px;margin-bottom:28px}
.cs-icongrid .cs-ig-header h1{font-size:26px;font-weight:800;color:#fff;margin:0}
.cs-icongrid .cs-ig-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.cs-icongrid .cs-ig-card{display:flex;flex-direction:column;align-items:center;text-align:center;padding:24px 18px;border-radius:16px;border:1px solid rgba(255,255,255,.06);background:rgba(255,255,255,.02);position:relative;overflow:hidden}
.cs-icongrid .cs-ig-card::before{content:'';position:absolute;top:0;left:0;right:0;height:4px;border-radius:16px 16px 0 0}
.cs-icongrid .cs-ig-card:nth-child(1)::before{background:linear-gradient(90deg,#9C27B0,#CE93D8)}
.cs-icongrid .cs-ig-card:nth-child(2)::before{background:linear-gradient(90deg,#3699FF,#69B3FF)}
.cs-icongrid .cs-ig-card:nth-child(3)::before{background:linear-gradient(90deg,#FFA800,#FFD54F)}
.cs-icongrid .cs-ig-card:nth-child(4)::before{background:linear-gradient(90deg,#1BC5BD,#4DD0E1)}
.cs-icongrid .cs-ig-card:nth-child(n+5)::before{background:linear-gradient(90deg,#8950FC,#B388FF)}
.cs-icongrid .cs-ig-circle{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-bottom:14px}
.cs-icongrid .cs-ig-card:nth-child(1) .cs-ig-circle{background:rgba(156,39,176,.15)}
.cs-icongrid .cs-ig-card:nth-child(2) .cs-ig-circle{background:rgba(54,153,255,.15)}
.cs-icongrid .cs-ig-card:nth-child(3) .cs-ig-circle{background:rgba(255,168,0,.15)}
.cs-icongrid .cs-ig-card:nth-child(4) .cs-ig-circle{background:rgba(27,197,189,.15)}
.cs-icongrid .cs-ig-card:nth-child(n+5) .cs-ig-circle{background:rgba(137,80,252,.15)}
.cs-icongrid .cs-ig-circle i{font-size:18px}
.cs-icongrid .cs-ig-card:nth-child(1) .cs-ig-circle i{color:#CE93D8}
.cs-icongrid .cs-ig-card:nth-child(2) .cs-ig-circle i{color:#3699FF}
.cs-icongrid .cs-ig-card:nth-child(3) .cs-ig-circle i{color:#FFA800}
.cs-icongrid .cs-ig-card:nth-child(4) .cs-ig-circle i{color:#1BC5BD}
.cs-icongrid .cs-ig-card:nth-child(n+5) .cs-ig-circle i{color:#8950FC}
.cs-icongrid .cs-ig-text{font-size:13px;color:#d1d1e0;line-height:1.5}

@media(max-width:768px){
.cs-copertina .cs-glass-card{padding:20px 24px}
.cs-copertina .cs-glass-card h1{font-size:24px}
.cs-scenario .cs-scenario-body{padding:24px 20px}
.cs-puntichiave .cs-pk-grid{grid-template-columns:1fr}
.cs-split{flex-direction:column}
.cs-split .cs-split-left{width:100%;padding:24px}
.cs-cardsfloat .cs-cf-grid{grid-template-columns:1fr}
.cs-magazine .cs-mag-cols{grid-template-columns:1fr}
.cs-icongrid .cs-ig-grid{grid-template-columns:1fr}
}
        `;
        document.head.appendChild(style);
    }

    hideScalettaOverlay() {
        this.scalettaActive = false;
        this.scalettaSlides = [];
        this.scalettaCurrentSlide = 0;

        // Ripristina iframe Jitsi nella posizione originale
        this.restoreJitsiFromPip();

        const overlay = document.getElementById('scalettaOverlay');
        if (overlay) overlay.remove();
        document.body.style.overflow = '';
    }

    /**
     * Sposta l'iframe Jitsi in un riquadro PiP dentro l'overlay della presentazione.
     */
    /**
     * Riposiziona l'iframe Jitsi come PiP tramite CSS (senza spostarlo nel DOM).
     * Non fa appendChild — evita il reload dell'iframe e la disconnessione.
     */
    moveJitsiToPip() {
        const jitsiContainer = document.getElementById('jitsi-iframe');
        if (!jitsiContainer) return;

        // Nascondi la toolbar custom e altri div (barra rossa, logo)
        const children = jitsiContainer.children;
        for (let i = 0; i < children.length; i++) {
            const child = children[i] as HTMLElement;
            if (child.tagName === 'DIV') {
                child.setAttribute('data-pip-hidden', child.style.display || '');
                child.style.display = 'none';
            }
        }

        // Riposiziona il container come PiP con position fixed
        jitsiContainer.style.position = 'fixed';
        jitsiContainer.style.width = '240px';
        jitsiContainer.style.height = '160px';
        jitsiContainer.style.bottom = '80px';
        jitsiContainer.style.right = '24px';
        jitsiContainer.style.top = 'auto';
        jitsiContainer.style.left = 'auto';
        jitsiContainer.style.zIndex = '10001';
        jitsiContainer.style.borderRadius = '12px';
        jitsiContainer.style.overflow = 'hidden';
        jitsiContainer.style.boxShadow = '0 8px 32px rgba(0,0,0,.6)';
        jitsiContainer.style.border = '2px solid rgba(255,255,255,.15)';

        // Leggero zoom per ritagliare label residue ai bordi
        const iframe = jitsiContainer.querySelector('iframe') as HTMLElement;
        if (iframe) {
            iframe.style.borderRadius = '12px';
            iframe.style.transform = 'scale(1.12)';
            iframe.style.transformOrigin = 'center center';
        }

        // Nascondi il div placeholder PiP (non serve piu, l'iframe resta in place)
        const pipEl = document.getElementById('scalettaPip');
        if (pipEl) pipEl.style.display = 'none';

        // Pinna il video del docente come large video e disattiva tile view
        if (this.api) {
            try {
                this.api.executeCommand('setTileView', false);
                const docenteId = (this as any)._docenteParticipantId;
                if (docenteId) {
                    this.api.executeCommand('setLargeVideoParticipant', docenteId);
                }
            } catch (e) {}
        }
    }

    /**
     * Ripristina l'iframe Jitsi a schermo intero (posizione originale).
     */
    restoreJitsiFromPip() {
        const jitsiContainer = document.getElementById('jitsi-iframe');
        if (!jitsiContainer) return;

        // Ripristina stili originali
        jitsiContainer.style.position = 'fixed';
        jitsiContainer.style.width = '100%';
        jitsiContainer.style.height = '100%';
        jitsiContainer.style.top = '0px';
        jitsiContainer.style.left = '';
        jitsiContainer.style.bottom = '';
        jitsiContainer.style.right = '';
        jitsiContainer.style.zIndex = '999';
        jitsiContainer.style.borderRadius = '';
        jitsiContainer.style.overflow = '';
        jitsiContainer.style.boxShadow = '';
        jitsiContainer.style.border = '';

        // Ripristina iframe interno
        const iframe = jitsiContainer.querySelector('iframe') as HTMLElement;
        if (iframe) {
            iframe.style.borderRadius = '';
            iframe.style.transform = '';
            iframe.style.transformOrigin = '';
        }

        // Ripristina il display originale degli elementi nascosti durante il PiP
        const hidden = jitsiContainer.querySelectorAll('[data-pip-hidden]');
        hidden.forEach((el: any) => {
            const origDisplay = el.getAttribute('data-pip-hidden');
            // Se il display originale era vuoto (non settato inline), rimuovi l'override
            // in modo che il CSS/Angular possa gestirlo
            if (origDisplay === '' || origDisplay === null) {
                el.style.removeProperty('display');
            } else {
                el.style.display = origDisplay;
            }
            el.removeAttribute('data-pip-hidden');
        });

        // Fallback: assicura che TUTTI i DIV figli diretti siano visibili
        // (in caso Angular li abbia ricreati senza data-pip-hidden)
        const children = jitsiContainer.children;
        for (let i = 0; i < children.length; i++) {
            const child = children[i] as HTMLElement;
            if (child.tagName === 'DIV' && child.style.display === 'none' && !child.hasAttribute('data-pip-hidden')) {
                child.style.removeProperty('display');
            }
        }

        // Ripristina la tile view e sblocca il pinning
        if (this.api) {
            try {
                this.api.executeCommand('setLargeVideoParticipant', '');
                this.api.executeCommand('setTileView', true);
            } catch (e) {}
        }
    }

    startScalettaPolling() {
        this.stopScalettaPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.scalettaPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/scaletta-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;
                if (resp.active && resp.state) {
                    if (!self.scalettaActive) {
                        self.showScalettaOverlay(resp.state.titolo, resp.state.content);
                    } else {
                        // Aggiorna slide corrente se cambiata
                        self.updateScalettaSlide(resp.state.content);
                    }
                } else if (!resp.active && self.scalettaActive) {
                    self.hideScalettaOverlay();
                }
                // Check pausa countdown per late-join e re-sync
                if (resp.pausa && resp.pausa.type !== 'stop') {
                    const serverEndTime = (resp.pausa.endTime || 0) * 1000; // ms
                    const remaining = Math.max(0, Math.round((serverEndTime - Date.now()) / 1000));
                    if (remaining > 0) {
                        self._pausaTotalSec = resp.pausa.totalSec || 0;
                        self._pausaEndTime = Date.now() + remaining * 1000;
                        if (!self._pausaCountdownInterval) {
                            self.startPausaCountdownUI();
                        }
                    }
                } else if (!resp.pausa && self._pausaCountdownInterval) {
                    self.stopPausaCountdownUI();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopScalettaPolling() {
        if (this.scalettaPollingInterval) {
            clearInterval(this.scalettaPollingInterval);
            this.scalettaPollingInterval = null;
        }
    }

    // =========================================================================
    // CASO STUDIO: presentazione auto-play con TTS dal docente
    // =========================================================================

    handleCasoStudioSync(data: any) {
        console.log('[CasoStudio] Sync ricevuto:', data.type);

        if (data.type === 'start' && data.slides) {
            this.showCasoStudioOverlay(data);
        } else if (data.type === 'slide') {
            if (this.casoStudioActive && typeof data.currentSlide === 'number') {
                this.casoStudioCurrentSlide = data.currentSlide;
                this.renderCasoStudioSlide();
                this.playCasoStudioAudio();
            }
        } else if (data.type === 'pause') {
            this.casoStudioPaused = true;
            if (this.casoStudioAudio) this.casoStudioAudio.pause();
        } else if (data.type === 'resume') {
            this.casoStudioPaused = false;
            if (this.casoStudioAudio) this.casoStudioAudio.play().catch(() => {});
        } else if (data.type === 'stop') {
            this.hideCasoStudioOverlay();
        }
    }

    showCasoStudioOverlay(data: any) {
        // Se gia' attivo, aggiorna solo la slide
        if (this.casoStudioActive && document.getElementById('casoStudioOverlay')) {
            if (typeof data.currentSlide === 'number') {
                this.casoStudioCurrentSlide = data.currentSlide;
                this.renderCasoStudioSlide();
                this.playCasoStudioAudio();
            }
            return;
        }

        // Nascondi scaletta se attiva (caso studio ha priorita') — salva stato per ripristino
        (this as any)._scalettaWasActive = this.scalettaActive;
        if (this.scalettaActive) {
            // Nascondi overlay scaletta senza cancellare i dati
            const scalOv = document.getElementById('scalettaOverlay');
            if (scalOv) scalOv.style.display = 'none';
        }

        const old = document.getElementById('casoStudioOverlay');
        if (old) old.remove();

        this.casoStudioSlides = data.slides || [];
        this.casoStudioCurrentSlide = data.currentSlide || 0;
        this.casoStudioPaused = false;
        this.casoStudioActive = true;

        if (!this.casoStudioSlides.length) return;

        // Inietta CSS se non presente
        this.injectScalettaPresCSS();

        const overlay = document.createElement('div');
        overlay.id = 'casoStudioOverlay';
        overlay.className = 'pres-overlay active';

        overlay.innerHTML =
            '<div class="pres-topbar">' +
                '<div class="pres-topbar-left">' +
                    '<div style="display:flex;align-items:center;gap:8px">' +
                        '<div style="width:8px;height:8px;border-radius:50%;background:#9C27B0;animation:csPulse 1.5s ease-in-out infinite"></div>' +
                        '<div class="pres-topbar-title" style="color:#CE93D8"><i class="fas fa-briefcase" style="margin-right:6px"></i>Caso Studio</div>' +
                    '</div>' +
                '</div>' +
                '<div style="display:flex;align-items:center;gap:12px">' +
                    '<div id="csAudioIndicator" style="display:flex;align-items:center;gap:4px;color:#9C27B0;font-size:11px;font-weight:600"><i class="fas fa-volume-up"></i> <span>Audio</span></div>' +
                    '<div class="pres-counter" id="csCounter"></div>' +
                '</div>' +
            '</div>' +
            '<div class="pres-stage"><div class="pres-slide" id="csSlideContent" style="border:1px solid rgba(156,39,176,.15)"></div></div>' +
            '<div class="pres-nav">' +
                '<div class="pres-progress"><div class="pres-progress-fill" id="csProgress" style="background:linear-gradient(90deg,#9C27B0,#CE93D8)"></div></div>' +
                '<div class="pres-nav-info" id="csNavInfo"></div>' +
            '</div>' +
            '<div class="pres-pip" id="csPip"></div>';

        // Inject pulse animation
        if (!document.getElementById('csPulseCSS')) {
            const pulseStyle = document.createElement('style');
            pulseStyle.id = 'csPulseCSS';
            pulseStyle.textContent = '@keyframes csPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.4;transform:scale(.7)}}';
            document.head.appendChild(pulseStyle);
        }

        document.body.appendChild(overlay);

        // Sposta Jitsi in PiP
        this.moveJitsiToPip();

        // Render prima slide e avvia audio
        this.renderCasoStudioSlide();
        this.playCasoStudioAudio();
    }

    hideCasoStudioOverlay() {
        this.casoStudioActive = false;
        this.casoStudioPaused = false;
        this.casoStudioSlides = [];
        this.casoStudioCurrentSlide = 0;

        if (this.casoStudioAudio) {
            this.casoStudioAudio.pause();
            this.casoStudioAudio = null;
        }

        const overlay = document.getElementById('casoStudioOverlay');
        if (overlay) overlay.remove();

        // Ripristina scaletta se era attiva prima del caso studio
        if ((this as any)._scalettaWasActive && this.scalettaActive) {
            const scalOv = document.getElementById('scalettaOverlay');
            if (scalOv) {
                scalOv.style.display = '';
                // Jitsi e' gia' in PiP dalla scaletta, non serve ripristinare
                return;
            }
        }

        this.restoreJitsiFromPip();
    }

    /**
     * Detecta il layout da usare per una slide caso studio.
     * Prima controlla keywords nel titolo per layout semantici,
     * poi ruota tra layout generici per garantire varieta' visiva.
     */
    detectCasoStudioLayout(slide: any, idx: number, total: number): string {
        // Copertina: prima slide o tipo esplicito
        if (slide.tipo === 'copertina' || idx === 0) return 'copertina';

        const t = (slide.titolo || '').toLowerCase();

        // Layout semantici per keywords
        if (t.includes('domand') || t.includes('rifless') || t.includes('question')) return 'domande';
        if (t.includes('punti chiave') || t.includes('takeaway') || t.includes('riepilog') || t.includes('conclus')) return 'puntichiave';
        if (t.includes('scenario') || t.includes('contesto') || t.includes('situazione')) return 'scenario';

        // Ultima slide → punti chiave (se non catturata sopra)
        if (idx === total - 1) return 'puntichiave';

        // Slide con solo narrazione (no punti) → spotlight
        if ((!slide.punti || !slide.punti.length) && slide.narrazione) return 'spotlight';

        // Rotazione tra layout generici per varieta'
        const genericLayouts = ['timeline', 'split', 'bignums', 'cardsfloat', 'banner', 'magazine', 'icongrid'];
        return genericLayouts[(idx - 1) % genericLayouts.length];
    }

    renderCasoStudioSlide() {
        const container = document.getElementById('csSlideContent');
        if (!container || !this.casoStudioSlides.length) return;

        if (this.casoStudioCurrentSlide >= this.casoStudioSlides.length) this.casoStudioCurrentSlide = 0;
        const s = this.casoStudioSlides[this.casoStudioCurrentSlide];
        const total = this.casoStudioSlides.length;
        const idx = this.casoStudioCurrentSlide;

        const counter = document.getElementById('csCounter');
        if (counter) counter.textContent = (idx + 1) + ' / ' + total;
        const navInfo = document.getElementById('csNavInfo');
        if (navInfo) navInfo.textContent = (idx + 1) + ' di ' + total;
        const progress = document.getElementById('csProgress');
        if (progress) progress.style.width = ((idx + 1) / total * 100) + '%';

        const esc = (str: string) => this.escHtml(str || '');
        const layout = this.detectCasoStudioLayout(s, idx, total);

        // Reset container padding — layouts manage their own
        container.style.padding = '0';

        // Icone tematiche per varieta'
        const icons = ['fa-lightbulb', 'fa-shield-alt', 'fa-users', 'fa-cogs', 'fa-bullhorn', 'fa-map-marked-alt', 'fa-clipboard-check', 'fa-exclamation-triangle', 'fa-hands-helping', 'fa-heartbeat'];
        const slideIcon = icons[idx % icons.length];
        // Colori per banner dots
        const dotColors = ['#9C27B0', '#3699FF', '#FFA800', '#1BC5BD', '#F64E60', '#8950FC'];

        let html = '';

        switch (layout) {
            case 'copertina':
                html += '<div class="cs-copertina">';
                html += '<div class="cs-badge"><i class="fas fa-briefcase"></i> Caso Studio</div>';
                html += '<div class="cs-icon-wrap"><i class="fas fa-briefcase"></i></div>';
                html += '<div class="cs-glass-card">';
                html += '<h1>' + esc(s.titolo) + '</h1>';
                // Mostra descrizione o narrazione (testo completo, non troncato)
                const descText = s.descrizione || s.narrazione || '';
                if (descText) html += '<div class="cs-desc">' + esc(descText) + '</div>';
                html += '</div></div>';
                break;

            case 'scenario':
                html += '<div class="cs-scenario">';
                html += '<div class="cs-accent-bar"></div>';
                html += '<div class="cs-scenario-body">';
                html += '<div class="cs-scenario-header">';
                html += '<div class="cs-scenario-icon"><i class="fas fa-theater-masks"></i></div>';
                html += '<h1>' + esc(s.titolo) + '</h1>';
                html += '</div>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-narrative-points">';
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-narrative-item"><div class="cs-narrative-num">' + (i + 1) + '</div><div class="cs-narrative-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                if (s.narrazione && !s.punti?.length) html += '<div class="cs-narrazione-footer">' + esc(s.narrazione) + '</div>';
                html += '</div></div>';
                break;

            case 'domande':
                html += '<div class="cs-domande">';
                html += '<div class="cs-domande-header"><div class="cs-domande-icon"><i class="fas fa-question"></i></div><h1>' + esc(s.titolo) + '</h1></div>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-domande-grid">';
                    s.punti.forEach((p: string) => {
                        html += '<div class="cs-domanda-card"><div class="cs-domanda-num"><i class="fas fa-comment-dots"></i></div><div class="cs-domanda-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                html += '</div>';
                break;

            case 'puntichiave':
                html += '<div class="cs-puntichiave">';
                html += '<div class="cs-pk-header"><div class="cs-pk-icon"><i class="fas fa-star"></i></div><h1>' + esc(s.titolo) + '</h1></div>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-pk-grid">';
                    s.punti.forEach((p: string) => {
                        html += '<div class="cs-pk-card"><div class="cs-pk-check"><i class="fas fa-check"></i></div><div class="cs-pk-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                if (s.narrazione) html += '<div class="cs-pk-footer">' + esc(s.narrazione) + '</div>';
                html += '</div>';
                break;

            case 'timeline':
                html += '<div class="cs-timeline">';
                html += '<div class="cs-tl-header"><div class="cs-tl-icon"><i class="fas ' + slideIcon + '"></i></div><h1>' + esc(s.titolo) + '</h1></div>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-tl-list">';
                    s.punti.forEach((p: string) => {
                        html += '<div class="cs-tl-item"><div class="cs-tl-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                html += '</div>';
                break;

            case 'split':
                html += '<div class="cs-split">';
                html += '<div class="cs-split-left">';
                html += '<div class="cs-split-icon"><i class="fas ' + slideIcon + '"></i></div>';
                html += '<h1>' + esc(s.titolo) + '</h1>';
                html += '<div class="cs-split-sub">Caso Studio</div>';
                html += '</div>';
                html += '<div class="cs-split-right">';
                if (s.punti && s.punti.length) {
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-split-card"><div class="cs-split-num">' + (i + 1) + '</div><div class="cs-split-text">' + esc(p) + '</div></div>';
                    });
                }
                if (s.narrazione && !s.punti?.length) html += '<div style="font-size:14px;color:#d1d1e0;line-height:1.7;padding:14px 18px">' + esc(s.narrazione) + '</div>';
                html += '</div></div>';
                break;

            case 'bignums':
                html += '<div class="cs-bignums">';
                html += '<div class="cs-bn-header"><div class="cs-bn-badge"><i class="fas ' + slideIcon + '" style="margin-right:4px"></i> Approfondimento</div></div>';
                html += '<h1 style="font-size:26px;font-weight:800;color:#fff;margin:0 0 24px">' + esc(s.titolo) + '</h1>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-bn-list">';
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-bn-item"><div class="cs-bn-num">0' + (i + 1) + '</div><div class="cs-bn-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                html += '</div>';
                break;

            case 'cardsfloat':
                html += '<div class="cs-cardsfloat">';
                html += '<div class="cs-cf-header"><h1>' + esc(s.titolo) + '</h1><div class="cs-cf-line"></div></div>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-cf-grid">';
                    const cfIcons = ['fa-lightbulb', 'fa-puzzle-piece', 'fa-bullseye', 'fa-layer-group', 'fa-gem', 'fa-rocket'];
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-cf-card"><div class="cs-cf-card-icon"><i class="fas ' + cfIcons[i % cfIcons.length] + '"></i></div><div class="cs-cf-card-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                if (s.narrazione) html += '<div class="cs-cf-narr">' + esc(s.narrazione) + '</div>';
                html += '</div>';
                break;

            case 'banner':
                html += '<div class="cs-banner">';
                html += '<div class="cs-ban-top"><h1>' + esc(s.titolo) + '</h1><div class="cs-ban-sub"><i class="fas ' + slideIcon + '" style="margin-right:4px"></i>Caso Studio</div></div>';
                html += '<div class="cs-ban-body">';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-ban-list">';
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-ban-item"><div class="cs-ban-dot" style="background:' + dotColors[i % dotColors.length] + '"></div><div class="cs-ban-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                html += '</div></div>';
                break;

            case 'spotlight':
                html += '<div class="cs-spotlight">';
                html += '<div class="cs-spot-icon"><i class="fas ' + slideIcon + '"></i></div>';
                html += '<h1>' + esc(s.titolo) + '</h1>';
                if (s.punti && s.punti.length) {
                    html += '<div class="cs-spot-points">';
                    s.punti.forEach((p: string) => {
                        html += '<div class="cs-spot-point"><div class="cs-spot-bullet"></div>' + esc(p) + '</div>';
                    });
                    html += '</div>';
                } else if (s.narrazione) {
                    html += '<div class="cs-spot-text">' + esc(s.narrazione) + '</div>';
                }
                html += '</div>';
                break;

            case 'magazine':
                html += '<div class="cs-magazine">';
                html += '<div class="cs-mag-header"><div class="cs-mag-sub"><i class="fas ' + slideIcon + '" style="margin-right:4px"></i>Caso Studio</div><h1>' + esc(s.titolo) + '</h1></div>';
                if (s.punti && s.punti.length) {
                    const half = Math.ceil(s.punti.length / 2);
                    html += '<div class="cs-mag-cols"><div class="cs-mag-col">';
                    s.punti.slice(0, half).forEach((p: string) => {
                        html += '<div class="cs-mag-item">' + esc(p) + '</div>';
                    });
                    html += '</div><div class="cs-mag-col">';
                    s.punti.slice(half).forEach((p: string) => {
                        html += '<div class="cs-mag-item">' + esc(p) + '</div>';
                    });
                    html += '</div></div>';
                }
                if (s.narrazione) html += '<div class="cs-mag-narr">' + esc(s.narrazione) + '</div>';
                html += '</div>';
                break;

            case 'icongrid':
                html += '<div class="cs-icongrid">';
                html += '<div class="cs-ig-header"><h1>' + esc(s.titolo) + '</h1></div>';
                if (s.punti && s.punti.length) {
                    const igIcons = ['fa-shield-alt', 'fa-users', 'fa-bullhorn', 'fa-heartbeat', 'fa-cogs', 'fa-map-marked-alt'];
                    html += '<div class="cs-ig-grid">';
                    s.punti.forEach((p: string, i: number) => {
                        html += '<div class="cs-ig-card"><div class="cs-ig-circle"><i class="fas ' + igIcons[i % igIcons.length] + '"></i></div><div class="cs-ig-text">' + esc(p) + '</div></div>';
                    });
                    html += '</div>';
                }
                html += '</div>';
                break;

            default:
                // Fallback ultra-semplice
                html += '<div style="padding:40px 48px">';
                html += '<h1 style="font-size:26px;font-weight:800;color:#fff;margin-bottom:20px">' + esc(s.titolo) + '</h1>';
                if (s.punti && s.punti.length) {
                    s.punti.forEach((p: string) => {
                        html += '<div style="padding:8px 0;color:#d1d1e0;font-size:15px;line-height:1.6">' + esc(p) + '</div>';
                    });
                }
                html += '</div>';
        }

        container.innerHTML = html;
    }

    playCasoStudioAudio() {
        if (this.casoStudioAudio) {
            this.casoStudioAudio.pause();
            this.casoStudioAudio = null;
        }

        if (!this.casoStudioActive || this.casoStudioPaused) return;

        const s = this.casoStudioSlides[this.casoStudioCurrentSlide];
        if (!s || !s.audioFile) return;

        // L'audioFile potrebbe essere un path relativo (/assets/...) — preponi il baseUrl del server
        let audioUrl = s.audioFile;
        if (audioUrl.startsWith('/')) {
            const baseUrl = (environment.urlWeb || '/').replace(/\/$/, '');
            audioUrl = baseUrl + audioUrl;
        }

        const audio = new Audio(audioUrl);
        this.casoStudioAudio = audio;

        const indicator = document.getElementById('csAudioIndicator');

        audio.onplay = () => {
            if (indicator) indicator.innerHTML = '<i class="fas fa-volume-up"></i> <span style="animation:csPulse 1.5s ease-in-out infinite">In riproduzione...</span>';
        };
        audio.onended = () => {
            if (indicator) indicator.innerHTML = '<i class="fas fa-volume-up"></i> <span>Audio</span>';
            // Auto-advance e' gestito dal docente che invia slide sync
        };
        audio.onerror = () => {
            if (indicator) indicator.innerHTML = '<i class="fas fa-volume-mute" style="color:#565674"></i>';
        };

        audio.play().catch(() => {
            // Autoplay bloccato dal browser — prova con interazione utente
            console.warn('[CasoStudio] Autoplay audio bloccato, attesa interazione utente');
            if (indicator) indicator.innerHTML = '<i class="fas fa-volume-mute" style="color:#F64E60"></i> <span style="color:#F64E60;cursor:pointer" onclick="document.getElementById(\'csAudioIndicator\')?.dispatchEvent(new Event(\'click\'))">Clicca per audio</span>';

            const clickHandler = () => {
                if (this.casoStudioAudio && this.casoStudioActive) {
                    this.casoStudioAudio.play().catch(() => {});
                }
                document.removeEventListener('click', clickHandler);
            };
            document.addEventListener('click', clickHandler, { once: true });
        });
    }

    startCasoStudioPolling() {
        this.stopCasoStudioPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.casoStudioPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/casostudio-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;
                if (resp.active && resp.state) {
                    if (!self.casoStudioActive) {
                        // Late-join: ricostruisci lo stato dal server
                        try {
                            const content = JSON.parse(resp.state.content || '{}');
                            content.currentSlide = resp.state.currentSlide || 0;
                            content.presId = resp.state.presId;
                            content.presPartner = resp.state.presPartner;
                            self.showCasoStudioOverlay(content);
                        } catch (e) {}
                    } else {
                        // Aggiorna slide corrente se cambiata
                        const newSlide = resp.state.currentSlide;
                        if (typeof newSlide === 'number' && newSlide !== self.casoStudioCurrentSlide) {
                            self.casoStudioCurrentSlide = newSlide;
                            self.renderCasoStudioSlide();
                            self.playCasoStudioAudio();
                        }
                    }
                } else if (!resp.active && self.casoStudioActive) {
                    self.hideCasoStudioOverlay();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopCasoStudioPolling() {
        if (this.casoStudioPollingInterval) {
            clearInterval(this.casoStudioPollingInterval);
            this.casoStudioPollingInterval = null;
        }
    }

    // =========================================================================
    // FLASHCARD LIVE: sessione flashcard condivisa dal docente
    // =========================================================================

    handleFlashcardLiveSync(data: any) {
        console.log('[FlashcardLive] Sync ricevuto:', data.type);

        if (data.type === 'start' && data.flashcards) {
            this.showFlashcardOverlay(data);
        } else if (data.type === 'stop') {
            this.hideFlashcardOverlay();
        }
    }

    showFlashcardOverlay(data: any) {
        // Se già attivo, ignora
        if (this.flashcardLiveActive) return;

        const presId = data.presId || '';
        const presPartner = data.presPartner || 0;
        if (!presId || !presPartner) return;

        this.flashcardLiveActive = true;
        this.flashcardData = data.flashcards || [];
        this.flashcardTitolo = data.titolo || 'Flashcard';
        this.flashcardCurrentIdx = 0;

        // Rimuovi overlay precedente se esiste
        const old = document.getElementById('flashcardLiveOverlay');
        if (old) old.remove();

        // Inject CSS se non presente
        this.injectFlashcardLiveCSS();

        // Crea overlay con iframe al viewer_flashcard.php
        const overlay = document.createElement('div');
        overlay.id = 'flashcardLiveOverlay';
        overlay.className = 'fc-live-overlay active';

        const viewerUrl = (environment.urlWeb || '/') + 'pages/viewer_flashcard.php?id=' +
            encodeURIComponent(presId) + '&partner=' + presPartner + '&theme=dark&mode=live';

        overlay.innerHTML =
            '<div class="fc-live-topbar">' +
                '<div class="fc-live-topbar-left">' +
                    '<i class="fas fa-clone" style="color:#FFA800;margin-right:8px"></i>' +
                    '<span class="fc-live-topbar-title">' + this.escHtml(this.flashcardTitolo) + '</span>' +
                    '<span class="fc-live-badge">' + this.flashcardData.length + ' card</span>' +
                '</div>' +
                '<div style="display:flex;align-items:center;gap:8px">' +
                    '<span style="font-size:10px;color:rgba(255,255,255,.5)">Condiviso dal docente</span>' +
                '</div>' +
            '</div>' +
            '<div class="fc-live-stage">' +
                '<iframe id="fcLiveIframe" src="' + viewerUrl + '" ' +
                    'style="width:100%;height:100%;border:none;border-radius:12px" ' +
                    'allow="autoplay; fullscreen" allowfullscreen></iframe>' +
            '</div>';

        document.body.appendChild(overlay);

        // Muovi Jitsi nel PiP
        this.moveJitsiToPip();
    }

    hideFlashcardOverlay() {
        this.flashcardLiveActive = false;
        this.flashcardData = [];

        const overlay = document.getElementById('flashcardLiveOverlay');
        if (overlay) overlay.remove();

        // Ripristina Jitsi dalla PiP
        this.restoreJitsiFromPip();
    }

    injectFlashcardLiveCSS() {
        if (document.getElementById('fcLiveCSS')) return;
        const style = document.createElement('style');
        style.id = 'fcLiveCSS';
        style.textContent = `
            .fc-live-overlay {
                display:none;position:fixed;inset:0;z-index:9999;
                background:#0d0d1a;color:#fff;
                font-family:'Poppins','Segoe UI',-apple-system,sans-serif;
            }
            .fc-live-overlay.active {
                display:flex !important;flex-direction:column;
            }
            .fc-live-topbar {
                display:flex;align-items:center;justify-content:space-between;
                padding:10px 24px;background:rgba(0,0,0,.4);
                border-bottom:1px solid rgba(255,255,255,.08);flex-shrink:0;
            }
            .fc-live-topbar-left {
                display:flex;align-items:center;gap:6px;
            }
            .fc-live-topbar-title {
                font-size:14px;font-weight:700;color:#fff;
            }
            .fc-live-badge {
                font-size:10px;font-weight:600;
                background:rgba(255,168,0,.15);color:#FFA800;
                padding:2px 8px;border-radius:10px;margin-left:6px;
            }
            .fc-live-stage {
                flex:1;padding:16px;overflow:hidden;
            }
        `;
        document.head.appendChild(style);
    }

    startFlashcardPolling() {
        this.stopFlashcardPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.flashcardPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/flashcard-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;
                if (resp.active && resp.state) {
                    if (!self.flashcardLiveActive) {
                        // Late-join: ricostruisci stato dal server
                        try {
                            const content = JSON.parse(resp.state.content || '{}');
                            self.showFlashcardOverlay(content);
                        } catch (e) {}
                    }
                } else if (!resp.active && self.flashcardLiveActive) {
                    self.hideFlashcardOverlay();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopFlashcardPolling() {
        if (this.flashcardPollingInterval) {
            clearInterval(this.flashcardPollingInterval);
            this.flashcardPollingInterval = null;
        }
    }

    // =========================================================================
    // VIDEO ESTERNO LIVE: sessione video condivisa dal docente
    // =========================================================================

    handleVideoLiveSync(data: any) {
        console.log('[VideoLive] Sync ricevuto:', data.type);

        if (data.type === 'start' && data.url) {
            this.showVideoOverlay(data);
        } else if (data.type === 'stop') {
            this.hideVideoOverlay();
        } else if (data.type === 'pause') {
            this.videoLivePausePlay('pause');
        } else if (data.type === 'play') {
            this.videoLivePausePlay('play');
        } else if (data.type === 'seek' && data.seekTime !== undefined) {
            this.videoLiveSeek(data.seekTime);
        }
    }

    videoLiveSeek(seconds: number) {
        const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
        if (!iframe || !iframe.contentWindow) return;
        iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command', func: 'seekTo', args: [seconds, true]
        }), '*');
    }

    videoLivePausePlay(action: 'pause' | 'play') {
        const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
        if (!iframe || !iframe.contentWindow) return;
        const func = action === 'pause' ? 'pauseVideo' : 'playVideo';
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: '' }), '*');

        // Aggiorna indicatore nella topbar
        const statusEl = document.getElementById('videoLiveStatusLabel');
        if (statusEl) {
            if (action === 'pause') {
                statusEl.textContent = 'In pausa';
                statusEl.style.color = '#FFA800';
            } else {
                statusEl.textContent = 'Condiviso dal docente';
                statusEl.style.color = 'rgba(255,255,255,.5)';
            }
        }
    }

    /**
     * Attende che il player YT sia pronto, poi esegue seekTo al tempo indicato.
     * Doppio approccio: postMessage listener + fallback con timeout dopo onload.
     */
    videoLiveSeekOnReady(seekSeconds: number, shouldPause: boolean) {
        const self = this;
        let seekDone = false;

        const doSeek = () => {
            if (seekDone) return;
            seekDone = true;
            const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
            if (!iframe || !iframe.contentWindow) return;
            if (seekSeconds > 0) {
                iframe.contentWindow.postMessage(JSON.stringify({
                    event: 'command', func: 'seekTo', args: [seekSeconds, true]
                }), '*');
            }
            if (shouldPause) {
                setTimeout(() => self.videoLivePausePlay('pause'), 500);
            }
        };

        // Approccio 1: listener postMessage — attende playerState playing/buffering
        let attempts = 0;
        const seekInterval = setInterval(() => {
            attempts++;
            if (seekDone || attempts > 30 || !self.videoLiveActive) {
                clearInterval(seekInterval);
                return;
            }
            const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage('{"event":"listening"}', '*');
            }
        }, 500);

        const onMessage = (ev: MessageEvent) => {
            if (seekDone) return;
            try {
                const d = typeof ev.data === 'string' ? JSON.parse(ev.data) : ev.data;
                if (!d || d.event !== 'infoDelivery' || !d.info) return;
                if (d.info.playerState === 1 || d.info.playerState === 3) {
                    clearInterval(seekInterval);
                    window.removeEventListener('message', onMessage);
                    doSeek();
                }
            } catch (e) {}
        };
        window.addEventListener('message', onMessage);

        // Approccio 2: fallback — dopo che l'iframe ha fatto load + 3s, forza il seek
        const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
        if (iframe) {
            iframe.addEventListener('load', () => {
                setTimeout(() => {
                    if (!seekDone) {
                        clearInterval(seekInterval);
                        window.removeEventListener('message', onMessage);
                        doSeek();
                    }
                }, 3000);
            });
        }
        // Fallback assoluto: dopo 8 secondi
        setTimeout(() => {
            if (!seekDone) {
                clearInterval(seekInterval);
                window.removeEventListener('message', onMessage);
                doSeek();
            }
        }, 8000);
    }

    showVideoOverlay(data: any) {
        if (this.videoLiveActive) return;

        const url = data.url || '';
        const titolo = data.titolo || 'Video';
        const ytId = data.ytId || this.extractYoutubeId(url);

        if (!url) return;

        this.videoLiveActive = true;
        this.videoLiveUrl = url;
        this.videoLiveTitolo = titolo;

        // Rimuovi overlay esistente
        const existing = document.getElementById('videoLiveOverlay');
        if (existing) existing.remove();

        // Inject CSS se non presente
        this.injectVideoLiveCSS();

        // Crea overlay con video
        const overlay = document.createElement('div');
        overlay.id = 'videoLiveOverlay';
        overlay.className = 'video-live-overlay active';

        let videoHtml = '';
        const startTime = data.currentTime ? Math.floor(data.currentTime) : 0;
        const isPaused = data.paused || false;
        if (ytId) {
            // YouTube: embed senza controlli, solo audio toggle nella topbar
            videoHtml =
                '<div class="video-live-container">' +
                    '<iframe id="videoLiveIframe" ' +
                        'src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&controls=0&disablekb=1&fs=0&rel=0&modestbranding=1&iv_load_policy=3&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin) + '" ' +
                        'style="width:100%;height:100%;border:none;border-radius:12px;pointer-events:none" ' +
                        'allow="autoplay;encrypted-media" allowfullscreen></iframe>' +
                    '<div class="video-live-block-overlay"></div>' +
                '</div>';
        } else {
            // URL non-YouTube: mostra nel iframe senza controlli
            videoHtml = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:20px">' +
                '<i class="fas fa-video" style="font-size:48px;color:rgba(255,255,255,.3)"></i>' +
                '<div style="color:#fff;font-size:16px;font-weight:600;text-align:center">' + this.escHtml(titolo) + '</div>' +
                '<a href="' + this.escHtml(url) + '" target="_blank" style="padding:12px 28px;background:#FF0000;color:#fff;border-radius:12px;font-weight:700;text-decoration:none;font-size:14px">' +
                '<i class="fas fa-external-link-alt" style="margin-right:8px"></i>Apri Video</a></div>';
        }

        const muteHtml = ytId ?
            '<button id="videoLiveMuteBtn" class="video-live-mute-btn" title="Disattiva audio">' +
                '<svg class="vol-off" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>' +
                '<svg class="vol-on" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.08"/></svg>' +
            '</button>' : '';

        overlay.innerHTML =
            '<div class="video-live-topbar">' +
                '<div class="video-live-topbar-left">' +
                    '<i class="fas fa-video" style="color:#FF0000;margin-right:8px"></i>' +
                    '<span class="video-live-topbar-title">' + this.escHtml(titolo) + '</span>' +
                '</div>' +
                '<div style="display:flex;align-items:center;gap:10px">' +
                    '<span id="videoLiveStatusLabel" style="font-size:10px;color:rgba(255,255,255,.5)">Condiviso dal docente</span>' +
                    muteHtml +
                '</div>' +
            '</div>' +
            '<div class="video-live-stage">' + videoHtml + '</div>';

        document.body.appendChild(overlay);

        // Bind mute/unmute toggle per YouTube (audio ON per default)
        if (ytId) {
            const muteBtn = document.getElementById('videoLiveMuteBtn');
            const iframe = document.getElementById('videoLiveIframe') as HTMLIFrameElement;
            if (muteBtn && iframe) {
                let isMuted = false; // Audio ON per default
                muteBtn.addEventListener('click', () => {
                    if (!iframe.contentWindow) return;
                    if (isMuted) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
                        muteBtn.classList.remove('video-live-muted');
                        muteBtn.title = 'Disattiva audio';
                    } else {
                        iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        muteBtn.classList.add('video-live-muted');
                        muteBtn.title = 'Attiva audio';
                    }
                    isMuted = !isMuted;
                });
            }
        }

        // Allinea tempo e stato pausa per late-join corsisti
        if (ytId && (startTime > 0 || isPaused)) {
            this.videoLiveSeekOnReady(startTime, isPaused);
        }

        // Muovi Jitsi nel PiP
        this.moveJitsiToPip();
    }

    hideVideoOverlay() {
        this.videoLiveActive = false;
        this.videoLiveUrl = '';
        this.videoLiveTitolo = '';

        const overlay = document.getElementById('videoLiveOverlay');
        if (overlay) overlay.remove();

        // Ripristina Jitsi dalla PiP
        this.restoreJitsiFromPip();
    }

    injectVideoLiveCSS() {
        if (document.getElementById('videoLiveCSS')) return;
        const style = document.createElement('style');
        style.id = 'videoLiveCSS';
        style.textContent = `
            .video-live-overlay {
                display:none;position:fixed;inset:0;z-index:9999;
                background:#0d0d1a;color:#fff;
                font-family:'Poppins','Segoe UI',-apple-system,sans-serif;
            }
            .video-live-overlay.active {
                display:flex !important;flex-direction:column;
            }
            .video-live-topbar {
                display:flex;align-items:center;justify-content:space-between;
                padding:10px 24px;background:rgba(0,0,0,.4);
                border-bottom:1px solid rgba(255,255,255,.08);flex-shrink:0;
            }
            .video-live-topbar-left {
                display:flex;align-items:center;gap:6px;
            }
            .video-live-topbar-title {
                font-size:14px;font-weight:700;color:#fff;
            }
            .video-live-stage {
                flex:1;padding:16px;overflow:hidden;
            }
            .video-live-container {
                width:100%;height:100%;position:relative;border-radius:12px;overflow:hidden;
            }
            .video-live-block-overlay {
                position:absolute;inset:0;z-index:2;cursor:default;
            }
            .video-live-mute-btn {
                width:36px;height:36px;border-radius:50%;border:none;
                background:rgba(255,255,255,.12);
                color:#fff;cursor:pointer;
                display:flex;align-items:center;justify-content:center;
                transition:all .2s;flex-shrink:0;
            }
            .video-live-mute-btn:hover {
                background:rgba(255,255,255,.22);
            }
            .video-live-mute-btn .vol-on { display:block; }
            .video-live-mute-btn .vol-off { display:none; }
            .video-live-mute-btn.video-live-muted .vol-on { display:none; }
            .video-live-mute-btn.video-live-muted .vol-off { display:block; }
            .video-live-mute-btn.video-live-muted {
                background:rgba(255,0,0,.4);
            }
            .video-live-mute-btn.video-live-muted:hover {
                background:rgba(255,0,0,.55);
            }
        `;
        document.head.appendChild(style);
    }

    private extractYoutubeId(url: string): string {
        if (!url) return '';
        const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return m ? m[1] : '';
    }

    startVideoPolling() {
        this.stopVideoPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.videoPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/video-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;
                if (resp.active && resp.state) {
                    if (!self.videoLiveActive) {
                        // Late-join: ricostruisci stato dal server con currentTime calcolato dal server
                        try {
                            const content = JSON.parse(resp.state.content || '{}');
                            content.currentTime = resp.currentTime || 0;
                            content.paused = resp.paused || false;
                            self.showVideoOverlay(content);
                        } catch (e) {}
                    }
                } else if (!resp.active && self.videoLiveActive) {
                    self.hideVideoOverlay();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopVideoPolling() {
        if (this.videoPollingInterval) {
            clearInterval(this.videoPollingInterval);
            this.videoPollingInterval = null;
        }
    }

    // =========================================================================
    // PRESENTAZIONE INTEGRATA: viewer del corso condiviso dal docente
    // Corsisti vedono l'iframe del viewer_presentazione.php senza slave/mini.
    // Il docente controlla play/pause/avanti/indietro. Corsista solo audio toggle.
    // =========================================================================

    handlePresIntegrataSync(data: any) {
        console.log('[PresIntegrata] Sync ricevuto:', data.type);

        if (data.type === 'start') {
            this.showPresIntegrataOverlay(data);
        } else if (data.type === 'slide') {
            if (this.presIntegrataActive && typeof data.currentSlide === 'number') {
                this.presIntegrataCurrentSlide = data.currentSlide;
                this.navigatePresIntegrataSlide(data.currentSlide);
            }
        } else if (data.type === 'pause') {
            this.presIntegrataPaused = true;
            this.presIntegrataSendCommand('presenterPause');
        } else if (data.type === 'resume') {
            this.presIntegrataPaused = false;
            this.presIntegrataSendCommand('presenterResume');
        } else if (data.type === 'stop') {
            this.hidePresIntegrataOverlay();
        }
    }

    showPresIntegrataOverlay(data: any) {
        // Se già attivo, aggiorna solo la slide
        if (this.presIntegrataActive && document.getElementById('presIntegrataOverlay')) {
            if (typeof data.currentSlide === 'number' && data.currentSlide !== this.presIntegrataCurrentSlide) {
                this.presIntegrataCurrentSlide = data.currentSlide;
                this.navigatePresIntegrataSlide(data.currentSlide);
            }
            return;
        }

        // Nascondi scaletta se attiva
        (this as any)._scalettaWasActivePI = this.scalettaActive;
        if (this.scalettaActive) {
            const scalOv = document.getElementById('scalettaOverlay');
            if (scalOv) scalOv.style.display = 'none';
        }

        const old = document.getElementById('presIntegrataOverlay');
        if (old) old.remove();

        this.presIntegrataPresId = data.presId || '';
        this.presIntegrataPresPartner = data.presPartner || 0;
        this.presIntegrataTitolo = data.titolo || 'Presentazione';
        this.presIntegrataCurrentSlide = data.currentSlide || 0;
        this.presIntegrataTotalSlides = data.totalSlides || 0;
        this.presIntegrataPaused = !!(data.paused);
        this.presIntegrataActive = true;

        // Inietta CSS
        this.injectScalettaPresCSS();

        const overlay = document.createElement('div');
        overlay.id = 'presIntegrataOverlay';
        overlay.className = 'pres-overlay active';

        const baseUrl = environment.urlWeb || '/';
        let iframeSrc = baseUrl + 'pages/viewer_presentazione.php?id=' + encodeURIComponent(this.presIntegrataPresId) +
            '&partner=' + this.presIntegrataPresPartner + '&slave=1';
        if (this.presIntegrataCurrentSlide > 0) {
            iframeSrc += '&startSlide=' + this.presIntegrataCurrentSlide;
        }
        if (data.seekTime > 0) {
            iframeSrc += '&startSeek=' + (data.seekTime || 0);
        }

        overlay.innerHTML =
            '<div class="pres-topbar">' +
                '<div class="pres-topbar-left">' +
                    '<div style="display:flex;align-items:center;gap:8px">' +
                        '<div style="width:8px;height:8px;border-radius:50%;background:#3699FF;animation:csPulse 1.5s ease-in-out infinite"></div>' +
                        '<div class="pres-topbar-title" style="color:#74b9ff"><i class="fas fa-tv" style="margin-right:6px"></i>Presentazione</div>' +
                    '</div>' +
                '</div>' +
                '<div style="display:flex;align-items:center;gap:12px">' +
                    '<button id="piMuteBtn" style="background:transparent;border:1px solid rgba(54,153,255,.3);color:#3699FF;padding:4px 10px;border-radius:6px;font-size:10px;cursor:pointer;font-weight:600" title="Attiva/Disattiva audio">' +
                        '<i class="fas fa-volume-up" id="piMuteIcon"></i> <span id="piMuteLabel">Audio</span>' +
                    '</button>' +
                    '<div class="pres-counter" id="piCounter">' + ((this.presIntegrataCurrentSlide || 0) + 1) + ' / ' + (this.presIntegrataTotalSlides || '?') + '</div>' +
                '</div>' +
            '</div>' +
            '<div style="flex:1;position:relative;overflow:hidden">' +
                '<iframe id="presIntegrataIframe" src="' + iframeSrc + '" allow="autoplay" style="width:100%;height:100%;border:none"></iframe>' +
            '</div>';

        // Inject pulse animation if not present
        if (!document.getElementById('csPulseCSS')) {
            const pulseStyle = document.createElement('style');
            pulseStyle.id = 'csPulseCSS';
            pulseStyle.textContent = '@keyframes csPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.4;transform:scale(.7)}}';
            document.head.appendChild(pulseStyle);
        }

        document.body.appendChild(overlay);

        // Bind mute toggle
        const muteBtn = document.getElementById('piMuteBtn');
        if (muteBtn) {
            let isMuted = false;
            muteBtn.addEventListener('click', () => {
                isMuted = !isMuted;
                this.presIntegrataSendCommand(isMuted ? 'presenterMute' : 'presenterUnmute');
                const icon = document.getElementById('piMuteIcon');
                const label = document.getElementById('piMuteLabel');
                if (icon) icon.className = isMuted ? 'fas fa-volume-mute' : 'fas fa-volume-up';
                if (label) label.textContent = isMuted ? 'Muto' : 'Audio';
                muteBtn.style.borderColor = isMuted ? 'rgba(246,78,96,.4)' : 'rgba(54,153,255,.3)';
                muteBtn.style.color = isMuted ? '#F64E60' : '#3699FF';
            });
        }

        // Salva riferimento iframe
        const iframe = document.getElementById('presIntegrataIframe') as HTMLIFrameElement;
        this.presIntegrataIframe = iframe;

        // Sposta Jitsi in PiP
        this.moveJitsiToPip();

        // Listener per slideChange e presenterReady dall'iframe
        const self = this;
        let piAudioStarted = false;
        window.addEventListener('message', function piMsgHandler(event) {
            if (!self.presIntegrataActive) {
                window.removeEventListener('message', piMsgHandler);
                return;
            }
            try {
                const msg = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                if (msg && msg.type === 'presenterSlideChange') {
                    self.presIntegrataCurrentSlide = msg.slideIndex || 0;
                    const counter = document.getElementById('piCounter');
                    if (counter) counter.textContent = (self.presIntegrataCurrentSlide + 1) + ' / ' + self.presIntegrataTotalSlides;
                } else if (msg && msg.type === 'presenterReady') {
                    self.presIntegrataTotalSlides = msg.totalSlides || self.presIntegrataTotalSlides;
                    const counter = document.getElementById('piCounter');
                    if (counter) counter.textContent = (self.presIntegrataCurrentSlide + 1) + ' / ' + self.presIntegrataTotalSlides;

                    // Il viewer è pronto — avvia o metti in pausa l'audio
                    if (!piAudioStarted) {
                        piAudioStarted = true;
                        setTimeout(() => {
                            if (self.presIntegrataPaused) {
                                self.presIntegrataSendCommand('presenterPause');
                            } else {
                                // Avvia riproduzione audio — il viewer in slave mode non parte da solo
                                self.presIntegrataSendCommand('presenterResume');
                            }
                        }, 300);
                    }
                }
            } catch (e) {}
        });
    }

    hidePresIntegrataOverlay() {
        this.presIntegrataActive = false;
        this.presIntegrataPaused = false;
        this.presIntegrataIframe = null;
        this.presIntegrataPresId = '';

        const overlay = document.getElementById('presIntegrataOverlay');
        if (overlay) overlay.remove();

        // Ripristina scaletta se era attiva
        if ((this as any)._scalettaWasActivePI && this.scalettaActive) {
            const scalOv = document.getElementById('scalettaOverlay');
            if (scalOv) {
                scalOv.style.display = '';
                return;
            }
        }

        this.restoreJitsiFromPip();
    }

    navigatePresIntegrataSlide(slideIndex: number) {
        if (!this.presIntegrataIframe || !this.presIntegrataIframe.contentWindow) return;

        // Debounce: ignora duplicati per la stessa slide entro 800ms
        // (evita doppio trigger DataChannel + polling che causa reload audio)
        const now = Date.now();
        if ((this as any)._piLastNavSlide === slideIndex && now - ((this as any)._piLastNavTs || 0) < 800) {
            return;
        }
        (this as any)._piLastNavSlide = slideIndex;
        (this as any)._piLastNavTs = now;

        try {
            const win = this.presIntegrataIframe.contentWindow as any;
            if (win._presenterControl) {
                win._presenterControl.goToSlide(slideIndex);
            } else {
                this.presIntegrataIframe.contentWindow.postMessage(JSON.stringify({
                    command: 'presenterGoToSlide', slideIndex: slideIndex
                }), '*');
            }
        } catch (e) {
            this.presIntegrataIframe.contentWindow.postMessage(JSON.stringify({
                command: 'presenterGoToSlide', slideIndex: slideIndex
            }), '*');
        }
        const counter = document.getElementById('piCounter');
        if (counter) counter.textContent = (slideIndex + 1) + ' / ' + this.presIntegrataTotalSlides;
    }

    presIntegrataSendCommand(command: string) {
        if (!this.presIntegrataIframe || !this.presIntegrataIframe.contentWindow) return;
        try {
            const win = this.presIntegrataIframe.contentWindow as any;
            if (win._presenterControl) {
                if (command === 'presenterPause') win._presenterControl.pause();
                else if (command === 'presenterResume') win._presenterControl.resume();
                else if (command === 'presenterMute') win._presenterControl.mute();
                else if (command === 'presenterUnmute') win._presenterControl.unmute();
            } else {
                this.presIntegrataIframe.contentWindow.postMessage(JSON.stringify({ command: command }), '*');
            }
        } catch (e) {
            this.presIntegrataIframe.contentWindow.postMessage(JSON.stringify({ command: command }), '*');
        }
    }

    startPresIntegrataPolling() {
        this.stopPresIntegrataPolling();
        const self = this;
        const baseUrl = environment.urlWeb || '/';

        this.presIntegrataPollingInterval = setInterval(() => {
            if (!self.isJoined || !self.idCorsoSvolgimento) return;

            const formData = new FormData();
            formData.append('idCorsoSvolgimento', self.idCorsoSvolgimento);

            fetch(baseUrl + 'api/presintegrata-state.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                if (!resp.success) return;
                if (resp.active && resp.state) {
                    if (!self.presIntegrataActive) {
                        // Late-join: ricostruisci stato dal server
                        try {
                            const st = resp.state;
                            const serverTs = parseInt(st.ts) || 0;
                            const nowTs = Math.floor(Date.now() / 1000);
                            const audioTime = parseFloat(st.audioTime) || 0;
                            const seekTime = st.paused ? audioTime : audioTime + (nowTs - serverTs);

                            self.showPresIntegrataOverlay({
                                presId: st.presId,
                                presPartner: st.presPartner,
                                titolo: st.titolo || 'Presentazione',
                                currentSlide: parseInt(st.currentSlide) || 0,
                                totalSlides: parseInt(st.totalSlides) || 0,
                                paused: !!(parseInt(st.paused)),
                                seekTime: seekTime
                            });
                        } catch (e) {}
                    } else {
                        // Aggiorna slide se cambiata
                        const newSlide = parseInt(resp.state.currentSlide);
                        if (typeof newSlide === 'number' && newSlide !== self.presIntegrataCurrentSlide) {
                            self.presIntegrataCurrentSlide = newSlide;
                            self.navigatePresIntegrataSlide(newSlide);
                        }
                        // Sync pausa
                        const isPaused = !!(parseInt(resp.state.paused));
                        if (isPaused !== self.presIntegrataPaused) {
                            self.presIntegrataPaused = isPaused;
                            self.presIntegrataSendCommand(isPaused ? 'presenterPause' : 'presenterResume');
                        }
                    }
                } else if (!resp.active && self.presIntegrataActive) {
                    self.hidePresIntegrataOverlay();
                }
            })
            .catch(() => {});
        }, 5000);
    }

    stopPresIntegrataPolling() {
        if (this.presIntegrataPollingInterval) {
            clearInterval(this.presIntegrataPollingInterval);
            this.presIntegrataPollingInterval = null;
        }
    }

    // Flag anti-doppio-scatto per salvaTimeOut a fine evento.
    private _fineEventoHandled: boolean = false;
    // Timer puntuale di uscita programmato al momento esatto di fine lezione.
    // Vedi commento in startAccessoPolling per il razionale (zero polling aggiuntivo).
    private _fineEventoTimeout: any = null;
    // Ultimo fineUfficiale conosciuto: se cambia (docente aggiorna durata) → riprogramma.
    private _fineUfficialeCached: string | null = null;

    startAccessoPolling() {
        this.stopAccessoPolling();
        this._fineEventoHandled = false;
        this._fineUfficialeCached = null;
        if (this._fineEventoTimeout) { clearTimeout(this._fineEventoTimeout); this._fineEventoTimeout = null; }
        const baseUrl = environment.urlWeb || '/';
        const runPoll = () => {
            if (!this.idCorsista || !this.idCorsoSvolgimento) {
                this.accessoPollingInterval = setTimeout(runPoll, 15000);
                return;
            }
            const formData = new FormData();
            formData.append('idCorsista', this.idCorsista);
            formData.append('idCorsoSvolgimento', this.idCorsoSvolgimento);
            fetch(baseUrl + 'api/check-accesso-bloccato.php', {
                method: 'POST',
                body: formData
            })
            .then(r => r.json())
            .then(resp => {
                // FINE LEZIONE AUTHORITATIVA (server-side): il server dice quando
                // finisce (data_ora + durata) e il client programma UN SINGOLO
                // setTimeout puntuale a quell'orario esatto.
                //
                // PERCHE' NON polling accelerato negli ultimi 60s:
                // con migliaia di utenti, polling a 2s = migliaia di RPS. Un
                // setTimeout unico costa 0 sul server e ha precisione ms in
                // foreground. In background il browser throttla il setTimeout,
                // MA il server clamp (function_primary.php::timeOutAula) limita
                // il DB a fine_ufficiale esatta → dati corretti anche in
                // scenario worst case.
                //
                // Se in un polling successivo fineUfficiale cambia (docente
                // aggiorna durata), il setTimeout viene riprogrammato.
                if (resp.eventoTerminato == 1 && !this._fineEventoHandled) {
                    this._fineEventoHandled = true;
                    console.log('[fine-evento] server dice: terminato -> salvaTimeOut istantaneo');
                    this.stopAccessoPolling();
                    if (this.isJoined) { this.salvaTimeOut(); }
                    return;
                }
                // Programma / riprogramma il timeout puntuale se fineUfficiale e' cambiato
                if (resp.fineUfficiale && resp.serverNow && !this._fineEventoHandled) {
                    if (resp.fineUfficiale !== this._fineUfficialeCached) {
                        this._fineUfficialeCached = resp.fineUfficiale;
                        if (this._fineEventoTimeout) { clearTimeout(this._fineEventoTimeout); this._fineEventoTimeout = null; }
                        const secAllaFine = typeof resp.secondiAllaFine === 'number' ? resp.secondiAllaFine : 999999;
                        if (secAllaFine > 0) {
                            const msAllaFine = secAllaFine * 1000;
                            console.log('[fine-evento] programmo uscita esatta in', secAllaFine, 's (fine:', resp.fineUfficiale, ')');
                            this._fineEventoTimeout = setTimeout(() => {
                                if (this._fineEventoHandled) return;
                                this._fineEventoHandled = true;
                                console.log('[fine-evento] timeout scattato -> salvaTimeOut');
                                this.stopAccessoPolling();
                                if (this.isJoined) { this.salvaTimeOut(); }
                            }, msAllaFine);
                        }
                    }
                }
                if (resp.bloccato == 1) {
                    this.corsistaNonAccettato();
                }
                // Simulcast inverso: se eravamo in simulcast ma simulcast_room è stato azzerato, torna all'aula originale
                if (!resp.simulcast_room && this._isSimulcast && this._originalRoom && this.room !== this._originalRoom) {
                    this._isSimulcast = false;
                    this._simulcastRedirecting = true;
                    var origRoom = this._originalRoom;

                    var overlay = document.createElement('div');
                    overlay.id = 'simulcast-overlay';
                    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;background:rgba(0,0,0,0.92);display:flex;flex-direction:column;align-items:center;justify-content:center;';
                    overlay.innerHTML = '<div style="text-align:center;color:#fff;font-family:Poppins,sans-serif;">' +
                        '<div style="width:50px;height:50px;border:3px solid rgba(255,255,255,0.2);border-top-color:#1BC5BD;border-radius:50%;animation:spin 0.8s linear infinite;margin:0 auto 20px;"></div>' +
                        '<div style="font-size:18px;font-weight:600;margin-bottom:8px;">Ritorno in aula</div>' +
                        '<div style="font-size:13px;color:rgba(255,255,255,0.6);">Attendi qualche istante...</div>' +
                        '</div>' +
                        '<style>@keyframes spin{to{transform:rotate(360deg)}}</style>';
                    document.body.appendChild(overlay);

                    try { this.api.dispose(); } catch(e) {}
                    this.room = origRoom;
                    this.options.roomName = origRoom;
                    this.api = new (window as any).JitsiMeetExternalAPI(
                        this.domain + this.tokenMeet + '/',
                        this.options
                    );
                    this._simulcastRedirecting = false;
                    this.agganciaSentinella();
                    this.initEvents();

                    this.api.addListener('videoConferenceJoined', () => {
                        var el = document.getElementById('simulcast-overlay');
                        if (el) el.remove();
                    });
                    setTimeout(() => {
                        var el = document.getElementById('simulcast-overlay');
                        if (el) el.remove();
                    }, 8000);
                    return;
                }
                // Simulcast: se simulcast_room e' diverso dalla stanza attuale, riconnetti
                if (resp.simulcast_room && resp.simulcast_room !== this.room) {
                    this._isSimulcast = true;
                    this._simulcastRedirecting = true;
                    this._simulcastSubject = this.room + ' \u2014 Multi aule';
                    var newRoom = resp.simulcast_room;

                    // Overlay di transizione
                    var overlay = document.createElement('div');
                    overlay.id = 'simulcast-overlay';
                    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;background:rgba(0,0,0,0.92);display:flex;flex-direction:column;align-items:center;justify-content:center;';
                    overlay.innerHTML = '<div style="text-align:center;color:#fff;font-family:Poppins,sans-serif;">' +
                        '<div style="width:50px;height:50px;border:3px solid rgba(255,255,255,0.2);border-top-color:#1BC5BD;border-radius:50%;animation:spin 0.8s linear infinite;margin:0 auto 20px;"></div>' +
                        '<div style="font-size:18px;font-weight:600;margin-bottom:8px;">Spostamento in aula condivisa</div>' +
                        '<div style="font-size:13px;color:rgba(255,255,255,0.6);">Attendi qualche istante...</div>' +
                        '</div>' +
                        '<style>@keyframes spin{to{transform:rotate(360deg)}}</style>';
                    document.body.appendChild(overlay);

                    try { this.api.dispose(); } catch(e) {}
                    this.room = newRoom;
                    this.options.roomName = newRoom;
                    this.api = new (window as any).JitsiMeetExternalAPI(
                        this.domain + this.tokenMeet + '/',
                        this.options
                    );
                    this._simulcastRedirecting = false;
                    this.agganciaSentinella();
                    this.initEvents();

                    // Rimuovi overlay quando Jitsi e' pronto
                    this.api.addListener('videoConferenceJoined', () => {
                        var el = document.getElementById('simulcast-overlay');
                        if (el) el.remove();
                    });
                    // Fallback: rimuovi dopo 8 secondi comunque
                    setTimeout(() => {
                        var el = document.getElementById('simulcast-overlay');
                        if (el) el.remove();
                    }, 8000);
                }

                // Polling costante ogni 15s (comportamento storico invariato).
                // La precisione all'orario di fine e' garantita dal setTimeout
                // puntuale (_fineEventoTimeout), NON dall'intervallo di polling.
                // Cosi' zero pressione aggiuntiva sul server anche con migliaia
                // di corsisti online.
                this.accessoPollingInterval = setTimeout(runPoll, 15000);
            })
            .catch(err => {
                console.error('[AccessoPoll] error:', err);
                this.accessoPollingInterval = setTimeout(runPoll, 15000);
            });
        };
        this.accessoPollingInterval = setTimeout(runPoll, 15000);
    }

    stopAccessoPolling() {
        if (this.accessoPollingInterval) {
            clearTimeout(this.accessoPollingInterval);
            clearInterval(this.accessoPollingInterval);
            this.accessoPollingInterval = null;
        }
        if (this._fineEventoTimeout) {
            clearTimeout(this._fineEventoTimeout);
            this._fineEventoTimeout = null;
        }
    }

}
